var As = Object.defineProperty, fs = Object.defineProperties;
var gs = Object.getOwnPropertyDescriptors;
var fi = Object.getOwnPropertySymbols;
var ps = Object.prototype.hasOwnProperty, ws = Object.prototype.propertyIsEnumerable;
var gi = (i) => {
  throw TypeError(i);
};
var Mt = (i, e, t) => e in i ? As(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, g = (i, e) => {
  for (var t in e || (e = {}))
    ps.call(e, t) && Mt(i, t, e[t]);
  if (fi)
    for (var t of fi(e))
      ws.call(e, t) && Mt(i, t, e[t]);
  return i;
}, L = (i, e) => fs(i, gs(e));
var s = (i, e, t) => Mt(i, typeof e != "symbol" ? e + "" : e, t), Ut = (i, e, t) => e.has(i) || gi("Cannot " + t);
var u = (i, e, t) => (Ut(i, e, "read from private field"), t ? t.call(i) : e.get(i)), R = (i, e, t) => e.has(i) ? gi("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(i) : e.set(i, t), _ = (i, e, t, n) => (Ut(i, e, "write to private field"), n ? n.call(i, t) : e.set(i, t), t), W = (i, e, t) => (Ut(i, e, "access private method"), t);
var _t = (i, e, t, n) => ({
  set _(r) {
    _(i, e, r, t);
  },
  get _() {
    return u(i, e, n);
  }
});
var I = (i, e, t) => new Promise((n, r) => {
  var o = (d) => {
    try {
      c(t.next(d));
    } catch (h) {
      r(h);
    }
  }, a = (d) => {
    try {
      c(t.throw(d));
    } catch (h) {
      r(h);
    }
  }, c = (d) => d.done ? n(d.value) : Promise.resolve(d.value).then(o, a);
  c((t = t.apply(i, e)).next());
});
import { E as pe } from "./BTxJOjm9.js";
import { p as Ss, A as vs, t as bs, i as Es } from "./B7jz034g.js";
class pi {
  constructor(e) {
    s(this, "maxSize", 0);
    s(this, "size", 0);
    s(this, "buffers", []);
    s(this, "_borrowedBuffers", 0);
    s(this, "get", (e) => {
      const t = this.buffers.shift();
      return this._borrowedBuffers++, this.size < e || !t ? (this.buffers = [], this.size = e, new ArrayBuffer(e)) : t;
    });
    s(this, "reclaim", (e) => {
      this._borrowedBuffers = Math.max(0, this._borrowedBuffers - 1), !(e.byteLength < this.size) && (this.buffers.length >= this.maxSize || this.buffers.push(e));
    });
    this.maxSize = e;
  }
  /**
   * The size of the pooled array buffers
   */
  get bufferSize() {
    return this.size;
  }
  /**
   * The number of array buffers pooled
   */
  get poolSize() {
    return this.buffers.length;
  }
  /**
   * The number of borrowed array buffers. Effectively, calls to get() - calls to reclaim().
   */
  get borrowedBuffers() {
    return this._borrowedBuffers;
  }
}
class X {
  constructor(e = 50) {
    s(this, "maxSize");
    s(this, "values", []);
    s(this, "push", (e) => {
      this.isFull() && this.pop(), this.values.push(e);
    });
    s(this, "clear", () => void (this.values = []));
    s(this, "pop", () => this.values.shift());
    s(this, "peekFirst", () => this.values[0]);
    s(this, "peekLast", () => this.values[this.values.length - 1]);
    s(this, "isFull", () => this.values.length >= this.maxSize);
    s(this, "isEmpty", () => this.values.length === 0);
    s(this, "items", () => this.values);
    s(this, "filterPop", (e) => {
      for (; this.peekFirst() && !e(this.peekFirst()); )
        this.pop();
    });
    this.maxSize = e;
  }
}
class Wi {
  constructor(e, t = 0) {
    s(this, "buffer");
    s(this, "bytes");
    s(this, "bitOffset");
    s(this, "peekBit", () => this.getBit(this.bytes, this.bitOffset));
    s(this, "readBit", () => {
      const e = this.peekBit();
      return this.bitOffset++, e;
    });
    s(this, "readBits", (e) => {
      let t = 0;
      for (let n = 0; n < e; n++)
        t = t << 1 | (this.getBit(this.bytes, this.bitOffset++) ? 1 : 0);
      return t;
    });
    s(this, "readSignedExpGolomb", () => {
      const e = this.readUnsignedExpGolomb();
      return e & 1 ? (e + 1) / 2 : -(e / 2);
    });
    s(this, "readUnsignedExpGolomb", () => {
      let e = 0;
      for (; this.getBit(this.bytes, this.bitOffset++) === 0; )
        e++;
      let t = 1 << e;
      for (let n = e - 1; n >= 0; n--)
        t |= this.getBit(this.bytes, this.bitOffset++) << n;
      return t - 1;
    });
    // Safety: We assume that base has enough elements
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    s(this, "getBit", (e, t) => e[t >> 3] >> 7 - (t & 7) & 1);
    this.buffer = e, this.bytes = new Uint8Array(this.buffer), this.bitOffset = t;
  }
}
function We() {
  const i = self.MediaSource, e = self.ManagedMediaSource;
  return i != null ? i : e;
}
const ys = new RegExp(
  "(android|bbd+|meego).+mobile|avantgo|bada/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/",
  "i"
), q = navigator.userAgent.toLowerCase(), Ts = ys.test(q), Cs = () => {
  const i = document.createElement("video");
  return i.canPlayType("application/vnd.apple.mpegURL") !== "" || i.canPlayType("audio/mpegurl") !== "";
}, Is = () => {
  try {
    if (typeof WebAssembly == "object" && typeof WebAssembly.instantiate == "function") {
      const i = new WebAssembly.Module(Uint8Array.of(0, 97, 115, 109, 1, 0, 0, 0));
      if (i instanceof WebAssembly.Module) return new WebAssembly.Instance(i) instanceof WebAssembly.Instance;
    }
  } catch (i) {
    return !1;
  }
  return !1;
}, Bs = () => q.indexOf("CrKey") !== -1, ji = () => navigator.platform === "MacIntel" && navigator.maxTouchPoints === 0, Pt = () => navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1, Rs = () => q.indexOf("iphone") >= 0 && q.indexOf("like iphone") < 0 || q.indexOf("ipad") >= 0 && q.indexOf("like ipad") < 0 || q.indexOf("ipod") >= 0 && q.indexOf("like ipod") < 0 || Pt(), ks = () => {
  var i, e;
  return Pt() ? !1 : (e = (i = We()) == null ? void 0 : i.isTypeSupported('audio/mp4; codecs="opus"')) != null ? e : !1;
}, ko = () => "ontouchstart" in window || navigator.maxTouchPoints > 0;
function Ps() {
  var i, e;
  if (/(iPhone|iPod|iPad)/i.test(q))
    return (e = (i = q == null ? void 0 : q.match(/OS [\d_]+/i)) == null ? void 0 : i[0]) == null ? void 0 : e.substring(3).split("_").map((t) => parseInt(t))[0];
}
const xs = () => {
  var t;
  const i = !!We();
  let e = !1;
  return i && (e = ks()), {
    isMobile: Ts,
    supportsMp4Opus: e,
    supportsMediaSource: i,
    supportsHls: Cs(),
    supportsWebAssembly: Is(),
    platform: {
      iosVersion: (t = Ps()) != null ? t : Number.MAX_SAFE_INTEGER,
      isIpadOS: Pt(),
      isMacOS: ji(),
      isIOS: Rs()
    }
  };
}, Ls = (i, e, t) => {
  let n = 0;
  for (let r = e; r <= t; r++)
    if (r === e) {
      const o = i[r];
      n += o & 127, o & 128 && (n -= 128);
    } else
      n = n * 256 + i[r];
  return n;
};
class Ms {
  constructor(e = 100, t = 100) {
    s(this, "resizeSteps");
    s(this, "internalBuffer");
    s(this, "view");
    s(this, "uint8");
    s(this, "_position", 0);
    s(this, "_end", 0);
    this.resizeSteps = t, this.internalBuffer = new ArrayBuffer(e), this.view = new DataView(this.internalBuffer), this.uint8 = new Uint8Array(this.internalBuffer);
  }
  position() {
    return this._position;
  }
  seek(e) {
    this._position = Math.max(0, Math.min(this._end, e));
  }
  seekToEnd() {
    this._position = this._end;
  }
  writeUint8(e) {
    this.writeAndMove(e, 1);
  }
  writeUint16(e) {
    this.writeAndMove(e, 2);
  }
  writeUint24(e) {
    this.writeAndMove(e, 3);
  }
  writeUint32(e) {
    this.writeAndMove(e, 4);
  }
  writeUint32At(e, t) {
    this.view.setUint32(e, t);
  }
  writeBytes(e) {
    this.resizeIfNeeded(this.position() + e.byteLength), this.uint8.set(e, this.position()), this._position += e.byteLength, this._end = Math.max(this._end, this._position);
  }
  buffer() {
    return this.internalBuffer.slice(0, this._end);
  }
  write(e, t) {
    switch (this.resizeIfNeeded(this.position() + t), t) {
      case 1:
        this.view.setUint8(this.position(), e);
        break;
      case 2:
        this.view.setUint16(this.position(), e);
        break;
      case 3:
        this.view.setUint8(this.position(), e >> 16 & 255), this.view.setUint8(this.position() + 1, e >> 8 & 255), this.view.setUint8(this.position() + 2, e & 255);
        break;
      case 4:
        this.view.setUint32(this.position(), e);
        break;
    }
  }
  writeAndMove(e, t) {
    this.write(e, t), this._position += t, this._end = Math.max(this._end, this._position);
  }
  resizeIfNeeded(e) {
    if (e > this.internalBuffer.byteLength) {
      const t = new ArrayBuffer(e + this.resizeSteps), n = new Uint8Array(t);
      n.set(this.uint8), this.internalBuffer = t, this.view = new DataView(this.internalBuffer), this.uint8 = n;
    }
  }
}
class Re {
  constructor(e, t, n) {
    s(this, "onSuccess");
    s(this, "onError");
    s(this, "doExecute");
    this.doExecute = e, this.onSuccess = t, this.onError = n;
  }
  execute(e) {
    try {
      this.doExecute(e), this.onSuccess();
    } catch (t) {
      this.onError(t);
    }
  }
}
const et = (i) => i.reduce((e, t) => e + t, 0) / i.length, xe = (i) => ({
  last: i[i.length - 1] || 0,
  average: i.length === 0 ? 0 : et(i),
  max: i.length === 0 ? 0 : Math.max(...i),
  min: i.length === 0 ? 0 : Math.min(...i)
}), Us = (i) => {
  let e = 0, t = 0, n = 0, r = 0, o = 0;
  for (let h = 0; h < i.length; h++) {
    const { x: l, y: m } = i[h];
    e += l, t += m, n += l * m, r += l * l, o += m * m;
  }
  const a = (i.length * n - e * t) / (i.length * r - e * e), c = (t - a * e) / i.length, d = Math.pow(
    (i.length * n - e * t) / Math.sqrt((i.length * r - e * e) * (i.length * o - t * t)),
    2
  );
  return { slope: a, intercept: c, r2: d, predict: (h) => a * (i.length + h) + c };
};
class _s {
  constructor(e = 10) {
    s(this, "rates");
    s(this, "_total", 0);
    s(this, "accumulatedValues", 0);
    s(this, "lastTickTime", Date.now());
    s(this, "add", (e) => {
      this.accumulatedValues += e, this._total += e;
    });
    s(this, "tick", () => {
      const e = this.accumulatedValues / ((Date.now() - this.lastTickTime) / 1e3);
      this.rates.push(e), this.accumulatedValues = 0, this.lastTickTime = Date.now();
    });
    this.rates = new X(e);
  }
  get total() {
    return this._total;
  }
  get average() {
    return this.rates.isEmpty() ? 0 : et(this.rates.items());
  }
}
const Be = (i, e) => {
  if (i === e) return !0;
  if (i == null || typeof i != "object" || e == null || typeof e != "object") return !1;
  let t = 0, n = 0;
  for (const r in i) t += 1;
  for (const r in e)
    if (n += 1, !(r in i) || !Be(i[r], e[r])) return !1;
  return t == n;
}, wi = ["off", "error", "warn", "info", "debug", "trace"], Ds = {
  ERROR: "error",
  WARN: "warn",
  INFO: "info",
  DEBUG: "debug",
  TRACE: "trace",
  OFF: "off"
};
var be, Ze, Ee, Fe, Ne;
const he = class he {
  constructor({ context: e, logLevel: t, debug: n }) {
    R(this, be, /* @__PURE__ */ new Map());
    R(this, Ze, "");
    R(this, Ee, !1);
    R(this, Fe, "off");
    s(this, "trace", (...e) => {
    });
    s(this, "debug", (...e) => {
    });
    s(this, "info", (...e) => {
    });
    s(this, "warn", (...e) => {
    });
    s(this, "error", (...e) => {
    });
    s(this, "table", (...e) => {
    });
    s(this, "count", (...e) => {
    });
    _(this, Ze, e), _(this, Fe, t), _(this, Ee, n || !1), this.setLevel(t), this.setDebug(u(this, Ee));
  }
  setDebug(e) {
    _(this, Ee, e);
    for (const [t, n] of u(this, be))
      n.setDebug(e);
    e ? (this.table = console.table.bind(console), this.count = console.count.bind(console)) : (this.table = () => {
    }, this.count = () => {
    });
  }
  setLevel(e) {
    _(this, Fe, e);
    for (const [n, r] of u(this, be))
      r.setLevel(e);
    const t = wi.indexOf(e);
    for (const [n, r] of wi.entries())
      r !== "off" && (n <= t ? this[r] = console[r].bind(
        console,
        "%c%s %c%s",
        "font-weight:bold;",
        r.toUpperCase(),
        "font-weight:normal;",
        u(this, Ze)
      ) : this[r] = () => {
      });
  }
  createContext(e) {
    const t = u(this, be).get(e);
    if (!t) {
      const n = new he({ context: `${e}`, logLevel: u(this, Fe), debug: u(this, Ee) });
      return u(this, be).set(e, n), n;
    }
    return t;
  }
  static get() {
    return u(he, Ne) || _(he, Ne, new he({ context: "Vindral", logLevel: "off" })), u(he, Ne);
  }
};
be = new WeakMap(), Ze = new WeakMap(), Ee = new WeakMap(), Fe = new WeakMap(), Ne = new WeakMap(), R(he, Ne);
let Ht = he;
const ce = () => {
}, Si = (i, e) => {
  const t = g({}, i);
  return typeof t != "object" || e.forEach((n) => {
    delete t[n];
  }), t;
}, Se = (i, e = Date.now()) => {
  const t = i.length;
  if (t > 0) {
    const n = t - 1, r = i[n];
    r.end || (r.end = e);
  }
}, ke = (i, e = Date.now()) => {
  Se(i), i.push({ start: e });
}, Pe = (i) => i.reduce((e, t) => {
  var n;
  return e + (((n = t.end) != null ? n : Date.now()) - t.start);
}, 0), vi = (i, e, t = Date.now()) => i.reduce((n, r) => {
  var c;
  const o = Math.max(t - e, r.start), a = (c = r.end) != null ? c : t;
  return Math.max(0, a - o) + n;
}, 0), ut = class ut {
  constructor() {
    s(this, "pendingTimeouts", /* @__PURE__ */ new Set());
    s(this, "pendingIntervals", /* @__PURE__ */ new Set());
    s(this, "clearTimeout", (e) => {
      this.pendingTimeouts.delete(e) && window.clearTimeout(e);
    });
    s(this, "clearInterval", (e) => {
      this.pendingIntervals.delete(e) && window.clearInterval(e);
    });
    s(this, "setTimeout", (e, t, ...n) => {
      const r = window.setTimeout(() => {
        e(...n), this.clearTimeout(r);
      }, t);
      return this.pendingTimeouts.add(r), r;
    });
    s(this, "setInterval", (e, t, ...n) => {
      const r = window.setInterval(() => {
        e(...n);
      }, t);
      return this.pendingIntervals.add(r), r;
    });
    s(this, "unload", () => {
      this.pendingIntervals.forEach(this.clearInterval), this.pendingTimeouts.forEach(this.clearTimeout);
    });
  }
};
s(ut, "create", () => new ut());
let N = ut;
const bi = () => {
  const i = [...Array(256).keys()].map((t) => t.toString(16).padStart(2, "0")), e = crypto.getRandomValues(new Uint8Array(16));
  return e[6] = e[6] & 15 | 64, e[8] = e[8] & 63 | 128, [...e.entries()].map(([t, n]) => [4, 6, 8, 10].includes(t) ? `-${i[n]}` : i[n]).join("");
}, Zi = (i) => I(void 0, null, function* () {
  return new Promise((e) => setTimeout(e, i));
}), Os = (t, ...n) => I(void 0, [t, ...n], function* (i, e = new Error("Timeout")) {
  return new Promise((r, o) => setTimeout(() => o(e), i));
}), Fs = (i) => {
  switch (i) {
    case "h264":
    case "av1":
      return "video";
    case "aac":
    case "opus":
    case "mp3":
      return "audio";
    case "webvtt":
      return "text";
    default:
      throw new Error("Unknown codec");
  }
}, De = (i) => "width" in i && typeof i.width == "number", Oe = (i) => "sampleRate" in i && typeof i.sampleRate == "number", Me = (i) => {
  switch (i.codec) {
    case "opus":
      return 'audio/mp4; codecs="opus"';
    case "mp3":
      return "audio/mpeg";
    case "webvtt":
      return "text/vtt";
    case "aac":
      return i.codecString ? `audio/mp4; codecs="${i.codecString}"` : "audio/mp4";
    case "h264":
      return i.codecString ? `video/mp4; codecs="${i.codecString}"` : "video/mp4";
    case "av1":
      return i.codecString ? `video/mp4; codecs="${i.codecString}"` : "video/mp4";
  }
}, ge = () => Number.MAX_SAFE_INTEGER, rt = () => ({
  width: Number.MAX_SAFE_INTEGER,
  height: Number.MAX_SAFE_INTEGER
}), Ei = (i) => !(typeof i != "object" || i === null || !("type" in i)), Ns = "connection_failed", Vs = "connection_failed_will_not_attempt_again", Qs = "authentication_error", zs = "authentication_expired", Hs = "channel_not_found", Gs = "no_incoming_data_error", Xs = "connection_inactivity", Ws = "missing_init_segment", js = "no_track_context", Zs = "invalid_track_context_state", qs = "disconnected_by_edge", Js = "decoder_error", Ys = "audio_player_error", $s = "media_source_error", Ks = "webgl_context_lost_error", en = "access_forbidden";
class b extends Error {
  constructor(t, n, r = {}) {
    super(t);
    s(this, "props");
    s(this, "extra", {});
    /**
     * The error code is a stable string that represents the error type - this should be treated as an
     * opaque string that can be used as a key for looking up localized strings for displaying error messages.
     * @returns the error code
     */
    s(this, "code", () => this.props.code);
    /**
     * Indicates whether the error is fatal - if it is that means the Vindral instance will be unloaded because of this error.
     */
    s(this, "isFatal", () => this.props.isFatal);
    /**
     * The underlying error that caused the Vindral error
     * @returns the underlying error
     */
    s(this, "source", () => this.props.source);
    s(this, "type", () => {
      var t;
      return (t = this.props.type) != null ? t : "external";
    });
    /**
     * @returns a stringifiable represenation of the error
     */
    s(this, "toStringifiable", () => {
      var r;
      const t = this.source(), n = t instanceof Error ? t.stack : this.stack;
      return L(g({}, this.extra), {
        code: this.props.code,
        isFatal: this.props.isFatal,
        type: this.props.type,
        message: this.message,
        sourceMessage: (r = this.source()) == null ? void 0 : r.message,
        stack: n
      });
    });
    this.props = n, this.extra = r, Object.setPrototypeOf(this, new.target.prototype);
  }
}
const tn = (i, e) => new b(
  "MediaElement Error",
  { isFatal: i, code: "media_element_error", source: e },
  { mediaErrorCode: e.code }
), sn = (i, e) => new b("Decoder Error", { isFatal: i, code: Js, source: e, type: "internal" }), qi = (i, e) => new b("Audio Player Error", { isFatal: i, code: Ys, source: e, type: "internal" }), nn = (i, e) => new b(`No init segment for rendition id ${i} for channel ${e}`, {
  isFatal: !1,
  code: Ws,
  type: "internal"
}), yi = (i, e, t, n) => new b(
  "MediaSource Error",
  { isFatal: i, code: $s, source: e, type: "internal" },
  { type: n, consecutiveErrorsCount: t }
), Dt = (i, e) => new b(`No track context for ${i}${e ? `, rendition id ${e}` : ""}`, {
  isFatal: !1,
  code: js,
  type: "internal"
}), rn = (i, e) => new b(
  `Track context is in an invalid state for ${i}${e ? `, rendition id ${e}` : ""}`,
  {
    isFatal: !1,
    code: Zs,
    type: "internal"
  }
), on = () => new b("Web Audio Context resume timeout", { isFatal: !1, code: "web_audio_context_resume_timeout" }), ze = (i) => new b("Disconnected From Edge Server", {
  type: "external",
  source: i,
  isFatal: !1,
  code: qs
}), ot = (i) => new b("Authentication Failed", { isFatal: !0, code: Qs, source: i }), an = (i) => new b("Authentication Expired", { isFatal: !0, code: zs, source: i }), cn = (i, e) => new b("Connection closed due to inactivity", { isFatal: !1, code: Xs, source: e, type: i }), Ji = (i, e) => new b("Channel not found", { isFatal: !1, code: Hs, source: e, type: i }), dn = (i) => new b("No Incoming Data", { isFatal: !1, code: Gs, source: i }), hn = (i) => new b("Connection attempt failed", {
  isFatal: !1,
  code: Ns,
  source: i
}), un = () => new b("Connection failed - no more reconnect attempts", {
  isFatal: !0,
  code: Vs
}), ln = (i) => new b("WebGL Context Lost", { isFatal: !1, code: Ks, source: i, type: "internal" }), Ti = (i) => new b(i, { isFatal: !0, code: en }), mn = 7, An = 8, fn = (i) => {
  const e = i.getUint32(0, !1), t = i.getUint8(0) << 16 | i.getUint16(1, !1);
  let n = 0;
  return t === 1 ? n += 3 : e === 1 && (n += 4), n;
}, gn = (i) => fn(new DataView(i, 0)) !== 0, Ci = (i, e = 0) => {
  for (let t = e; t < i.byteLength - 4; t++) {
    const n = i.getUint32(t) === 1, r = (i.getUint8(t) << 16 | i.getUint16(t + 1)) === 1;
    if (n || r)
      return { position: t, nalPrefixSize: n ? 4 : 3 };
  }
}, pn = (i) => i & 31, wn = (i, e) => {
  const t = new DataView(i, 0);
  let n = Ci(t);
  for (; n; ) {
    const { position: r, nalPrefixSize: o } = n, a = Ci(t, r + 4), c = a ? a.position - r - o : void 0;
    if (!e(new DataView(i, r + o, c), o))
      return;
    n = a;
  }
}, Yi = (i) => {
  const e = [], t = [];
  if (!gn(i)) {
    const n = new DataView(i, 0), r = n.getUint8(5) & 31;
    let o = 6;
    for (let c = 0; c < r; c++) {
      const d = n.getUint16(o);
      e.push(i.slice(o + 2, o + 2 + d)), o += d + 2;
    }
    const a = n.getUint8(o);
    o += 1;
    for (let c = 0; c < a; c++) {
      const d = n.getUint16(o);
      t.push(i.slice(o + 2, o + 2 + d)), o += d + 2;
    }
    return {
      sequenceParameterSets: e,
      pictureParameterSets: t
    };
  }
  return wn(i, (n) => {
    const r = n.byteOffset + n.byteLength;
    switch (pn(n.getUint8(0))) {
      case An:
        t.push(n.buffer.slice(n.byteOffset, r));
        break;
      case mn:
        e.push(n.buffer.slice(n.byteOffset, r));
        break;
    }
    return !0;
  }), { sequenceParameterSets: e, pictureParameterSets: t };
}, Sn = (i) => {
  var v;
  const e = new DataView(i), t = e.getUint8(1), n = e.getUint8(2), r = e.getUint8(3), o = new Wi(i, 4 * 8);
  o.readUnsignedExpGolomb();
  let a = 1;
  switch (t) {
    case 100:
    case 110:
    case 122:
    case 244:
    case 44:
    case 83:
    case 86:
    case 118:
    case 128:
    case 138:
    case 144: {
      if (a = o.readUnsignedExpGolomb(), a === 3 && o.readBits(1), o.readUnsignedExpGolomb() + 8, o.readUnsignedExpGolomb() + 8, o.readBit(), o.readBit()) {
        for (let k = 0; k < (a != 3 ? 8 : 12); k++)
          if (o.readBit()) {
            const C = k < 6 ? 16 : 64;
            let E = 0, H = 8, Y = 8;
            for (let se = 0; se < C; se++)
              Y != 0 && (E = o.readSignedExpGolomb(), Y = (H + E + 256) % 256), H = Y == 0 ? H : Y;
          }
      }
      break;
    }
  }
  o.readUnsignedExpGolomb();
  const c = o.readUnsignedExpGolomb();
  if (c == 0)
    o.readUnsignedExpGolomb();
  else if (c == 1)
    throw new Error("Unhandled case");
  o.readUnsignedExpGolomb(), o.readBit();
  const d = o.readUnsignedExpGolomb(), h = o.readUnsignedExpGolomb(), l = o.readBit();
  l === 0 && o.readBit(), o.readBit();
  let m = d + 1, f = h + 1;
  if (f *= 2 - l, f *= 16, m *= 16, o.readBit()) {
    const B = a == 1 ? 1 : 0, M = 1 << (a == 1 || a == 2 ? 1 : 0), C = 2 - l << B, E = o.readUnsignedExpGolomb() * M, H = o.readUnsignedExpGolomb() * M, Y = o.readUnsignedExpGolomb() * C, se = o.readUnsignedExpGolomb() * C;
    m -= E + H, f -= Y + se;
  }
  let p = {
    numerator: 1,
    denumerator: 1
  };
  return o.readBit() && o.readBit() && (p = (v = vn[o.readBits(8)]) != null ? v : { numerator: 0, denumerator: 0 }), {
    width: m,
    height: f,
    pixelAspectRatio: p,
    profileIdc: t,
    constraintFlags: n,
    levelIdc: r
  };
}, vn = [
  { numerator: 0, denumerator: 0 },
  { numerator: 1, denumerator: 1 },
  { numerator: 12, denumerator: 11 },
  { numerator: 10, denumerator: 11 },
  { numerator: 16, denumerator: 11 },
  { numerator: 40, denumerator: 33 },
  { numerator: 24, denumerator: 11 },
  { numerator: 20, denumerator: 11 },
  { numerator: 32, denumerator: 11 },
  { numerator: 80, denumerator: 33 },
  { numerator: 18, denumerator: 11 },
  { numerator: 15, denumerator: 11 },
  { numerator: 64, denumerator: 33 },
  { numerator: 160, denumerator: 99 },
  { numerator: 4, denumerator: 3 },
  { numerator: 3, denumerator: 2 },
  { numerator: 2, denumerator: 1 }
];
function w(i) {
  const e = new ArrayBuffer(i.length), t = new Uint8Array(e);
  for (let n = 0, r = i.length; n < r; n++)
    t[n] = i.charCodeAt(n);
  return new Uint8Array(e);
}
const T = {
  ftyp: w("ftyp"),
  mvhd: w("mvhd"),
  moov: w("moov"),
  trak: w("trak"),
  tkhd: w("tkhd"),
  mdia: w("mdia"),
  mdhd: w("mdhd"),
  hdlr: w("hdlr"),
  minf: w("minf"),
  vmhd: w("vmhd"),
  smhd: w("smhd"),
  dinf: w("dinf"),
  dref: w("dref"),
  stbl: w("stbl"),
  stsd: w("stsd"),
  avc1: w("avc1"),
  av01: w("av01"),
  av1C: w("av1C"),
  avcC: w("avcC"),
  esds: w("esds"),
  colr: w("colr"),
  nclx: w("nclx"),
  mvex: w("mvex"),
  trex: w("trex"),
  udta: w("udta"),
  meta: w("meta"),
  ilst: w("ilst"),
  moof: w("moof"),
  mfhd: w("mfhd"),
  traf: w("traf"),
  tfhd: w("tfhd"),
  tfdt: w("tfdt"),
  trun: w("trun"),
  mdat: w("mdat"),
  mp4a: w("mp4a"),
  Opus: w("Opus"),
  prft: w("prft"),
  dOps: w("dOps"),
  emsg: w("emsg")
}, bn = 1e3, je = w("iso6"), Ii = new Uint8Array([0, 0, 2, 0]), En = [
  je,
  new Uint8Array([105, 115, 111, 109]),
  // isom
  new Uint8Array([105, 115, 111, 50]),
  // iso2
  new Uint8Array([97, 118, 99, 49]),
  // avc1
  new Uint8Array([109, 112, 52, 49])
  // mp41
], yn = [
  je,
  new Uint8Array([105, 115, 111, 109]),
  // isom
  new Uint8Array([105, 115, 111, 50]),
  // iso2
  new Uint8Array([97, 118, 48, 49]),
  // av01
  new Uint8Array([109, 112, 52, 49])
  // mp41
], Tn = [
  je,
  new Uint8Array([105, 115, 111, 109]),
  // isom
  new Uint8Array([105, 115, 111, 50]),
  // iso2
  new Uint8Array([109, 112, 52, 49])
  // mp41
];
class $i {
  constructor() {
    s(this, "writer", new Ms());
  }
}
const D = (i, e, t) => {
  i.writer.writeUint32(t + 8), i.writer.writeBytes(e);
}, F = (i, e, t, n, r) => {
  D(i, e, t + 4), i.writer.writeUint8(n), i.writer.writeUint24(r);
}, Ot = (i, e) => {
  D(
    i,
    T.ftyp,
    je.byteLength + Ii.byteLength + e.reduce((t, n) => t + n.byteLength, 0)
  ), i.writer.writeBytes(je), i.writer.writeBytes(Ii), e.forEach((t) => i.writer.writeBytes(t));
}, Cn = (i, e, t) => {
  F(i, T.mvhd, 96, 0, 0), i.writer.writeUint32(0), i.writer.writeUint32(0), i.writer.writeUint32(t), i.writer.writeUint32(e), i.writer.writeUint32(65536), i.writer.writeUint16(256), i.writer.writeBytes(new Uint8Array([
    // reserved and unused junk
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    64,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
  ])), i.writer.writeUint32(2);
}, Ki = (i) => "sequenceParameterSets" in i, Gt = (i) => "sequenceHeader" in i, Ce = (i) => i.type == "video", He = (i) => i.type == "audio", In = (i, e, t) => {
  const n = i.writer.position();
  F(i, T.tkhd, 0, 0, 3), i.writer.writeUint32(0), i.writer.writeUint32(0), i.writer.writeUint32(e.trackId), i.writer.writeUint32(0), i.writer.writeUint32(e.duration * t / e.timescale), i.writer.writeUint32(0), i.writer.writeUint32(0), i.writer.writeUint16(0), i.writer.writeUint16(He(e) ? 1 : 0), i.writer.writeUint16(He(e) ? 256 : 0), i.writer.writeUint16(0), i.writer.writeBytes(new Uint8Array(
    [
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0
    ]
  )), Ce(e) ? (i.writer.writeUint32(e.width * 65536), i.writer.writeUint32(e.height * 65536)) : He(e) && (i.writer.writeUint32(0), i.writer.writeUint32(0)), i.writer.writeUint32At(n, i.writer.position() - n);
}, Bn = (i, e) => {
  F(i, T.mdhd, 20, 0, 0), i.writer.writeUint32(0), i.writer.writeUint32(0), i.writer.writeUint32(e.timescale), i.writer.writeUint32(e.duration);
  const t = e.lang || "und", n = (t.charCodeAt(0) & 31) << 10 | (t.charCodeAt(1) & 31) << 5 | t.charCodeAt(2) & 31;
  i.writer.writeUint16(n), i.writer.writeUint16(0);
}, Rn = (i, e) => {
  const t = i.writer.position();
  F(i, T.hdlr, 0, 0, 0), i.writer.writeUint32(0), i.writer.writeBytes(w(Ce(e) ? "vide" : "soun")), i.writer.writeUint32(0), i.writer.writeUint32(0), i.writer.writeUint32(0), i.writer.writeBytes(w(Ce(e) ? "VideoHandler\0" : "SoundHandler\0")), i.writer.writeUint32At(t, i.writer.position() - t);
}, kn = (i) => {
  const e = i.writer.position();
  D(i, T.dinf, 0), F(i, T.dref, 16, 0, 0), i.writer.writeUint32(1), F(i, w("url "), 0, 0, 1), i.writer.writeUint32At(e, i.writer.position() - e);
}, Pn = (i, e) => {
  const t = i.writer.position();
  D(i, T.avcC, 0), i.writer.writeUint8(1), i.writer.writeUint8(e.sequenceParameterSets[0][1]), i.writer.writeUint8(e.sequenceParameterSets[0][2]), i.writer.writeUint8(e.sequenceParameterSets[0][3]), i.writer.writeUint8(255), i.writer.writeUint8(224 | e.sequenceParameterSets.length), e.sequenceParameterSets.forEach((n) => {
    i.writer.writeUint16(n.byteLength), i.writer.writeBytes(n);
  }), i.writer.writeUint8(e.pictureParameterSets.length), e.pictureParameterSets.forEach((n) => {
    i.writer.writeUint16(n.byteLength), i.writer.writeBytes(n);
  }), i.writer.writeUint32At(t, i.writer.position() - t);
}, xn = (i, e) => {
  var c, d;
  const t = i.writer.position();
  D(i, T.av1C, 0);
  const { seqProfile: n, operatingPoints: r, colorConfig: o } = e.parsedSequenceHeader, a = r[0];
  i.writer.writeUint8(129), i.writer.writeUint8(n << 5 | ((c = a == null ? void 0 : a.seqLevelIdx) != null ? c : 0)), i.writer.writeUint8(
    ((d = a == null ? void 0 : a.tier) != null ? d : 0) | (o.highBitDepth ? 1 : 0) | (o.bitDepth === 12 ? 1 : 0) << 5 | (o.monoChrome ? 1 : 0) << 4 | o.subsamplingX << 3 | o.subsamplingY << 2 | o.chromaSamplePosition & 65535
  ), i.writer.writeUint8(0), i.writer.writeBytes(e.sequenceHeader), i.writer.writeUint32At(t, i.writer.position() - t);
}, Ln = (i, e) => {
  const t = i.writer.position(), n = Gt(e) ? T.av01 : T.avc1;
  D(i, n, 0), i.writer.writeUint32(0), i.writer.writeUint16(0), i.writer.writeUint16(1), i.writer.writeUint16(0), i.writer.writeUint16(0), i.writer.writeUint32(0), i.writer.writeUint32(0), i.writer.writeUint32(0), i.writer.writeUint16(e.width), i.writer.writeUint16(e.height), i.writer.writeUint32(4718592), i.writer.writeUint32(4718592), i.writer.writeUint32(0), i.writer.writeUint16(1), i.writer.writeUint8(0), i.writer.writeBytes(new Uint8Array(31)), i.writer.writeUint16(24), i.writer.writeUint16(-1), Ki(e) ? Pn(i, e) : Gt(e) && (xn(i, e), e.parsedSequenceHeader.colorConfig && (D(i, w("colr"), 11), i.writer.writeBytes(T.nclx), i.writer.writeUint16(e.parsedSequenceHeader.colorConfig.colorPrimaries), i.writer.writeUint16(e.parsedSequenceHeader.colorConfig.transferCharacteristics), i.writer.writeUint16(e.parsedSequenceHeader.colorConfig.matrixCoefficients), i.writer.writeUint8(e.parsedSequenceHeader.colorConfig.colorRange ? 1 : 0))), e.pixelAspectRatio && (D(i, w("pasp"), 8), i.writer.writeUint32(e.pixelAspectRatio.numerator), i.writer.writeUint32(e.pixelAspectRatio.denumerator)), e.bitrate && (D(i, w("btrt"), 12), i.writer.writeUint32(0), i.writer.writeUint32(e.bitrate), i.writer.writeUint32(e.bitrate)), i.writer.writeUint32At(t, i.writer.position() - t);
}, st = (i, e, t) => {
  let n = 3;
  for (i.writer.writeUint8(e); n > 0; n--)
    i.writer.writeUint8(t >> 7 * n | 128);
  i.writer.writeUint8(t & 127);
}, Mn = (i, e) => {
  const t = e.decoderConfig.byteLength > 0 ? e.decoderConfig.byteLength + 5 : 0, n = i.writer.position();
  F(i, T.esds, 0, 0, 0), st(i, 3, 21 + t + 5 + 1), i.writer.writeUint16(e.trackId), i.writer.writeUint8(0), st(i, 4, 13 + t);
  const r = e.codec === "mp3" && e.sampleRate > 24e3 ? 107 : 64;
  i.writer.writeUint8(r), i.writer.writeUint8(21), i.writer.writeUint24(0), i.writer.writeUint32(e.bitrate || 0), i.writer.writeUint32(e.bitrate || 0), e.decoderConfig.byteLength > 0 && (st(i, 5, e.decoderConfig.byteLength), i.writer.writeBytes(e.decoderConfig)), st(i, 6, 1), i.writer.writeUint8(2), i.writer.writeUint32At(n, i.writer.position() - n);
}, Un = (i) => {
  switch (i) {
    case "aac":
    case "mp3":
      return "mp4a";
    case "opus":
      return "Opus";
  }
}, _n = (i, e) => {
  const t = i.writer.position();
  D(i, w("dOps"), 0), i.writer.writeUint8(0);
  const n = e.decoderConfig, r = new DataView(n.buffer, n.byteOffset, n.byteLength);
  i.writer.writeUint8(r.getUint8(9)), i.writer.writeUint16(r.getUint16(10, !0)), i.writer.writeUint32(r.getUint32(12, !0)), i.writer.writeUint16(r.getUint16(16, !0)), i.writer.writeBytes(e.decoderConfig.slice(18)), i.writer.writeUint32At(t, i.writer.position() - t);
}, Dn = (i, e) => {
  const t = i.writer.position();
  switch (D(i, w(Un(e.codec)), 0), i.writer.writeUint32(0), i.writer.writeUint16(0), i.writer.writeUint16(1), i.writer.writeUint16(0), i.writer.writeUint16(0), i.writer.writeUint32(0), i.writer.writeUint16(e.channelCount), i.writer.writeUint16(16), i.writer.writeUint32(0), i.writer.writeUint16(e.sampleRate), i.writer.writeUint16(0), e.codec) {
    case "aac":
    case "mp3":
      Mn(i, e);
      break;
    case "opus":
      _n(i, e);
      break;
  }
  e.bitrate && (D(i, w("btrt"), 12), i.writer.writeUint32(0), i.writer.writeUint32(e.bitrate), i.writer.writeUint32(e.bitrate)), i.writer.writeUint32At(t, i.writer.position() - t);
}, On = (i, e) => {
  const t = i.writer.position();
  D(i, T.stbl, 0);
  const n = i.writer.position();
  F(i, T.stsd, 0, 0, 0), i.writer.writeUint32(1), Ce(e) ? Ln(i, e) : He(e) && Dn(i, e), i.writer.writeUint32At(n, i.writer.position() - n), F(i, w("stts"), 4, 0, 0), i.writer.writeUint32(0), F(i, w("stsc"), 4, 0, 0), i.writer.writeUint32(0), F(i, w("stsz"), 8, 0, 0), i.writer.writeUint32(0), i.writer.writeUint32(0), F(i, w("stco"), 4, 0, 0), i.writer.writeUint32(0), i.writer.writeUint32At(t, i.writer.position() - t);
}, Fn = (i, e) => {
  const t = i.writer.position();
  D(i, T.minf, 0), Ce(e) ? (F(i, T.vmhd, 8, 0, 1), i.writer.writeUint32(0), i.writer.writeUint32(0)) : He(e) && (F(i, T.smhd, 4, 0, 0), i.writer.writeUint16(0), i.writer.writeUint16(0)), kn(i), On(i, e), i.writer.writeUint32At(t, i.writer.position() - t);
}, Nn = (i, e) => {
  const t = i.writer.position();
  D(i, T.mdia, 0), Bn(i, e), Rn(i, e), Fn(i, e), i.writer.writeUint32At(t, i.writer.position() - t);
}, Vn = (i, e, t) => {
  const n = i.writer.position();
  D(i, T.trak, 0), In(i, e, t), Nn(i, e), i.writer.writeUint32At(n, i.writer.position() - n);
}, Qn = (i, e) => {
  F(i, T.trex, 20, 0, 0), i.writer.writeUint32(e.trackId), i.writer.writeUint32(1), i.writer.writeUint32(0), i.writer.writeUint32(0), i.writer.writeUint32(0);
}, zn = (i, e) => {
  const t = i.writer.position();
  D(i, T.mvex, 0), e.forEach((n) => Qn(i, n)), i.writer.writeUint32At(t, i.writer.position() - t);
}, Hn = (i, e, t, n) => {
  const r = i.writer.position();
  D(i, T.moov, 0), Cn(i, 0, t), e.forEach((o) => Vn(i, o, t)), zn(i, e), i.writer.writeUint32At(r, i.writer.position() - r);
}, Gn = (i, e) => {
  const t = i.writer.position();
  F(i, T.tfhd, 16, 0, 56), i.writer.writeUint32(e.trackId), i.writer.writeUint32(e.defaultDuration || 0), i.writer.writeUint32(e.defaultSize || 0), i.writer.writeUint32(e.defaultFlags || 0), i.writer.writeUint32At(t, i.writer.position() - t);
}, Xn = (i, e) => {
  const t = i.writer.position();
  F(i, T.tfdt, 8, 1, 0);
  const n = Math.floor(e.timestamp / 4294967296), r = (e.timestamp & 4294967295) >>> 0;
  i.writer.writeUint32(n), i.writer.writeUint32(r), i.writer.writeUint32At(t, i.writer.position() - t);
}, Wn = (i, e) => {
  const t = e.samples.some((c) => !!c.compositionTimeOffset), n = Bi(e.samples[0]) !== e.defaultFlags;
  let r = 1;
  n && (r |= 4), t && (r |= 2048);
  const o = i.writer.position();
  F(i, T.trun, 16, 1, r), i.writer.writeUint32(e.samples.length);
  const a = i.writer.position();
  i.writer.writeUint32(0), n && i.writer.writeUint32(Bi(e.samples[0])), t && e.samples.forEach((c) => i.writer.writeUint32(c.compositionTimeOffset || 0)), i.writer.writeUint32At(a, i.writer.position() + 8), i.writer.writeUint32At(o, i.writer.position() - o);
}, Bi = (i) => i.isSync ? 33554432 : 16842752, jn = (i, e) => {
  const t = i.writer.position();
  D(i, T.traf, 0), Gn(i, e), Xn(i, e), Wn(i, e), i.writer.writeUint32At(t, i.writer.position() - t);
}, Zn = (i, e) => {
  F(i, T.mfhd, 4, 0, 0), i.writer.writeUint32(e);
}, qn = (i, e) => {
  const t = i.writer.position();
  D(i, T.moof, 0), Zn(i, e.sequenceNumber), jn(i, e), i.writer.writeUint32At(t, i.writer.position() - t);
}, Jn = (i, e) => {
  D(i, T.mdat, e.samples[0].data.length), i.writer.writeBytes(e.samples[0].data);
}, xt = (i, e) => {
  const t = new $i(), n = i.filter((o) => Ce(o) && Ki(o)).length > 0;
  return i.filter((o) => Ce(o) && Gt(o)).length > 0 ? Ot(t, yn) : n ? Ot(t, En) : Ot(t, Tn), Hn(t, i, bn), t.writer.buffer();
}, Lt = (i) => {
  const e = new $i();
  if (i.samples.length !== 1)
    throw new Error("Only one sample is supported");
  return qn(e, i), Jn(e, i), e.writer.buffer();
}, Yn = ({ isSync: i, timestamp: e, data: t, duration: n }, r) => Lt({
  trackId: 1,
  timestamp: e,
  sequenceNumber: r,
  defaultSize: t.byteLength,
  defaultFlags: 33554432,
  defaultDuration: n,
  samples: [
    {
      isSync: i,
      data: new Uint8Array(t),
      duration: n
    }
  ]
}), $n = (i, e, t, n) => xt([
  {
    type: "audio",
    codec: "aac",
    decoderConfig: i,
    channelCount: e,
    sampleRate: t,
    timescale: n,
    duration: 0,
    trackId: 1
  }
]), es = (i) => {
  const { sequenceParameterSets: e, pictureParameterSets: t } = Yi(i), n = e[0], r = t[0];
  if (!n || !r)
    throw new Error("No sps or pps provided");
  return Sn(n);
}, Kn = ({ isSync: i, timestamp: e, data: t, duration: n, compositionTimeOffset: r }, o) => Lt({
  trackId: 1,
  timestamp: e,
  sequenceNumber: o,
  defaultSize: t.byteLength,
  defaultFlags: i ? 33554432 : 16842752,
  defaultDuration: n,
  samples: [
    {
      isSync: i,
      data: new Uint8Array(t),
      duration: n,
      compositionTimeOffset: r
    }
  ]
}), er = (i, e) => {
  const { sequenceParameterSets: t, pictureParameterSets: n } = Yi(i), r = es(i);
  return xt([
    {
      type: "video",
      sequenceParameterSets: t.map((o) => new Uint8Array(o)),
      pictureParameterSets: n.map((o) => new Uint8Array(o)),
      width: r.width,
      height: r.height,
      timescale: e,
      duration: 0,
      trackId: 1
    }
  ]);
}, tr = (i, e, t) => xt([
  {
    type: "audio",
    trackId: 1,
    channelCount: e,
    timescale: t,
    codec: "opus",
    decoderConfig: i,
    duration: 0,
    sampleRate: 48e3
  }
]), ir = ({ isSync: i, timestamp: e, data: t, duration: n }, r) => Lt({
  trackId: 1,
  timestamp: e,
  sequenceNumber: r,
  defaultSize: t.byteLength,
  defaultFlags: 33554432,
  defaultDuration: n,
  samples: [
    {
      isSync: i,
      data: new Uint8Array(t),
      duration: n
    }
  ]
}), ts = (i) => {
  const e = new Wi(i);
  return e.peekBit() === 1 && e.readBits(32), rr(e), mr(e);
}, sr = (i) => {
  let e = 0;
  for (let t = 0; t < 8; t++) {
    const n = i.readBits(8);
    if (e |= (n & 127) << t * 7, (n & 128) !== 128)
      break;
  }
  return e;
}, nr = (i) => {
  let e = 0;
  for (; e < 100 && i.readBit() === 0; )
    e++;
  return e >= 32 ? 0 : i.readBits(e) + (1 << e) - 1;
}, rr = (i) => {
  const e = i.readBits(8);
  if ((e >> 7 & 1) !== 0)
    return;
  const n = e >> 3 & 15, r = e >> 2 & 1, o = e >> 1 & 1;
  return r == 1 && i.readBits(8), o == 1 && sr(i), {
    headerLength: 1 + r,
    type: n
  };
}, or = (i) => {
  const e = i.readBits(32), t = i.readBits(32), n = i.readBit() !== 0;
  let r = 0;
  return n && (r = nr(i) + 1), {
    timescale: t,
    equalPictureInterval: n,
    numUnitsInDisplayTick: e,
    numTicksPerPicture: r
  };
}, Ri = 2, Ft = 2, ar = 1, cr = 2, dr = 2, hr = 13, ur = 0, lr = 2, ki = 0, mr = (i) => {
  const e = i.readBits(3), n = i.readBit() !== 0, r = i.readBit() !== 0;
  let o, a = !1, c = !1, d = !1, h = 0, l = 0;
  const m = [];
  if (r)
    i.readBits(5);
  else {
    if (c = i.readBit() !== 0, c && (o = or(i), a = i.readBit() !== 0, a))
      throw new Error("Not implemented");
    d = i.readBit() !== 0;
    const re = i.readBits(5) + 1;
    for (let j = 0; j < re; j++) {
      const oe = i.readBits(12), K = i.readBits(5);
      let de = 0;
      if (K > 7 && (de = i.readBit()), a)
        throw new Error("decoderModelInfoPresentFlag==1");
      d && i.readBit() !== 0 && i.readBits(4), m.push({ tier: de, operatingPointIdc: oe, seqLevelIdx: K });
    }
  }
  const f = i.readBits(4) + 1, p = i.readBits(4) + 1, v = i.readBits(f) + 1, B = i.readBits(p) + 1;
  let k = !1;
  r ? k = !1 : k = i.readBit() !== 0, k && (h = i.readBits(4) + 2, l = i.readBits(3) + 1);
  const M = i.readBit() !== 0, C = i.readBit() !== 0, E = i.readBit() !== 0;
  let H = !1, Y = !1, se = !1, tt = !1, ne = !1, Qe = !1, it = !1, A = Ri, S = Ft, P = 0;
  r || (H = i.readBit() !== 0, Y = i.readBit() !== 0, se = i.readBit() !== 0, tt = i.readBit() !== 0, ne = i.readBit() !== 0, ne && (Qe = i.readBit() !== 0, it = i.readBit() !== 0), i.readBit() !== 0 ? A = Ri : A = i.readBit(), A > 0 ? i.readBit() > 0 ? S = Ft : S = i.readBit() : S = Ft, ne ? P = i.readBits(3) : P = 0);
  const x = i.readBit() !== 0, O = i.readBit() !== 0, U = i.readBit() !== 0;
  return {
    seqProfile: e,
    stillPicture: n,
    reducedStillPictureHeader: r,
    timingInfoPresentFlag: c,
    timingInfo: o != null ? o : {
      equalPictureInterval: !1,
      numUnitsInDisplayTick: 0,
      timescale: 0,
      numTicksPerPicture: 0
    },
    decoderModelInfoPresentFlag: a,
    initialDisplayDelayPresentFlag: d,
    operatingPoints: m,
    frameWidthBits: f,
    frameHeightBits: p,
    maxFrameWidth: v,
    maxFrameHeight: B,
    frameIdNumbersPresentFlag: k,
    deltaFrameIdLength: h,
    additionalFrameIdLength: l,
    use_128x128Superblock: M,
    enableFilterIntra: C,
    enableIntraEdgeFilter: E,
    enableInterintraCompound: H,
    enableMaskedCompound: Y,
    enableWarpedMotion: se,
    enableDualFilter: tt,
    enableOrderHint: ne,
    enableJntComp: Qe,
    enableRefFrameMvs: it,
    seqForceScreenContentTools: A,
    seqForceIntegerMv: S,
    orderHintBits: P,
    enableSuperres: x,
    enableCdef: O,
    enableRestoration: U,
    colorConfig: Ar(i, e),
    filmGrainParamsPresent: i.readBit() !== 0
  };
}, Ar = (i, e) => {
  const t = i.readBit() !== 0;
  let n = 8, r = !1;
  e === 2 && t ? n = i.readBit() !== 0 ? 12 : 10 : e <= 2 && (n = t ? 10 : 8), e === 1 ? r = !1 : r = i.readBit() !== 0;
  const o = r ? 1 : 3, a = i.readBit() !== 0;
  let c = cr, d = dr, h = lr, l = !1, m = 0, f = 0, p = ki, v = !1;
  return a && (c = i.readBits(8), d = i.readBits(8), h = i.readBits(8)), r ? (l = i.readBit() !== 0, m = 1, f = 1, p = ki, v = !1, {
    highBitDepth: t,
    bitDepth: n,
    monoChrome: r,
    chromaSamplePosition: p,
    colorPrimaries: c,
    colorRange: l,
    matrixCoefficients: h,
    numPlanes: o,
    separateUvDeltaQ: v,
    subsamplingX: m,
    subsamplingY: f,
    transferCharacteristics: d
  }) : c === ar && d == hr && h == ur ? (l = !0, m = 0, f = 0, {
    highBitDepth: t,
    bitDepth: n,
    monoChrome: r,
    chromaSamplePosition: p,
    colorPrimaries: c,
    colorRange: l,
    matrixCoefficients: h,
    numPlanes: o,
    separateUvDeltaQ: v,
    subsamplingX: m,
    subsamplingY: f,
    transferCharacteristics: d
  }) : (l = i.readBit() !== 0, e === 0 ? (m = 1, f = 1) : e === 1 ? (m = 0, f = 0) : n === 12 ? (m = i.readBit(), m !== 0 ? f = i.readBit() : f = 0) : (m = 1, f = 0), m !== 0 && f !== 0 && (p = i.readBits(2)), v = i.readBit() !== 0, {
    highBitDepth: t,
    bitDepth: n,
    monoChrome: r,
    chromaSamplePosition: p,
    colorPrimaries: c,
    colorRange: l,
    matrixCoefficients: h,
    numPlanes: o,
    separateUvDeltaQ: v,
    subsamplingX: m,
    subsamplingY: f,
    transferCharacteristics: d
  });
}, fr = (i) => {
  const e = ts(i);
  if (e)
    return {
      width: e.maxFrameWidth,
      height: e.maxFrameHeight
    };
}, gr = ({ isSync: i, timestamp: e, data: t, duration: n, compositionTimeOffset: r }, o) => Lt({
  trackId: 1,
  timestamp: e,
  sequenceNumber: o,
  defaultSize: t.byteLength,
  defaultFlags: i ? 33554432 : 16842752,
  defaultDuration: n,
  samples: [
    {
      isSync: i,
      data: new Uint8Array(t),
      duration: n,
      compositionTimeOffset: r
    }
  ]
}), pr = (i, e) => {
  const t = ts(i);
  if (!t)
    throw new Error("Failed to parse sequence header");
  return xt([
    {
      type: "video",
      parsedSequenceHeader: t,
      sequenceHeader: new Uint8Array(i),
      width: t.maxFrameWidth,
      height: t.maxFrameHeight,
      timescale: e,
      duration: 0,
      trackId: 1
    }
  ]);
}, wr = (i, e, t) => {
  switch (i) {
    case "h264":
      return vr(e, t);
    case "av1":
      return br(e, t);
    case "opus":
      return Er(e, t);
    case "aac":
      return yr(e, t);
    default:
      throw new Error(`Failed to initialize ${i} segment`);
  }
}, Sr = (i, e) => {
  switch (i) {
    case "h264":
      return es(e);
    case "av1":
      return fr(e);
  }
}, vr = (i, e) => er(i, e), br = (i, e) => pr(i, e), Er = (i, e) => tr(new Uint8Array(i), 2, e), yr = (i, e) => $n(new Uint8Array(i), 2, e, e), Tr = (i, e) => {
  switch (i.codec) {
    case "h264":
      return Kn(i, e);
    case "opus":
      return ir(i, e);
    case "aac":
      return Yn(i, e);
    case "av1":
      return gr(i, e);
    default:
      throw new Error(`Unsupported codec ${i.codec}`);
  }
}, Ge = (i) => !!(i & 1), Cr = (i) => !!(i & 2), Ir = (i) => !!(i & 4), Br = (i) => !!(i & 8), Rr = (i) => !!(i & 16), kr = (i) => {
  const e = new DataView(i, 0), t = e.getUint8(0), n = e.getUint16(1), r = e.getUint8(3), o = e.getUint8(4), a = Ls(new Uint8Array(i), 5, 12), c = e.getUint32(13), d = Rr(r) ? e.getInt16(17) : void 0, h = i.slice(n);
  return { version: t, renditionId: o, flags: r, timestamp: a, timescale: c, payload: h, compositionTimeOffset: d };
}, Pr = "data:video/mp4;base64,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", nt = () => "wakeLock" in navigator && window.navigator.userAgent.indexOf("Samsung") === -1;
class xr {
  constructor() {
    s(this, "enabled", !1);
    s(this, "wakeLockVideo");
    s(this, "_wakeLock", null);
    s(this, "handleVisibilityChange", () => {
      this._wakeLock !== null && document.visibilityState === "visible" && this.enable();
    });
    nt() && (this._wakeLock = null, document.addEventListener("visibilitychange", this.handleVisibilityChange), document.addEventListener("fullscreenchange", this.handleVisibilityChange));
  }
  _addSourceToVideo(e, t, n) {
    const r = document.createElement("source");
    r.src = n, r.type = `video/${t}`, e.appendChild(r);
  }
  get isEnabled() {
    return this.enabled;
  }
  attach(e) {
    if (!nt()) {
      if (!this.wakeLockVideo) {
        const t = document.createElement("video");
        this.wakeLockVideo = t, this.wakeLockVideo.setAttribute("title", "Live Stream"), this.wakeLockVideo.setAttribute("playsinline", ""), this._addSourceToVideo(this.wakeLockVideo, "mp4", Pr), Object.assign(this.wakeLockVideo.style, {
          position: "absolute",
          left: "-100%",
          top: "-100%"
        }), this.wakeLockVideo.addEventListener("loadedmetadata", () => {
          t.addEventListener("timeupdate", () => {
            t.currentTime > 0.5 && (t.currentTime = Math.random());
          });
        });
      }
      e && e.appendChild(this.wakeLockVideo);
    }
  }
  enable() {
    return I(this, null, function* () {
      var e, t;
      return nt() ? navigator.wakeLock.request("screen").then((n) => {
        this._wakeLock = n, this.enabled = !0, this._wakeLock.addEventListener("release", () => {
        });
      }).catch(() => {
        this.enabled = !1;
      }) : ((t = (e = this.wakeLockVideo) == null ? void 0 : e.play()) != null ? t : Promise.resolve()).then((r) => (this.enabled = !0, r)).catch(() => {
        this.enabled = !1;
      });
    });
  }
  disable() {
    var e, t;
    nt() ? (this._wakeLock && this._wakeLock.release(), this._wakeLock = null) : ((e = this.wakeLockVideo) == null || e.pause(), (t = this.wakeLockVideo) == null || t.remove()), this.enabled = !1;
  }
  unload() {
    document.removeEventListener("visibilitychange", this.handleVisibilityChange), document.removeEventListener("fullscreenchange", this.handleVisibilityChange), this.disable();
  }
}
const Lr = /\r\n|\r|\n/;
var me, ae;
class Pi {
  constructor(e) {
    R(this, me);
    R(this, ae);
    _(this, me, e), _(this, ae, 0);
  }
  skipEmptyLines() {
    let e = 0;
    for (; u(this, me)[u(this, ae)] === ""; )
      _t(this, ae)._++, e++;
    return e;
  }
  readLine() {
    return u(this, me)[_t(this, ae)._++];
  }
  takeUntilEmptyLine() {
    const e = [];
    for (; u(this, me)[u(this, ae)] !== ""; ) {
      const t = this.readLine();
      if (t === void 0)
        break;
      e.push(t);
    }
    return e;
  }
  linesLeft() {
    return u(this, me).length - u(this, ae);
  }
}
me = new WeakMap(), ae = new WeakMap();
var Ie, is, Xt;
class Mr {
  constructor() {
    R(this, Ie);
  }
  parse(e) {
    const t = [], n = e.split(Lr), r = new Pi(n), o = r.readLine();
    if (!o || !o.startsWith("WEBVTT"))
      throw new Error("missing 'WEBVTT' signature");
    for (; r.readLine() !== ""; )
      ;
    for (; r.linesLeft() > 0; ) {
      const a = W(this, Ie, is).call(this, r);
      t.push(a), r.skipEmptyLines();
    }
    return t;
  }
}
Ie = new WeakSet(), is = function(e) {
  e.skipEmptyLines();
  const t = e.takeUntilEmptyLine(), n = new Pi(t);
  let r = n.readLine(), o;
  if (r != null && r.includes("-->") || (o = r, r = n.readLine()), r === void 0)
    throw new Error("expected cue line");
  const [a, c] = r.split("-->").map((p) => p.trim());
  if (!a || !c)
    throw new Error(`a cue needs both start and end time start: ${a} end: ${c}`);
  const [d, h] = c.split(" ", 1).map((p) => p.trim());
  if (!d)
    throw new Error(`missing end time: ${d}`);
  const l = n.readLine();
  if (!l)
    throw new Error("missing text");
  const m = W(this, Ie, Xt).call(this, a), f = W(this, Ie, Xt).call(this, d);
  return {
    id: o,
    startTime: m,
    endTime: f,
    text: l
  };
}, Xt = function(e) {
  const t = e.split(":");
  if (t.length == 2) {
    const [c = 0, d = 0] = t.map((l) => parseFloat(l));
    return c * 60 + d;
  }
  const [n = 0, r = 0, o = 0] = t.map((c) => parseFloat(c));
  return n * 60 * 60 + r * 60 + o;
};
class Wt extends pe {
  constructor({ type: t, autoplay: n, muted: r, logger: o, poster: a }) {
    super();
    s(this, "element");
    s(this, "logger");
    s(this, "seekTimes", new X(10));
    s(this, "seekStartTime");
    // represents the user specified "muted" state
    s(this, "_userProvidedMuted");
    s(this, "timers", new N());
    s(this, "_userHasProvidedInput", !1);
    s(this, "_isPaused", !0);
    s(this, "isActivated", !1);
    /**
     * This dummy element is used to occupy space during pip mode
     * when we set the real video element to position: fixed in order
     * to keep the video playing on iOS.
     */
    s(this, "dummy");
    /**
     * Enter ios hack mode in order to keep the video playing in pip mode even when the video goes out of view.
     */
    s(this, "_iosHackEnterPiPMode", () => {
      const t = this.element.parentElement, n = this.element.clientWidth / this.element.clientHeight;
      this.element.style.position = "fixed", this.element.style.opacity = "0", this.element.style.pointerEvents = "none", t && (this.dummy = document.createElement("video"), this.dummy.style.paddingBottom = "calc(100% / " + n + ")", this.dummy.style.width = "100%", this.dummy.style.height = "0px", t.appendChild(this.dummy));
    });
    /**
     * Restore the pip mode hack for ios.
     */
    s(this, "_iosHackExitPiPMode", () => {
      this.element.style.position = "relative", this.element.style.opacity = "1", this.element.style.pointerEvents = "auto", this.dummy && (this.dummy.remove(), this.dummy = void 0);
    });
    s(this, "attach", (t) => {
      this.element.remove(), t.appendChild(this.element);
    });
    s(this, "load", () => {
      this.timers.setInterval(this.onPlayPause, 500), this.timers.setTimeout(() => {
        this.timers.setInterval(this.onBufferStateChange, 500);
      }, 1e4);
    });
    s(this, "unload", () => {
      this.timers.unload();
    });
    s(this, "getPlaybackRate", () => this.element.playbackRate);
    s(this, "getPlaybackState", () => this.element.readyState >= this.element.HAVE_FUTURE_DATA ? "playing" : "buffering");
    s(this, "setPlaybackRate", (t) => void (this.element.playbackRate = t));
    s(this, "getBuffer", () => {
      const t = [], n = this.element.buffered;
      if (!n)
        return [];
      for (let r = 0; r < n.length; r++)
        t.push({ start: n.start(r) * 1e3, end: n.end(r) * 1e3 });
      return t;
    });
    s(this, "pause", () => {
      this._isPaused = !1, this.element.pause();
    });
    /// This method is used to try to play the media element without throwing an error if it fails.
    s(this, "tryPlay", () => {
      this.element.muted = this._userProvidedMuted, this._play().catch(ce);
    });
    /// This method is used to play the media element and will throw an error if it fails.
    s(this, "play", () => {
      this.element.muted = this._userProvidedMuted, this._play().catch((t) => {
        if (t instanceof Error) {
          const n = new b("Media Play Error", { source: t, isFatal: !1, code: "media_play_error" });
          this.emit("error", n);
        }
      });
    });
    s(this, "_play", () => I(this, null, function* () {
      try {
        yield this.element.play(), this._userHasProvidedInput = !this.muted || this._userProvidedMuted;
      } catch (t) {
        if (t instanceof Error && t.name === "NotAllowedError")
          if (this._userHasProvidedInput = !1, this.element.muted)
            this.emit("needs user input", {
              forAudio: !0,
              forVideo: !0
            });
          else
            return this.element.muted = !0, this.emit("needs user input", {
              forAudio: !0,
              forVideo: !1
            }), this._play();
        else
          throw t;
      }
    }));
    s(this, "onEvent", (t) => {
      this.logger.trace(t.type, { state: this.element.readyState, event: t, playbackState: this.getPlaybackState() });
    });
    s(this, "onVolumeChange", () => {
      this.logger.info("volume state", { isMuted: this.element.muted, volume: this.element.volume }), this.emit("volume state", { isMuted: this.element.muted, volume: this.element.volume });
    });
    s(this, "onPlayPause", () => {
      this._isPaused !== this.element.paused && (this._isPaused = this.element.paused, this.logger.info("player pause change", { paused: this.element.paused }), this.emit("media element state", this.element.paused ? "paused" : "playing"));
    });
    s(this, "onBufferStateChange", () => {
      this.emit("buffer state", {
        isPaused: this.element.paused,
        buffered: this.getBuffer(),
        currentTime: this.currentTime,
        playbackState: this.getPlaybackState()
      });
    });
    s(this, "onSeekStart", () => {
      this.seekStartTime = Date.now();
    });
    s(this, "onSeekEnd", () => {
      this.seekStartTime && (this.seekTimes.push(Date.now() - this.seekStartTime), this.seekStartTime = void 0);
    });
    this.logger = o, this._userProvidedMuted = r, this.element = document.createElement(t), this.element instanceof HTMLVideoElement && (this.element.playsInline = !0), this.element.controls = !1, this.element.autoplay = n, this.element.muted = r, this.element.style.display = "block", this.element.style.width = "100%", this.element.disableRemotePlayback = !0, this.element.setAttribute(
      "poster",
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAQAAACRI2S5AAAAEElEQVR42mNkIAAYRxWAAQAG9gAKqv6+AwAAAABJRU5ErkJggg=="
    ), this.onPlayPause(), setTimeout(() => {
      !this.element || !a || this.element.setAttribute("poster", a);
    }, 0), this.element.addEventListener("stalled", this.onEvent), this.element.addEventListener("canplay", this.onEvent), this.element.addEventListener("loadeddata", this.onEvent), this.element.addEventListener("loadedmetadata", this.onEvent), this.element.addEventListener("canplaythrough", this.onEvent), this.element.addEventListener("waiting", this.onEvent), this.element.addEventListener("playing", this.onPlayPause), this.element.addEventListener("pause", this.onPlayPause), this.element.addEventListener("seeked", this.onSeekEnd), this.element.addEventListener("seeking", this.onSeekStart), this.element.addEventListener("volumechange", this.onVolumeChange), this.element.addEventListener("timeupdate", this.onBufferStateChange), this.element.addEventListener("progress", this.onBufferStateChange);
  }
  get seekTime() {
    return this.seekTimes.isEmpty() ? 0 : et(this.seekTimes.items());
  }
  get isSeeking() {
    return this.element.seeking;
  }
  get currentTime() {
    return isNaN(this.element.currentTime) ? 0 : this.element.currentTime * 1e3;
  }
  set currentTime(t) {
    Number.isFinite(t) && (this.element.currentTime = t / 1e3);
  }
  get playbackRate() {
    return this.element.playbackRate;
  }
  set playbackRate(t) {
    this.element.playbackRate = t;
  }
  get volume() {
    return this.element.volume;
  }
  set volume(t) {
    this.element.volume = t;
  }
  get muted() {
    return this.element.muted;
  }
  set muted(t) {
    this._userProvidedMuted = t, this.element.muted = t;
  }
  get userHasProvidedInput() {
    return this._userHasProvidedInput;
  }
  get isPaused() {
    return this._isPaused;
  }
}
const Ur = [
  "minBufferTime",
  "maxBufferTime",
  "burstEnabled",
  "sizeBasedResolutionCapEnabled",
  "separateVideoSocketEnabled",
  "videoCodecs"
];
function _r(i) {
  return Ur.includes(i);
}
class Dr {
  constructor(e) {
    s(this, "options");
    s(this, "overrides", /* @__PURE__ */ new Map());
    this.options = e;
  }
  /**
   *
   * @returns the options excluding any overrides
   */
  getOptions() {
    return this.options;
  }
  /**
   * Add overrides for a specific channel
   * @param channelId the channel to add overrides to
   * @param overrides the overrides to insert
   */
  addOverrides(e, t) {
    this.overrides.set(e, t);
  }
  /**
   * Sets an option value
   * @param key the option key to set
   * @param value the option value to insert into the key
   */
  set(e, t) {
    this.options[e] = t;
  }
  /**
   * Gets the option value for a specific key. If a channelId is provided, it will also apply any overrides
   * to the options value.
   * @param key the key to get from the options
   * @param channelId the channelId to get channel specific overrides from
   * @returns the option value, potentially overridden by channel overrides if a channelId is provided
   */
  get(e, t) {
    var n;
    if (t && _r(e)) {
      const r = (n = this.overrides.get(t)) == null ? void 0 : n[e];
      if (typeof r != "undefined")
        return r;
    }
    return this.options[e];
  }
  /**
   *
   * @param key the key to get from the overrides
   * @param channelId the channel overrides to get the override from
   * @returns the override value for that channel
   */
  getOverride(e, t) {
    var n;
    return (n = this.overrides.get(t)) == null ? void 0 : n[e];
  }
}
const Or = (i) => {
  const e = window;
  e.vindralInstances = e.vindralInstances || {}, e.vindralInstances[i.getStatistics().clientId.substring(0, 8)] = i;
}, Fr = {
  sizeBasedResolutionCapEnabled: !0,
  pictureInPictureEnabled: !0,
  abrEnabled: !0,
  burstEnabled: !1,
  mseEnabled: !0,
  mseOpusEnabled: !1,
  muted: !1,
  minBufferTime: 1500,
  maxBufferTime: 1500,
  logLevel: Ds.OFF,
  maxSize: rt(),
  maxVideoBitRate: ge(),
  maxAudioBitRate: ge(),
  tags: [],
  media: "audio+video",
  poster: !0,
  reconnectHandler: (i) => i.reconnectRetries < 30,
  iosWakeLockEnabled: !1,
  telemetryEnabled: !0,
  iosMediaElementEnabled: !1,
  pauseSupportEnabled: !0,
  advanced: {
    // Allow 1280 in both directions to support portait mode as well
    wasmDecodingConstraint: {
      bitRate: Number.MAX_SAFE_INTEGER,
      width: 1280,
      height: 1280
    }
  },
  videoCodecs: ["av1", "h264"]
}, Nr = (i) => {
  if (!navigator.mediaCapabilities)
    return Promise.resolve({ smooth: !0, supported: !0, powerEfficient: !0, failedToQuery: !0 });
  if (i.codec === "webvtt")
    throw new Error("WebVTT is not supported");
  let e;
  return Oe(i) ? e = {
    type: "media-source",
    audio: {
      contentType: Me(i),
      bitrate: i.bitRate,
      channels: i.channels.toString(),
      samplerate: i.sampleRate
    }
  } : e = {
    type: "media-source",
    video: {
      contentType: Me(i),
      bitrate: i.bitRate,
      width: i.width,
      height: i.height,
      framerate: i.frameRate[0] / i.frameRate[1]
    }
  }, navigator.mediaCapabilities.decodingInfo(e);
}, Vr = 0.15, Qr = 0.2, xi = 0.4, zr = 0.5, Hr = 0.6, Nt = 15, Gr = {
  cooldownTime: 3e3,
  maxBufferingEvents: {
    last10Seconds: 0
  },
  maxBufferingRatio: {
    last10Seconds: 0
  },
  maxRecentDowngradesCount: 3,
  maxDowngradeLookbackMs: 60 * 1e3,
  minTimeSpentPlaying: {
    factor: 0.5,
    ratio: 0.1
  },
  maxCooldownRatio: 2
}, Vt = (i) => (e) => e > i, lt = class lt {
  constructor(e, t, n, r) {
    s(this, "qualityOfServiceSource");
    s(this, "config");
    s(this, "emitter");
    s(this, "logger");
    s(this, "isSuspended", !1);
    s(this, "lastAdaptTime", Date.now());
    s(this, "isEnabled", !0);
    s(this, "load", () => {
      this.emitter.on("buffer state", this.onBufferState), this.emitter.on("adapted level", this.onAdaptedLevel);
    });
    s(this, "unload", () => {
      this.emitter.off("buffer state", this.onBufferState), this.emitter.off("adapted level", this.onAdaptedLevel);
    });
    s(this, "suspend", () => {
      this.isSuspended = !0;
    });
    s(this, "unsuspend", () => {
      this.reset(), this.isSuspended = !1;
    });
    s(this, "reset", (e = 0) => {
      this.lastAdaptTime = Date.now() + e;
    });
    s(this, "getStatistics", () => ({
      isAbrEnabled: this.isEnabled
    }));
    s(this, "isQoSOk", (e) => {
      const t = this.qualityOfServiceSource.getLevelStats(e), { upgradesFromLevel: n, downgradesFromLevel: r } = t != null ? t : { upgradesFromLevel: [], downgradesFromLevel: [] }, o = Date.now() - this.config.maxDowngradeLookbackMs, a = r.filter(Vt(o)).length, c = n.filter(Vt(o)).length;
      if (a - c > this.config.maxRecentDowngradesCount)
        return this.logger.debug("Recent downgrades count is over maximum", {
          downgrades: a - c,
          maxRecentDowngradesCount: this.config.maxRecentDowngradesCount
        }), !1;
      const d = this.qualityOfServiceSource.timeSpentPlayingInAtLeastLevelRatio(e), h = this.qualityOfServiceSource.timeActive() - this.qualityOfServiceSource.timeSpentBuffering(), l = d * h / this.config.maxDowngradeLookbackMs;
      if (a > 1 && l < this.config.minTimeSpentPlaying.factor)
        return this.logger.debug("Time spent playing is too low", {
          recentDowngrades: a,
          timeSpentPlayingInAtLeastLevelRatio: d
        }), !1;
      if (a > 1 && d < this.config.minTimeSpentPlaying.ratio)
        return this.logger.debug("Time spent playing in at least this level is too low", {
          recentDowngrades: a,
          timeSpentPlayingInAtLeastLevelRatio: d
        }), !1;
      const m = Math.max(0, r.length - n.length - l), f = Date.now() - this.config.maxDowngradeLookbackMs * m, p = r.filter(Vt(f)).length;
      return p && m > this.config.maxCooldownRatio ? (this.logger.debug("Too many downgrades compared to time spent playing", {
        downgradesWithinCooldownTime: p,
        cooldownRatio: m
      }), !1) : !0;
    });
    s(this, "onBufferState", (e) => {
      if (!this.isEnabled || this.isSuspended || this.lastAdaptTime + this.config.cooldownTime > Date.now())
        return;
      const { bufferFullness: t, general: n } = this.qualityOfServiceSource.getMetrics(), r = this.qualityOfServiceSource.getBufferFullnessRegression();
      if (!r)
        return;
      const o = 10 * 1e3, { slope: a } = r, c = r.predict(Nt), d = a < 0, h = r.predict(Nt) < xi && r.slope < 0, l = r.predict(Nt) > Hr, m = this.qualityOfServiceSource.timeSpentBufferingLast(30 * 1e3), f = this.qualityOfServiceSource.timeSpentActiveLast(30 * 1e3), p = m / f;
      if (t < 0.15 && p > 0.8) {
        this.adaptLevel("reconnect");
        return;
      }
      if (n.decodeRate <= 1) {
        this.adaptLevel("downgrade");
        return;
      }
      h || t < Vr ? d && t < xi && c < Qr && this.adaptLevel(e.playbackState === "buffering" ? "double downgrade" : "downgrade") : t > zr && l && !this.tooMuchTimeBuffering(o) && !this.tooManyBufferingEvents(o) && this.adaptLevel("upgrade");
    });
    s(this, "onAdaptedLevel", () => {
      this.reset();
    });
    s(this, "adaptLevel", (e) => this.emitter.emit("adapt level", e));
    this.qualityOfServiceSource = n, this.config = g(g({}, Gr), r), this.emitter = e, this.logger = t;
  }
  tooMuchTimeBuffering(e) {
    return this.qualityOfServiceSource.timeSpentBufferingLast(e) / this.qualityOfServiceSource.timeSpentActiveLast(e) > this.config.maxBufferingRatio.last10Seconds;
  }
  tooManyBufferingEvents(e) {
    return this.qualityOfServiceSource.timeSpentBufferingLast(e) > this.config.maxBufferingEvents.last10Seconds;
  }
};
s(lt, "create", (e, t, n, r = {}) => new lt(e, t, n, r));
let jt = lt;
const Xr = {
  minBufferTime: 1500,
  maxBufferTime: 1500,
  cooldownTime: 3e4,
  maxBufferingEvents: {
    last30Seconds: 3
  },
  maxBufferingRatio: {
    last30Seconds: 0.15
  }
}, ue = class ue {
  constructor(e, t, n, r, o) {
    s(this, "qualityOfServiceSource");
    s(this, "targetBufferTimeTarget");
    s(this, "config");
    s(this, "emitter");
    s(this, "logger");
    s(this, "isSuspended", !1);
    s(this, "lastIncreaseTime", Date.now());
    s(this, "bufferTimeAdjustmentCount", 0);
    s(this, "load", () => {
      this.emitter.on("buffer state", this.onBufferState);
    });
    s(this, "unload", () => {
      this.emitter.off("buffer state", this.onBufferState);
    });
    s(this, "suspend", () => {
      this.isSuspended = !0;
    });
    s(this, "unsuspend", () => {
      this.reset(), this.isSuspended = !1;
    });
    s(this, "reset", () => {
      this.lastIncreaseTime = Date.now();
    });
    s(this, "getStatistics", () => ({
      bufferTimeAdjustmentCount: this.bufferTimeAdjustmentCount
    }));
    s(this, "onBufferState", (e) => {
      const { minBufferTime: t, maxBufferTime: n, cooldownTime: r } = this.config;
      if (this.isSuspended || this.lastIncreaseTime + r > Date.now() || this.targetBufferTimeTarget.targetBufferTime >= n)
        return;
      const o = this.qualityOfServiceSource.timeSpentBufferingLast(30 * 1e3), a = this.qualityOfServiceSource.bufferingEventsLast(30 * 1e3), c = this.qualityOfServiceSource.timeSpentActiveLast(30 * 1e3), d = o / c, h = Math.ceil(
        Math.max(
          (n - t) / (ue.BUFFER_TIME_MAX_STEPS - 1),
          ue.BUFFER_TIME_STEP_SIZE
        )
      );
      (d > this.config.maxBufferingRatio.last30Seconds || a > this.config.maxBufferingEvents.last30Seconds) && (this.targetBufferTimeTarget.targetBufferTime = Math.min(
        n,
        this.targetBufferTimeTarget.targetBufferTime + h
      ), this.bufferTimeAdjustmentCount++, this.reset());
    });
    this.qualityOfServiceSource = n, this.targetBufferTimeTarget = r, this.config = g(g({}, Xr), o), this.emitter = e, this.logger = t;
  }
  updateConfig(e) {
    this.config = g(g({}, this.config), e);
  }
};
s(ue, "BUFFER_TIME_STEP_SIZE", 500), s(ue, "BUFFER_TIME_MAX_STEPS", 3), s(ue, "create", (e, t, n, r, o = {}) => new ue(e, t, n, r, o));
let Zt = ue;
class Wr extends pe {
  constructor(t, n) {
    super();
    s(this, "options");
    s(this, "websockets", []);
    s(this, "logger");
    s(this, "reconnectState", {
      reconnectRetries: 0
    });
    s(this, "isSuspended", !1);
    s(this, "_connectionAttemptCount", 0);
    s(this, "connectStartTime", 0);
    s(this, "_connectTime");
    s(this, "shouldContinueConnecting", !1);
    s(this, "_isConnectInProgress", !1);
    s(this, "readyState", () => {
      if (this.websockets.length === 0)
        return WebSocket.CLOSED;
      const t = this.websockets.map((n) => n.readyState);
      for (const n of t)
        switch (n) {
          case WebSocket.OPEN:
            continue;
          default:
            return n;
        }
      return WebSocket.OPEN;
    });
    s(this, "url", () => {
      var t;
      return (t = this.websockets[0]) == null ? void 0 : t.url;
    });
    s(this, "send", (t) => {
      var n;
      this.websockets.length && ((n = this.websockets[0]) == null || n.send(t));
    });
    s(this, "close", (t) => {
      var r;
      let n = !1;
      return (r = this.websockets) == null || r.forEach((o) => {
        o.onmessage = ce, o.removeEventListener("error", this.onError), o.removeEventListener("close", this.onClose), o.removeEventListener("open", this.onOpen), o.close(1e3, t), n = !0;
      }), this.websockets = [], this.shouldContinueConnecting = !1, this._isConnectInProgress = !1, this.logger.info("Closed websocket", { reason: t }), n;
    });
    s(this, "suspend", () => {
      this.isSuspended = !0;
    });
    s(this, "unsuspend", () => {
      this.isSuspended = !1, this.readyState() !== WebSocket.OPEN && !this.isConnectInProgress && this.connect();
    });
    s(this, "onMessage", (t, n) => {
      this.websockets.length !== 0 && this.options.onMessage(t, n.data);
    });
    s(this, "onError", () => {
      this.logger.info("On error", g({}, this.options)), this.close("one websocket had an error"), this.connect(!0);
    });
    s(this, "onClose", (t) => {
      switch (this.logger.info("Closed", L(g({}, this.options), {
        reason: t.reason,
        code: t.code,
        isSuspended: this.isSuspended
      })), this.close("one websocket was closed"), this.emit("close", this), t.code) {
        case 4e3:
          this.emit("error", ot(ze()));
          break;
        case 4001:
          this.emit("error", ot(ze()));
          break;
        case 4002:
          this.emit("error", an(ze()));
          break;
        case 4003:
          this.emit("error", Ji("internal", ze())), this.connect(!0);
          break;
        case 4010:
          this.emit("error", cn("internal", ze())), this.connect(!0);
          break;
        default:
          this.connect(!0);
      }
    });
    s(this, "onOpen", () => {
      this.logger.info("Opened", g({}, this.options)), this.readyState() === WebSocket.OPEN && (this._connectTime = Date.now() - this.connectStartTime, this.reconnectState.reconnectRetries = 0, this._isConnectInProgress = !1, this.emit("open", this));
    });
    /**
     * @returns a promise that resolves true if the connect steps succeeded
     * and false if any checks stopped the connection
     */
    s(this, "connect", (t = !1) => I(this, null, function* () {
      if (this.isConnectInProgress)
        return this.logger.info("Connect already in progress"), !1;
      if (this.isSuspended)
        return !1;
      if (this.readyState() !== WebSocket.CLOSED && this.close("new connection in progress"), this.shouldContinueConnecting = !0, this._isConnectInProgress = !0, t && this.options.reconnectDelay > 0) {
        this.logger.info("Waiting for reconnect delay", g({}, this.options)), yield Zi(this.options.reconnectDelay);
        const n = yield this.options.reconnectHandler(this.reconnectState);
        if (this.reconnectState.reconnectRetries++, !n)
          return this._isConnectInProgress = !1, this.emit("error", un()), !1;
      }
      this._connectionAttemptCount++;
      try {
        if (!this.shouldContinueConnecting)
          return this._isConnectInProgress = !1, this.logger.info("Connection aborted"), !1;
        const n = yield this.options.connectHandler();
        if (this.connectStartTime = Date.now(), !this.shouldContinueConnecting)
          return this._isConnectInProgress = !1, this.logger.info("Connection aborted"), !1;
        this.logger.info("Connecting websockets", L(g({}, this.options), { url: n }));
        for (let r = 0; r < this.options.connectionsCount; r++) {
          const o = new WebSocket(n);
          o.binaryType = "arraybuffer", o.onmessage = (a) => this.onMessage(r, a), o.addEventListener("error", this.onError), o.addEventListener("close", this.onClose), o.addEventListener("open", this.onOpen), this.websockets.push(o);
        }
        return !0;
      } catch (n) {
        return this._isConnectInProgress = !1, n instanceof b && (this.logger.error("Failed to connect", n.toStringifiable()), n.isFatal()) ? !1 : this.shouldContinueConnecting ? (this.logger.info("Connection aborted", { error: n }), this.connect(!0)) : !1;
      }
    }));
    this.options = t, this.logger = n;
  }
  get isConnectInProgress() {
    return this._isConnectInProgress;
  }
  get connectionCount() {
    return this.options.connectionsCount;
  }
  set connectionCount(t) {
    this.options.connectionsCount = t;
  }
  get connectionAttemptCount() {
    return this._connectionAttemptCount;
  }
  get connectTime() {
    return this._connectTime;
  }
}
const jr = 65536 * 8, Zr = 0.9, qt = (i) => jr * Zr * 1e3 / i, te = class te {
  constructor(e, t, n) {
    s(this, "timers", N.create());
    s(this, "emitter");
    s(this, "transport");
    s(this, "logger");
    s(this, "options");
    s(this, "rtts", new X(10));
    s(this, "lastPingSentTime", Date.now());
    s(this, "isPingInFlight", !1);
    s(this, "connectCount", 0);
    s(this, "_firstConnectionTime");
    s(this, "_lastConnectionTime");
    s(this, "missedPings", 0);
    s(this, "_connectionsCount", 2);
    s(this, "contextSwitchesInProgress", /* @__PURE__ */ new Set());
    s(this, "contextSwitchesCompleted", /* @__PURE__ */ new Set());
    s(this, "buffer", []);
    s(this, "unload", () => {
      this.logger.debug("Unloading module..."), this.disconnect("Unloading"), this.timers.unload(), this.emitter.off("send signal", this.sendSignal), this.emitter.off("disconnect", this.disconnect), this.emitter.off("reconnect", this.reconnect), this.logger.debug("Unloaded module");
    });
    s(this, "suspend", () => {
      var e;
      this.resetPingState(), (e = this.transport) == null || e.suspend();
    });
    s(this, "unsuspend", () => {
      var e;
      (e = this.transport) == null || e.unsuspend();
    });
    s(this, "getState", () => {
      var e;
      switch ((e = this.transport) == null ? void 0 : e.readyState()) {
        case WebSocket.OPEN:
          return "connected";
        case WebSocket.CONNECTING:
          return "connecting";
        default:
          return "disconnected";
      }
    });
    s(this, "sendSignal", (e) => {
      var t, n;
      if (this.logger.debug("sending signal", { signal: e }), ((t = this.transport) == null ? void 0 : t.readyState()) !== WebSocket.OPEN) {
        this.logger.debug("transport is closed");
        return;
      }
      (n = this.transport) == null || n.send(e);
    });
    s(this, "getStatistics", () => {
      var t, n, r;
      const e = xe(this.rtts.items());
      return {
        rtt: e,
        estimatedBandwidth: qt(e.average),
        edgeUrl: (t = this.transport) == null ? void 0 : t.url(),
        connectCount: this.connectCount,
        connectionAttemptCount: (r = (n = this.transport) == null ? void 0 : n.connectionAttemptCount) != null ? r : 0
      };
    });
    s(this, "onMessage", (e, t) => {
      var n;
      if (this.pingCooldownExpired() && this.sendPing(), this.contextSwitchesCompleted.size === ((n = this.transport) == null ? void 0 : n.connectionCount)) {
        this.logger.info("Completing context switch"), this.contextSwitchesInProgress.clear(), this.contextSwitchesCompleted.clear();
        const r = this.buffer.filter(([a, c]) => !(c instanceof ArrayBuffer)), o = this.buffer.filter(([a, c]) => c instanceof ArrayBuffer);
        r.map((a) => this.handleMessage(a[0], a[1])), o.map((a) => this.handleMessage(a[0], a[1])), this.buffer = [];
      }
      if (this.contextSwitchesInProgress.has(e)) {
        if (!(t instanceof ArrayBuffer)) {
          const r = JSON.parse(t);
          if (Ei(r) && r.type === "context switch complete") {
            this.logger.info("context switch completed", { socketId: e }), this.emitter.emit("context switch complete"), this.contextSwitchesCompleted.add(e);
            return;
          }
        }
        this.buffer.push([e, t]);
        return;
      }
      this.handleMessage(e, t);
    });
    s(this, "handleMessage", (e, t) => {
      if (t instanceof ArrayBuffer)
        this.emitter.emit("received data", t);
      else {
        const n = JSON.parse(t);
        if (!Ei(n))
          return;
        switch (n.type) {
          case "pong":
            this.lastPingSentTime && (this.rtts.push(Date.now() - this.lastPingSentTime), this.isPingInFlight = !1, this.emitter.emit("rtt", this.rtt));
            break;
          case "context switch":
            this.logger.info("Starting context switch", { socketId: e }), this.emitter.emit("context switch started"), this.contextSwitchesInProgress.add(e);
            break;
          default:
            this.emitter.emit("received signal", n);
            break;
        }
      }
    });
    s(this, "connect", (e) => {
      this.disconnect("user connected"), this._connectionsCount = e, this.transport = new Wr(
        {
          reconnectDelay: 1e3,
          connectionsCount: this._connectionsCount,
          onMessage: this.onMessage,
          reconnectHandler: this.options.reconnectHandler,
          connectHandler: this.options.connectHandler
        },
        this.logger.createContext("Transport")
      ), this.transport.on("open", this.onTransportChange), this.transport.on("close", this.onTransportChange), this.transport.on("error", (t) => this.emitter.emit("error", t)), this.transport.connect();
    });
    s(this, "onTransportChange", () => {
      var e;
      switch (this.getState()) {
        case "connected":
          (e = this.transport) != null && e.connectTime && (this.rtts.push(this.transport.connectTime / te.TLS_ROUNDTRIPS / this.transport.connectionCount), this.emitter.emit("rtt", this.rtt)), this._lastConnectionTime = Date.now(), this._firstConnectionTime || (this._firstConnectionTime = this._lastConnectionTime), this.connectCount++, this.resetPingState();
          break;
        default:
          this.contextSwitchesCompleted.clear(), this.contextSwitchesInProgress.clear(), this.buffer = [], this.resetPingState();
          break;
      }
      this.emitter.emit("connection state", this.getState());
    });
    s(this, "disconnect", (e = "Disconnect Requested") => {
      var t;
      this.contextSwitchesCompleted.clear(), this.contextSwitchesInProgress.clear(), this.buffer = [], this.resetPingState(), (t = this.transport) == null || t.close(e);
    });
    s(this, "reconnect", (e) => {
      var t;
      if ((t = this.transport) != null && t.isConnectInProgress) {
        this.logger.debug("Stopping reconnect, already mid-connection");
        return;
      }
      this.disconnect(e), this.connect(this._connectionsCount);
    });
    s(this, "resetPingState", () => {
      this.missedPings = 0, this.isPingInFlight = !1;
    });
    s(this, "pingCooldownExpired", () => Date.now() - this.lastPingSentTime > te.PING_INTERVAL);
    s(this, "sendPing", () => {
      if (this.isPingInFlight) {
        this.missedPings++, this.missedPings > te.MAX_MISSED_PINGS && this.reconnect("missed pings");
        return;
      }
      this.isPingInFlight = !0, this.lastPingSentTime = Date.now(), this.missedPings = 0, this.sendSignal(
        JSON.stringify({
          type: "ping"
        })
      );
    });
    this.logger = t, this.emitter = e, this.options = n, this.emitter.on("send signal", this.sendSignal), this.emitter.on("disconnect", this.disconnect), this.emitter.on("reconnect", this.reconnect);
  }
  get rtt() {
    return this.rtts.items().length > 0 ? et(this.rtts.items()) : 0;
  }
  get estimatedBandwidth() {
    return this.rtt > 0 ? qt(this.rtt) : void 0;
  }
  /**
   * The time taken to connect in milliseconds
   */
  get connectTime() {
    var e;
    return (e = this.transport) == null ? void 0 : e.connectTime;
  }
  /**
   * The timestamp when the first connection was made
   */
  get firstConnectionTime() {
    return this._firstConnectionTime;
  }
  /**
   * The timestamp when the last connection was made
   */
  get lastConnectionTime() {
    return this._lastConnectionTime;
  }
  setConnectionCount(e) {
    this._connectionsCount = e, this.transport && (this.transport.connectionCount = e);
  }
  getConnectionCount() {
    return this._connectionsCount;
  }
};
s(te, "PING_INTERVAL", 5e3), s(te, "MAX_MISSED_PINGS", 4), s(te, "TLS_ROUNDTRIPS", 3), s(te, "create", (e, t, n) => new te(e, t, n));
let Jt = te;
const Qt = () => ({
  video: L(g({}, rt()), {
    bitRate: ge()
  }),
  audio: {
    bitRate: ge()
  }
}), qr = () => ({
  width: window.innerWidth,
  height: window.innerHeight,
  bitRate: ge()
}), _e = class _e {
  constructor(e, t, n, r) {
    s(this, "emitter");
    s(this, "timers", new N());
    s(this, "pictureInPictureSource");
    s(this, "element");
    s(this, "currentCap");
    s(this, "userSpecifiedCap");
    s(this, "renditionLevelSource");
    s(this, "resizeObserver");
    s(this, "elementSize");
    s(this, "_sizeBasedResolutionCapEnabled");
    s(this, "unload", () => {
      var e;
      this.emitter.off("enter picture in picture", this.enterPictureInPicture), this.emitter.off("exit picture in picture", this.exitPictureInPicture), (e = this.resizeObserver) == null || e.disconnect(), this.suspend();
    });
    s(this, "load", () => {
      window.ResizeObserver && (this.resizeObserver = new ResizeObserver(this.onResize), this.resizeObserver.observe(this.element)), this.evaluateConstraintCap();
    });
    s(this, "unsuspend", () => {
      this.timers.setInterval(this.evaluateConstraintCap, _e.CHECK_SIZE_INTERVAL), this.evaluateConstraintCap();
    });
    s(this, "suspend", () => {
      this.timers.unload();
    });
    s(this, "setUserSpecifiedCap", (e) => {
      var n;
      const t = (n = this.getUserSpecifiedCap()) != null ? n : Qt();
      this.userSpecifiedCap = L(g({}, t), {
        video: g(g({}, t.video), e.video),
        audio: g(g({}, t.audio), e.audio)
      }), this.evaluateConstraintCap();
    });
    s(this, "getUserSpecifiedCap", () => this.userSpecifiedCap);
    s(this, "getCurrentConstraintCap", () => this.currentCap);
    s(this, "getStatistics", () => ({
      constraintCap: this.getUserSpecifiedCap(),
      windowInnerWidth: window.innerWidth,
      windowInnerHeight: window.innerHeight,
      elementWidth: this.elementSize.width,
      elementHeight: this.elementSize.height,
      pixelRatio: window.devicePixelRatio
    }));
    s(this, "constrainSubscription", (e) => {
      const t = this.getCurrentConstraintCap();
      return t && (e.video.codec && (e.video.bitRate = Math.min(t.video.bitRate, e.video.bitRate), e.video.width = Math.min(t.video.width, e.video.width), e.video.height = Math.min(t.video.height, e.video.height)), e.audio.codec && (e.audio.bitRate = Math.min(t.audio.bitRate, e.audio.bitRate))), e;
    });
    s(this, "onResize", (e) => {
      e.forEach((t) => {
        this.elementSize = { width: t.contentRect.width, height: t.contentRect.height };
      });
    });
    s(this, "evaluateConstraintCap", () => {
      var a, c, d, h, l;
      const e = this.sizeBasedResolutionCapEnabled ? L(g({}, Qt()), { video: qr() }) : Qt();
      if (!this.resizeObserver) {
        const m = this.element.getBoundingClientRect();
        this.elementSize = { width: m.width, height: m.height };
      }
      if (this.sizeBasedResolutionCapEnabled) {
        const m = window.devicePixelRatio, f = (a = this.pictureInPictureSource) == null ? void 0 : a.getPictureInPictureSize();
        this.elementSize.width > 0 && this.elementSize.height > 0 && (e.video.width = this.elementSize.width, e.video.height = this.elementSize.height), f && (e.video.width = f.width, e.video.height = f.height), e.video.width *= m, e.video.height *= m;
      }
      const n = this.renditionLevelSource.getRenditionLevels().find((m) => {
        if (m.video) {
          const f = m.video.width / m.video.height, p = e.video.width / e.video.height;
          return f > p ? m.video.width > e.video.width : m.video.height > e.video.height;
        }
      });
      n && n.video && (e.video.width = n.video.width, e.video.height = n.video.height);
      const r = (c = this.userSpecifiedCap) == null ? void 0 : c.video, o = (d = this.userSpecifiedCap) == null ? void 0 : d.audio;
      r && e.video.width > r.width && e.video.height > r.height && (e.video.width = r.width, e.video.height = r.height), e.video.bitRate = (h = r == null ? void 0 : r.bitRate) != null ? h : e.video.bitRate, e.audio.bitRate = (l = o == null ? void 0 : o.bitRate) != null ? l : e.audio.bitRate, Be(e, this.currentCap) ? this.currentCap = g({}, e) : (this.currentCap = g({}, e), this.emitter.emit("constraint cap changed", e));
    });
    s(this, "enterPictureInPicture", (e) => {
      this.pictureInPictureSource = e, this.evaluateConstraintCap();
    });
    s(this, "exitPictureInPicture", () => {
      this.pictureInPictureSource = void 0, this.evaluateConstraintCap();
    });
    this.element = t;
    const o = this.element.getBoundingClientRect();
    this.elementSize = { width: o.width, height: o.height }, this.emitter = e, this.renditionLevelSource = n, this._sizeBasedResolutionCapEnabled = r, this.emitter.on("enter picture in picture", this.enterPictureInPicture), this.emitter.on("exit picture in picture", this.exitPictureInPicture);
  }
  get sizeBasedResolutionCapEnabled() {
    return this._sizeBasedResolutionCapEnabled;
  }
  set sizeBasedResolutionCapEnabled(e) {
    this._sizeBasedResolutionCapEnabled = e, this.evaluateConstraintCap();
  }
};
s(_e, "CHECK_SIZE_INTERVAL", 1e3), s(_e, "create", (e, t, n, r) => new _e(e, t, n, r));
let Yt = _e;
const Jr = 5, Yr = 100, $r = 1e3;
class Ai {
  constructor(e, t, n, r) {
    s(this, "timers", N.create());
    s(this, "logger");
    s(this, "emitter");
    s(this, "trackContexts");
    s(this, "playbackSource");
    s(this, "isSuspended", !1);
    s(this, "load", () => {
      this.timers.setInterval(this.emitDecodedFrames, Yr), this.timers.setInterval(this.emitDecodeRate, $r), this.emitter.on("init segment", this.onInitSegment), this.emitter.on("coded sample", this.decode);
    });
    s(this, "unload", () => {
      this.trackContexts.forEach(({ decoderContext: e }) => e.unload()), this.timers.unload(), this.emitter.off("init segment", this.onInitSegment), this.emitter.off("coded sample", this.decode);
    });
    s(this, "suspend", () => {
      this.isSuspended = !0;
    });
    s(this, "unsuspend", () => {
      this.isSuspended = !1;
    });
    s(this, "getBuffer", (e) => {
      var t;
      return (t = this.trackContexts.get(e)) == null ? void 0 : t.buffer;
    });
    s(this, "videoDecodeRate", () => {
      var o, a, c;
      const e = this.trackContexts.get("video"), t = (o = e == null ? void 0 : e.sampleDuration) != null ? o : 40, n = xe((a = e == null ? void 0 : e.decodeTime.items()) != null ? a : []), r = xe((c = e == null ? void 0 : e.transportTime.items()) != null ? c : []);
      return t / (n.average + r.average);
    });
    s(this, "getStatistics", () => {
      var o, a, c, d;
      const e = this.trackContexts.get("video"), t = xe((o = e == null ? void 0 : e.decodeTime.items()) != null ? o : []), n = xe((a = e == null ? void 0 : e.transportTime.items()) != null ? a : []), r = xe((d = (c = this.trackContexts.get("audio")) == null ? void 0 : c.decodeTime.items()) != null ? d : []);
      return {
        videoDecodeRate: this.videoDecodeRate(),
        videoDecodeTime: t,
        audioDecodeTime: r,
        videoTransportTime: n
      };
    });
    s(this, "onInitSegment", ({ initSegment: e }) => {
      var n;
      const t = (n = this.trackContexts.get(e.type)) == null ? void 0 : n.decoderContext;
      if (!t)
        throw new b("No known decoder context", {
          code: "no_known_decoder_context",
          isFatal: !1
        });
      t.initSegment(e);
    });
    s(this, "decode", (e) => {
      const t = this.trackContexts.get(e.type);
      if (!t)
        throw new b("No known decoder context", {
          code: "no_known_decoder_context",
          isFatal: !1
        });
      if (this.isSuspended)
        return;
      t.sampleDuration = e.duration / e.timescale * 1e3;
      const { decoderContext: n, buffer: r } = t, o = e.timestamp / e.timescale * 1e3, a = e.duration / e.timescale * 1e3, c = r[r.length - 1];
      !c || o - Jr > c.end ? r.push({ start: o, end: o + a }) : o + a * 5 < c.end ? t.buffer = [{ start: o, end: o + a }] : c.end = o + a, n.enqueue(e), this.emitDecodedFrames();
    });
    s(this, "emitDecodedFrames", () => {
      let e;
      this.updateBufferState(), this.trackContexts.forEach((t) => {
        var r, o;
        let n;
        for (; (n = (o = (r = t.decoderContext).error) == null ? void 0 : o.call(r)) !== void 0; )
          this.emitter.emit("error", sn(!1, n));
        for (; (e = t.decoderContext.take()) !== void 0; ) {
          const { statistics: a } = e;
          a && (t.decodeTime.push(a.decodeTime), t.transportTime.push(
            (a.transportTimeToWorker + a.transportTimeFromWorker) / a.samplesInBatch
          )), this.emitter.emit("decoded frame", e);
        }
      });
    });
    s(this, "emitDecodeRate", () => {
      this.emitter.emit("video decode rate", this.videoDecodeRate());
    });
    s(this, "updateBufferState", () => {
      var o, a;
      let e;
      if (this.trackContexts.forEach((c) => {
        var d, h, l, m;
        if (!e)
          e = c.buffer;
        else {
          const f = (h = (d = c.buffer[c.buffer.length - 1]) == null ? void 0 : d.end) != null ? h : 0;
          ((m = (l = e[e.length - 1]) == null ? void 0 : l.end) != null ? m : 0) > f && (e = c.buffer);
        }
      }), !e)
        return;
      const t = this.playbackSource.currentTime, n = (a = (o = e[e.length - 1]) == null ? void 0 : o.end) != null ? a : 0, r = t < n ? "playing" : "buffering";
      this.emitter.emit("buffer state", {
        buffered: e,
        currentTime: this.playbackSource.currentTime,
        isPaused: this.playbackSource.isPaused,
        playbackState: r
      });
    });
    this.logger = t, this.emitter = e, this.trackContexts = n, this.playbackSource = r;
  }
  static create(e, t, n, r, o) {
    return I(this, null, function* () {
      const a = /* @__PURE__ */ new Map();
      for (const c of n)
        switch (c.type) {
          case "audio": {
            const { OpusDecoderContext: d } = yield import("./BzSm3HsC.js");
            a.set(c.type, {
              buffer: [],
              decoderContext: yield d.create(48e3, 2),
              decodeTime: new X(100),
              transportTime: new X(100),
              sampleDuration: 40
            });
            break;
          }
          case "video": {
            const { H264DecoderWorkerContext: d } = yield import("./C291RiDK.js");
            a.set(c.type, {
              buffer: [],
              decoderContext: yield d.create(o),
              decodeTime: new X(100),
              transportTime: new X(100),
              sampleDuration: 40
            });
            break;
          }
        }
      return new Ai(e, t, a, r);
    });
  }
}
const mt = class mt {
  constructor(e) {
    s(this, "emitter");
    s(this, "isVisibleCount", 0);
    s(this, "isHiddenCount", 0);
    s(this, "isOnlineCount", 0);
    s(this, "isOfflineCount", 0);
    s(this, "isActive", document.visibilityState === "visible");
    s(this, "unload", () => {
      document.removeEventListener("visibilitychange", this.onVisibilityChanged), window.removeEventListener("pagehide", this.onPageHide), window.removeEventListener("online", this.onOnline), window.removeEventListener("offline", this.onOffline);
    });
    s(this, "load", () => {
      document.addEventListener("visibilitychange", this.onVisibilityChanged), window.addEventListener("pagehide", this.onPageHide), window.addEventListener("online", this.onOnline), window.addEventListener("offline", this.onOffline);
    });
    s(this, "unsuspend", () => {
    });
    s(this, "getStatistics", () => {
      var e, t, n, r, o;
      return {
        isVisible: this.isVisible,
        isOnline: this.isOnline,
        isVisibleCount: this.isVisibleCount,
        isHiddenCount: this.isHiddenCount,
        isOnlineCount: this.isOnlineCount,
        isOfflineCount: this.isOfflineCount,
        navigatorRtt: (e = navigator.connection) == null ? void 0 : e.rtt,
        navigatorEffectiveType: (t = navigator.connection) == null ? void 0 : t.effectiveType,
        navigatorConnectionType: (n = navigator.connection) == null ? void 0 : n.type,
        navigatorSaveData: (r = navigator.connection) == null ? void 0 : r.saveData,
        navigatorDownlink: (o = navigator.connection) == null ? void 0 : o.downlink
      };
    });
    s(this, "onOnline", () => this.isOnlineCount++);
    s(this, "onOffline", () => this.isOfflineCount++);
    s(this, "onPageHide", (e) => this.emitter.emit("pagehide", e));
    s(this, "onVisibilityChanged", () => {
      this.setIsActive(document.visibilityState === "visible");
    });
    s(this, "setIsActive", (e) => {
      e !== this.isActive && (this.emitter.emit("page active", e), e ? this.isVisibleCount++ : this.isHiddenCount++), this.isActive = e;
    });
    this.emitter = e;
  }
  get isOnline() {
    return navigator.onLine;
  }
  get isVisible() {
    return document.visibilityState === "visible";
  }
};
s(mt, "create", (e) => new mt(e));
let $t = mt;
const Kr = (i) => (e, t, n) => e.timestamp <= t || e.timestampAdded <= n - i, le = class le {
  constructor(e, t, n) {
    s(this, "logger");
    s(this, "emitter");
    s(this, "waitingEvents", []);
    s(this, "isTriggered", Kr(le.EVENT_TIMEOUT));
    s(this, "timeSource");
    s(this, "timers", new N());
    s(this, "load", () => {
      this.timers.setInterval(this.onBufferedStateChanged, le.EVENT_CHECK_INTERVAL);
    });
    s(this, "unload", () => {
      this.timers.unload();
    });
    s(this, "addEvent", (e) => {
      this.logger.debug("Adding event", { event: e }), this.waitingEvents.push(L(g({}, e), { timestampAdded: Date.now() }));
    });
    s(this, "extractEvent", (e, t) => {
      t.type === "video" && e.channelId !== t.channelId && this.addEvent({
        type: "channel switch",
        channelId: t.channelId,
        timestamp: t.timestamp / t.timescale * 1e3
      }), t.type === "audio" && e.type === "audio" && t.language !== void 0 && t.language !== e.language && this.addEvent({
        type: "language switch",
        language: t.language,
        timestamp: t.timestamp / t.timescale * 1e3
      });
    });
    s(this, "onBufferedStateChanged", () => {
      var o;
      const e = Date.now(), t = (o = this.timeSource.drift) != null ? o : 0, n = this.timeSource.serverCurrentTime - t;
      if (this.waitingEvents.length === 0)
        return;
      const r = this.waitingEvents.filter((a) => this.isTriggered(a, n, e));
      this.waitingEvents = this.waitingEvents.filter((a) => !this.isTriggered(a, n, e)), r.forEach((a) => {
        this.logger.debug("Emitting event", { event: a }), this.emitter.emit("event", a);
      });
    });
    this.logger = t, this.emitter = e, this.timeSource = n;
  }
};
s(le, "EVENT_TIMEOUT", 5e3), s(le, "EVENT_CHECK_INTERVAL", 20), s(le, "create", (e, t, n) => new le(e, t, n));
let Kt = le;
const $ = class $ {
  constructor(e) {
    s(this, "emitter");
    s(this, "timers", N.create());
    s(this, "bytesReceived", /* @__PURE__ */ new Map());
    s(this, "timeoutInterval");
    s(this, "lastBytesUpdated", Date.now());
    s(this, "load", () => {
      this.emitter.on("connection state", this.onConnectionState), this.timers.setInterval(() => this.bytesReceived.forEach((e) => e.tick()), 100);
    });
    s(this, "unload", () => {
      this.emitter.off("connection state", this.onConnectionState), this.timers.unload();
    });
    s(this, "averageBitRate", (e) => {
      var t, n;
      return ((n = (t = this.bytesReceived.get(e)) == null ? void 0 : t.average) != null ? n : 0) * 8;
    });
    s(this, "totalBytesReceived", () => {
      let e = 0;
      return this.bytesReceived.forEach((t) => {
        e += t.total;
      }), e;
    });
    s(this, "add", (e, t) => {
      let n = this.bytesReceived.get(e);
      n || (n = new _s(20), this.bytesReceived.set(e, n)), t > 0 && (this.lastBytesUpdated = Date.now(), this.timeoutInterval || (this.timeoutInterval = this.timers.setInterval(
        this.checkTimeout,
        $.UPDATE_RECEIVED_BYTES_INTERVAL
      ))), n.add(t);
    });
    s(this, "getStatistics", () => ({
      bytesReceived: this.totalBytesReceived(),
      videoBitRate: this.averageBitRate("video"),
      audioBitRate: this.averageBitRate("audio")
    }));
    s(this, "onConnectionState", (e) => {
      this.clearTimeoutInterval(), e === "connected" && (this.lastBytesUpdated = Date.now(), this.timeoutInterval = this.timers.setInterval(
        this.checkTimeout,
        $.UPDATE_RECEIVED_BYTES_INTERVAL
      ));
    });
    s(this, "checkTimeout", () => {
      const e = Date.now() - this.lastBytesUpdated;
      if (this.totalBytesReceived() === 0 && e > $.NO_DATA_ERROR_TIMEOUT) {
        this.emitter.emit("error", dn()), this.emitter.emit("reconnect", "no incoming data"), this.clearTimeoutInterval();
        return;
      }
      e > $.NO_DATA_TIMEOUT && this.totalBytesReceived() > 0 && (this.emitter.emit("no data timeout", this.totalBytesReceived()), this.clearTimeoutInterval());
    });
    s(this, "clearTimeoutInterval", () => {
      this.timeoutInterval && (this.timers.clearInterval(this.timeoutInterval), this.timeoutInterval = void 0);
    });
    this.emitter = e;
  }
};
s($, "NO_DATA_ERROR_TIMEOUT", 20 * 1e3), s($, "NO_DATA_TIMEOUT", 5 * 1e3), s($, "UPDATE_RECEIVED_BYTES_INTERVAL", 1e3), s($, "create", (e) => new $(e));
let ei = $;
const eo = () => window.AudioContext || window.webkitAudioContext, At = class At extends pe {
  constructor() {
    super();
    // TODO: Checkout what happens when limit is reached
    s(this, "context", new (eo())());
    s(this, "timers", N.create());
    s(this, "previousCurrentTime", 0);
    s(this, "_isStuck", !1);
    s(this, "mediaStreamDestination");
    s(this, "unload", () => (this.timers.unload(), this.context.removeEventListener("statechange", this.onStateChange), this.context.state !== "closed" ? this.context.close() : Promise.resolve()));
    s(this, "createGain", () => this.context.createGain());
    s(this, "createBuffer", (t, n, r) => this.context.createBuffer(t, n, r));
    s(this, "createBufferSource", () => this.context.createBufferSource());
    s(this, "getMediaStreamDestination", () => (this.mediaStreamDestination || (this.mediaStreamDestination = this.context.createMediaStreamDestination()), this.mediaStreamDestination));
    s(this, "getDefaultDestination", () => this.context.destination);
    s(this, "resume", () => I(this, null, function* () {
      try {
        return yield Promise.race([this.context.resume(), Os(1e3, on())]);
      } catch (t) {
        throw this.suspend().catch(ce), t;
      }
    }));
    s(this, "suspend", () => I(this, null, function* () {
      var t;
      yield (t = this.context.suspend()) != null ? t : Promise.resolve();
    }));
    s(this, "onStateChange", () => this.emit("state", this.state));
    this.context.addEventListener("statechange", this.onStateChange), this.timers.setInterval(() => {
      this._isStuck = this.isRunning && this.context.currentTime === this.previousCurrentTime, this._isStuck && this.emit("stuck"), this.previousCurrentTime = this.context.currentTime;
    }, At.CHECK_INTERVAL);
  }
  get isStuck() {
    return this._isStuck;
  }
  get isRunning() {
    return this.state === "running";
  }
  get currentTime() {
    return this.context.currentTime;
  }
  get sampleRate() {
    return this.context.sampleRate;
  }
  get state() {
    return this.context.state;
  }
};
s(At, "CHECK_INTERVAL", 1e3);
let ti = At;
const ft = class ft extends pe {
  constructor(t, n, { muted: r, reInitWhenStuck: o }) {
    super();
    s(this, "logger");
    s(this, "audio");
    s(this, "gainNode");
    s(this, "_volume", 1);
    s(this, "_userProvidedMuted", !1);
    s(this, "_muted", !1);
    s(this, "startTime", 0);
    // TODO: Re-initialize if channels or sample rate changes
    s(this, "samples", new Float32Array(new ArrayBuffer(5 * 960 * 4 * 2)));
    // 100 ms flush interval
    // 500 samples == max 10 seconds buffer for instant activation of audio (assuming that each sample has 960 samples and 48000hz)
    s(this, "preInitSampleQueue", new X(500));
    s(this, "unplayedBufferSources", new X(100));
    s(this, "sampleRate", 48e3);
    s(this, "channels", 2);
    s(this, "index", 0);
    s(this, "clockSource");
    s(this, "clockDelta");
    s(this, "startTimeIsInvalidated", !0);
    s(this, "lastSampleTimestamp", 0);
    s(this, "reInitWhenStuck");
    s(this, "ignoreSuspendCalls", !1);
    s(this, "isActivated", !1);
    s(this, "unload", () => I(this, null, function* () {
      var t, n;
      (t = this.gainNode) == null || t.disconnect(), yield (n = this.audio) == null ? void 0 : n.unload(), this.reset(), this.audio = void 0, this.gainNode = void 0;
    }));
    s(this, "suspend", () => {
      this.setGain(0);
    });
    s(this, "unsuspend", () => {
      var t;
      this.setGain(this._volume), this.ignoreSuspendCalls = !!this.audio, (t = this.audio) == null || t.suspend().then(() => I(this, null, function* () {
        yield this.resume(), this.ignoreSuspendCalls = !1;
      })).catch(() => {
        this.ignoreSuspendCalls = !1, this.emit("state change", "suspended");
      });
    });
    s(this, "flush", () => {
      if (!this.audio || !this.gainNode)
        throw new b("AudioContext must be initialized to flush", {
          isFatal: !1,
          code: "audiocontext_must_be_initialized"
        });
      const t = this.samples.length / this.channels, n = this.audio.createBufferSource(), r = this.audio.createBuffer(this.channels, t, this.sampleRate);
      let o = 0;
      for (let c = 0; c < this.channels; c++) {
        o = c;
        const d = r.getChannelData(c);
        for (let h = 0; h < t; h++)
          d[h] = this.samples[o], o += this.channels;
      }
      const a = Math.max(this.startTime, 0);
      n.buffer = r, n.connect(this.gainNode), n.start(a), this.unplayedBufferSources.push([a, n]), this.startTime += r.duration;
    });
    s(this, "onDecodedFrame", (t) => {
      if (!(this.gainNode && this.audio && this.audio.isRunning)) {
        if (t.type === "audio") {
          this.preInitSampleQueue.push(L(g({}, t), { data: t.data.slice(0, t.data.length) }));
          const n = this.clockSource.currentTime;
          this.preInitSampleQueue.filterPop(({ timestamp: r, timescale: o }) => r / o * 1e3 > n);
        }
        return;
      }
      for (; !this.preInitSampleQueue.isEmpty(); ) {
        const n = this.preInitSampleQueue.items();
        this.preInitSampleQueue.clear(), n.forEach(this.onDecodedFrame);
      }
      if (this.unplayedBufferSources.filterPop(([n, r]) => {
        var o, a;
        return ((a = (o = this.audio) == null ? void 0 : o.currentTime) != null ? a : 0) < n;
      }), t.type === "audio") {
        const n = t.timestamp / t.timescale * 1e3;
        if (n < this.lastSampleTimestamp && (this.logger.info("Unordered timestamp - invalidating start time"), this.startTimeIsInvalidated = !0), this.lastSampleTimestamp = n, this.startTimeIsInvalidated) {
          const r = this.audio.currentTime * 1e3, o = this.clockSource.currentTime, a = (r + n - o) / 1e3;
          this.clockDelta = o - r, this.startTime = a, this.startTimeIsInvalidated = !1, this.unplayedBufferSources.items().forEach(([c, d]) => {
            a <= c && d.stop();
          });
        }
        this.samples.set(t.data, this.index), this.index += t.data.length, this.channels = t.channels, this.sampleRate = t.sampleRate, this.samples.length <= this.index && (this.index = 0, this.flush());
      }
    });
    // Left empty since we don't do anything without user input
    s(this, "play", () => I(this, null, function* () {
      this.audio = this.getAudioContext(), yield this.resume();
    }));
    s(this, "pause", () => {
    });
    s(this, "flushBuffer", () => {
      this.unplayedBufferSources.items().forEach(([t, n]) => n.stop()), this.index = 0;
    });
    s(this, "resume", () => I(this, null, function* () {
      var t;
      if (!this._userProvidedMuted)
        try {
          yield (t = this.audio) == null ? void 0 : t.resume(), this._muted = this._userProvidedMuted, this.startTimeIsInvalidated = !0;
        } catch (n) {
          throw this._muted = !0, n;
        }
    }));
    /**
     * We create the web audio context only when requested in order to avoid using up the max allowed audio contexts per page
     */
    s(this, "getAudioContext", () => this.audio ? this.audio : this.setupContext());
    s(this, "setupContext", () => {
      var t, n;
      return (t = this.audio) == null || t.unload(), this.audio = new ti(), this.audio.on("state", (r) => {
        this.logger.info("AudioContext state change", { state: r }), r === "running" && (this._muted = this._userProvidedMuted, this.setGain(this._volume)), !this.ignoreSuspendCalls && this.emit("state change", r);
      }), this.audio.on("stuck", () => {
        this.reInitWhenStuck && (this.logger.info("Re-init audio context"), this.setupContext(), this.resume().catch(ce), this.emit("stuck"));
      }), (n = this.gainNode) == null || n.disconnect(), this.gainNode = this.audio.createGain(), this.setGain(this._volume), this.startTime = this.audio.currentTime, this.audio;
    });
    s(this, "setGain", (t) => {
      this.gainNode && (this.gainNode.gain.value = this._muted ? 0 : t);
    });
    this._muted = r, this._userProvidedMuted = r, this.logger = t, this.clockSource = n, this.reInitWhenStuck = o;
  }
  get isContextRunning() {
    var t;
    return ((t = this.audio) == null ? void 0 : t.state) === "running";
  }
  get volume() {
    return this._volume;
  }
  set volume(t) {
    this._volume = t, this.muted || this.setGain(t);
  }
  get seekTime() {
    return 0;
  }
  get isSeeking() {
    return !1;
  }
  get muted() {
    var t;
    return this._muted || !((t = this.audio) != null && t.isRunning);
  }
  set muted(t) {
    this._userProvidedMuted = t, this._muted = t, this.setGain(this._volume);
  }
  get isPaused() {
    return !1;
  }
  get currentTime() {
    var t;
    return !this.audio || !this.audio.isRunning || this.audio.isStuck ? this.clockSource.currentTime : this.audio.currentTime * 1e3 + ((t = this.clockDelta) != null ? t : 0);
  }
  set currentTime(t) {
    this.logger.debug("setting current time to", { currentTime: t }), this.startTimeIsInvalidated = !0;
  }
  useMediaStreamDestination() {
    var r;
    const n = this.getAudioContext().getMediaStreamDestination();
    return (r = this.gainNode) == null || r.connect(n), n;
  }
  useDefaultDestination() {
    var r;
    const n = this.getAudioContext().getDefaultDestination();
    return (r = this.gainNode) == null || r.connect(n), n;
  }
};
s(ft, "create", (t, n, r) => new ft(t, n, r));
let at = ft;
var Ae;
class ss {
  constructor() {
    R(this, Ae, []);
    _(this, Ae, []);
  }
  addTextTrack(e, t, n) {
    const r = [], o = {
      kind: e,
      label: t,
      language: n,
      mode: "disabled",
      cues: r,
      addCue: (a) => {
        r.push(a);
      },
      removeCue: (a) => {
        const c = r.findIndex((d) => d === a);
        c !== -1 && r.splice(c, 1);
      }
    };
    return u(this, Ae).push(o), o;
  }
  set language(e) {
    u(this, Ae).forEach((t) => {
      t.language === e ? t.mode = "showing" : t.mode = "hidden";
    });
  }
  get language() {
    var e;
    return (e = u(this, Ae).find((t) => t.mode === "showing")) == null ? void 0 : e.language;
  }
  getActiveCues(e) {
    const t = u(this, Ae).find((n) => n.mode === "showing");
    return t ? t.cues.filter(({ startTime: n, endTime: r }) => e >= n && e <= r) : [];
  }
}
Ae = new WeakMap();
const we = (i, e) => {
  let t;
  for (t = e; i > 1; i--) t += e;
  return t;
};
class to {
  constructor() {
    s(this, "audio");
    s(this, "unmute", () => this.audio.play().catch(ce));
    const e = document.createElement("div");
    e.innerHTML = "<audio x-webkit-airplay='deny'></audio>";
    const t = e.children.item(0);
    if (t instanceof HTMLAudioElement)
      this.audio = t, this.audio.controls = !1, this.audio.disableRemotePlayback = !0, this.audio.preload = "auto", this.audio.src = "data:audio/mpeg;base64,//uQx" + we(23, "A") + "WGluZwAAAA8AAAACAAACcQCA" + we(16, "gICA") + we(66, "/") + "8AAABhTEFNRTMuMTAwA8MAAAAAAAAAABQgJAUHQQAB9AAAAnGMHkkI" + we(320, "A") + "//sQxAADgnABGiAAQBCqgCRMAAgEAH" + we(15, "/") + "7+n/9FTuQsQH//////2NG0jWUGlio5gLQTOtIoeR2WX////X4s9Atb/JRVCbBUpeRUq" + we(18, "/") + "9RUi0f2jn/+xDECgPCjAEQAABN4AAANIAAAAQVTEFNRTMuMTAw" + we(97, "V") + "Q==", this.audio.loop = !1, this.audio.load();
    else
      throw new Error("Failed to create audio tag");
  }
}
var qe, ie, V, ye, J, ns, Le, rs;
class io {
  constructor() {
    R(this, J);
    R(this, qe, []);
    R(this, ie, document.createElement("canvas"));
    R(this, V);
    R(this, ye, window.devicePixelRatio || 1);
    s(this, "config", {
      backgroundColor: "rgba(0,0,0,0.6)",
      textPadding: 8,
      fontSize: "28px",
      lineGap: 16
    });
    const e = u(this, ie).getContext("2d", { alpha: !0 });
    if (!e)
      throw new Error("Failed to create 2d context");
    _(this, V, e), W(this, J, Le).call(this);
  }
  get canvas() {
    return u(this, ie);
  }
  setActiveCues(e) {
    _(this, qe, e);
  }
  render(e, t = !1) {
    const n = u(this, qe).flatMap((c) => c.text.split(`
`).flatMap((h) => W(this, J, rs).call(this, h, e.width)).map((h) => {
      W(this, J, Le).call(this);
      const l = u(this, V).measureText(h);
      return {
        text: h,
        measurement: l,
        size: {
          height: l.fontBoundingBoxAscent + l.fontBoundingBoxDescent + this.config.textPadding * 2,
          width: l.width + this.config.textPadding * 2
        }
      };
    })), r = Math.max(...n.map((c) => c.size.width)), o = n.reduce((c, { size: d }) => c + d.height, 0) + (n.length - 1) * this.config.lineGap;
    let a = 0;
    W(this, J, ns).call(this, r, o), u(this, V).clearRect(0, 0, u(this, ie).width, u(this, ie).height);
    for (const { size: c, text: d } of n)
      W(this, J, Le).call(this), u(this, V).fillStyle = this.config.backgroundColor, u(this, V).fillRect(0, a, c.width, c.height), W(this, J, Le).call(this), u(this, V).fillText(d, this.config.textPadding, a + this.config.textPadding), a += c.height + this.config.lineGap;
    t && (u(this, V).strokeStyle = "red", u(this, V).strokeRect(0, 0, e.width, u(this, ie).height));
  }
}
qe = new WeakMap(), ie = new WeakMap(), V = new WeakMap(), ye = new WeakMap(), J = new WeakSet(), ns = function(e, t) {
  u(this, ie).width = e * u(this, ye), u(this, ie).height = t * u(this, ye), u(this, V).scale(u(this, ye), u(this, ye)), this.canvas.style.width = `${e}px`, this.canvas.style.height = `${t}px`;
}, Le = function() {
  u(this, V).fillStyle = "white", u(this, V).textAlign = "left", u(this, V).textBaseline = "top", u(this, V).font = `${this.config.fontSize} sans-serif`;
}, rs = function(e, t) {
  const n = [], r = e.split(" ");
  let o = "";
  for (; r.length > 0; ) {
    W(this, J, Le).call(this);
    let a = 0;
    for (; u(this, V).measureText(o + (o.length > 0 ? " " : "") + r[0]).width + this.config.textPadding * 2 <= t && r.length > 0; )
      a++, o += (o.length > 0 ? " " : "") + r.shift();
    if (a == 0) {
      n.push(r.shift() || ""), o = "";
      continue;
    }
    n.push(o), o = "";
  }
  return n;
};
const so = `
precision mediump float;
uniform sampler2D texture;

varying vec2 texture_coordinate;

void main() {
  float y = texture2D(texture, texture_coordinate).r;
  float a = texture2D(texture, texture_coordinate).a;

  gl_FragColor = vec4(y, y, y, a);
}
`, no = `
  attribute vec2 position;
  varying vec2 texture_coordinate;
  uniform mat4 model;

  void main() {
    texture_coordinate = position;
    gl_Position = model * vec4(position, 0.0, 1.0);
  }
`, Li = (i, e) => {
  let t = i.getContext("webgl", e);
  if (t || (t = i.getContext("experimental-webgl", e)), !t)
    throw new b("Failed to create webgl context", {
      isFatal: !0,
      code: "failed_to_create_web_gl_context"
    });
  return t;
}, Ue = (i, e, t) => {
  const n = i.createShader(e);
  if (!n)
    throw new b("Failed to create shader", { isFatal: !0, code: "failed_to_create_shader" });
  if (i.shaderSource(n, t), i.compileShader(n), !i.getShaderParameter(n, i.COMPILE_STATUS)) {
    const r = i.getShaderInfoLog(n);
    throw new b(`Failed to compile shader: ${r != null ? r : ""}`, {
      isFatal: !0,
      code: "failed_to_compile_shader"
    });
  }
  return n;
}, ve = (i) => {
  const e = i.createTexture();
  if (!e)
    throw new b("Failed to create texture", {
      isFatal: !0,
      code: "failed_to_create_texture"
    });
  return i.bindTexture(i.TEXTURE_2D, e), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MAG_FILTER, i.NEAREST), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MIN_FILTER, i.NEAREST), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_S, i.CLAMP_TO_EDGE), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_T, i.CLAMP_TO_EDGE), e;
}, Mi = (i, e) => {
  const t = i.createBuffer();
  if (!t)
    throw new b("Failed to create buffer", {
      isFatal: !0,
      code: "failed_to_create_buffer"
    });
  return i.bindBuffer(i.ARRAY_BUFFER, t), i.bufferData(i.ARRAY_BUFFER, e.buffer, i.STATIC_DRAW), t;
}, ii = (i, e, t) => {
  const n = i.createProgram();
  if (!n)
    throw new b("Failed to create program", {
      isFatal: !0,
      code: "failed_to_create_program"
    });
  if (i.attachShader(n, t), i.attachShader(n, e), i.linkProgram(n), !i.getProgramParameter(n, i.LINK_STATUS)) {
    const r = i.getShaderInfoLog(n);
    throw new b(`Failed to link program: ${r != null ? r : ""}`, {
      isFatal: !0,
      code: "failed_to_link_program"
    });
  }
  return n;
};
var gt, y, Je, Ye, $e, fe, Ve, os, as, pt;
class ro {
  constructor(e) {
    R(this, Ve);
    R(this, gt, 96);
    R(this, y);
    R(this, Je);
    R(this, Ye);
    R(this, $e);
    R(this, fe);
    s(this, "subtitleRenderer", new io());
    // prettier-ignore
    R(this, pt, (e, t, n, r) => [
      e,
      0,
      0,
      0,
      0,
      -t,
      0,
      0,
      0,
      0,
      1,
      0,
      n,
      r,
      0,
      1
    ]);
    _(this, y, e), _(this, Je, ve(e)), _(this, Ye, Ue(e, e.FRAGMENT_SHADER, so)), _(this, $e, Ue(e, e.VERTEX_SHADER, no)), _(this, fe, ii(e, u(this, $e), u(this, Ye))), this.subtitleRenderer.config.fontSize = "64px";
  }
  setActiveCues(e, t) {
    this.subtitleRenderer.setActiveCues(e), this.subtitleRenderer.render(t);
  }
  render(e) {
    const t = this.subtitleRenderer.canvas, n = (e.padding + u(this, gt)) * window.devicePixelRatio;
    t.width !== 0 && (u(this, y).useProgram(u(this, fe)), W(this, Ve, os).call(this), W(this, Ve, as).call(this, this.subtitleRenderer.canvas.width / e.width, this.subtitleRenderer.canvas.height / e.height, -this.subtitleRenderer.canvas.width / e.width / 2, -(1 - (this.subtitleRenderer.canvas.height + n) / e.height)), u(this, y).uniform1i(u(this, y).getUniformLocation(u(this, fe), "texture"), 4), u(this, y).activeTexture(u(this, y).TEXTURE4), u(this, y).bindTexture(u(this, y).TEXTURE_2D, u(this, Je)), u(this, y).enable(u(this, y).BLEND), u(this, y).blendFunc(u(this, y).SRC_ALPHA, u(this, y).ONE_MINUS_SRC_ALPHA), u(this, y).texImage2D(
      u(this, y).TEXTURE_2D,
      0,
      u(this, y).RGBA,
      u(this, y).RGBA,
      u(this, y).UNSIGNED_BYTE,
      t
    ), u(this, y).texParameteri(u(this, y).TEXTURE_2D, u(this, y).TEXTURE_MAG_FILTER, u(this, y).LINEAR), u(this, y).drawArrays(u(this, y).TRIANGLE_STRIP, 0, 4));
  }
}
gt = new WeakMap(), y = new WeakMap(), Je = new WeakMap(), Ye = new WeakMap(), $e = new WeakMap(), fe = new WeakMap(), Ve = new WeakSet(), os = function() {
  const e = u(this, y).getAttribLocation(u(this, fe), "position");
  u(this, y).enableVertexAttribArray(e), u(this, y).vertexAttribPointer(e, 2, u(this, y).FLOAT, !1, 0, 0);
}, as = function(e, t, n, r) {
  const o = u(this, y).getUniformLocation(u(this, fe), "model");
  u(this, y).uniformMatrix4fv(o, !1, u(this, pt).call(this, e, t, n, r));
}, pt = new WeakMap();
const Ui = `
precision mediump float;
uniform sampler2D y_texture;
uniform sampler2D u_texture;
uniform sampler2D v_texture;
uniform mat4 conversion;

varying vec2 texture_coordinate;

void main() {
  float y = texture2D(y_texture, texture_coordinate).r;
  float u = texture2D(u_texture, texture_coordinate).r;
  float v = texture2D(v_texture, texture_coordinate).r;

  gl_FragColor = vec4(y, u, v, 1) * conversion;
}
`, _i = `
  attribute vec2 position;
  varying vec2 texture_coordinate;
  uniform mat4 model;

  void main() {
    texture_coordinate = position;
    gl_Position = model * vec4(position, 0.0, 1.0);
  }
`, Di = {
  width: 256,
  codedWidth: 256,
  height: 144,
  codedHeight: 144
}, Oi = {
  preserveDrawingBuffer: !1,
  alpha: !1,
  depth: !1,
  stencil: !1,
  antialias: !1,
  premultipliedAlpha: !1
}, Xe = class Xe extends pe {
  constructor() {
    super();
    s(this, "canvas", document.createElement("canvas"));
    s(this, "context", Li(this.canvas, Oi));
    s(this, "pixelShader", Ue(this.context, this.context.FRAGMENT_SHADER, Ui));
    s(this, "vertexShader", Ue(this.context, this.context.VERTEX_SHADER, _i));
    s(this, "buffer", Mi(this.context, Xe.SQUARE_VERTICES));
    s(this, "program", ii(this.context, this.vertexShader, this.pixelShader));
    s(this, "textures", {
      y: ve(this.context),
      u: ve(this.context),
      v: ve(this.context)
    });
    // Lazy loaded when needed
    s(this, "textRenderer");
    s(this, "size", Di);
    s(this, "onContextLost", (t) => {
      this.textRenderer = void 0;
      const n = new Error(t instanceof WebGLContextEvent ? t.statusMessage : "webgl context lost");
      this.emit("context lost", ln(n)), t.preventDefault();
    });
    s(this, "onContextRestored", () => {
      this.emit("context restored"), this.context = Li(this.canvas, Oi), this.pixelShader = Ue(this.context, this.context.FRAGMENT_SHADER, Ui), this.vertexShader = Ue(this.context, this.context.VERTEX_SHADER, _i), this.buffer = Mi(this.context, Xe.SQUARE_VERTICES), this.program = ii(this.context, this.vertexShader, this.pixelShader), this.textures = {
        y: ve(this.context),
        u: ve(this.context),
        v: ve(this.context)
      }, this.load();
    });
    s(this, "load", () => {
      this.context.useProgram(this.program), this.setupPositionVertexAttributes(), this.setSize(Di), this.context.uniform1i(this.context.getUniformLocation(this.program, "y_texture"), 0), this.context.uniform1i(this.context.getUniformLocation(this.program, "u_texture"), 1), this.context.uniform1i(this.context.getUniformLocation(this.program, "v_texture"), 2), this.setConversionMatrix(this.rec709());
    });
    s(this, "unload", () => {
      var n;
      this.setSize({ width: 1, height: 1, codedHeight: 1, codedWidth: 1 }), [this.textures.y, this.textures.u, this.textures.v].forEach((r) => this.context.deleteTexture(r)), this.context.deleteShader(this.pixelShader), this.context.deleteShader(this.vertexShader), this.context.deleteProgram(this.program), this.context.deleteBuffer(this.buffer), this.canvas.removeEventListener("webglcontextlost", this.onContextLost), this.canvas.removeEventListener("webglcontextrestored", this.onContextRestored), (n = this.context.getExtension("WEBGL_lose_context")) == null || n.loseContext();
    });
    s(this, "resetSize", () => {
      this.setSize({
        width: this.size.width / 2,
        height: this.size.height / 2,
        codedHeight: this.size.codedHeight / 2,
        codedWidth: this.size.codedWidth / 2
      });
    });
    s(this, "render", (t, n) => {
      var r;
      this.context.useProgram(this.program), this.setSize({
        width: t.width,
        height: t.height,
        codedWidth: t.codedWidth,
        codedHeight: t.codedHeight
      }), this.setConversionMatrix(this.rec709()), this.setModelMatrix(this.size.width / this.size.codedWidth, this.size.height / this.size.codedHeight), this.context.activeTexture(this.context.TEXTURE0), this.updateTexture(this.textures.y, this.size.codedWidth, this.size.codedHeight, t.data[0]), this.context.activeTexture(this.context.TEXTURE1), this.updateTexture(this.textures.u, this.size.codedWidth / 2, this.size.codedHeight / 2, t.data[1]), this.context.activeTexture(this.context.TEXTURE2), this.updateTexture(this.textures.v, this.size.codedWidth / 2, this.size.codedHeight / 2, t.data[2]), this.context.drawArrays(this.context.TRIANGLE_STRIP, 0, 4), this.textRenderer && this.textRenderer.render({
        width: Math.max(n.clientWidth, 960) * window.devicePixelRatio,
        height: Math.max(n.clientHeight, 540) * window.devicePixelRatio,
        padding: -parseInt((r = n.style.getPropertyValue("--vindral-control-bar-offset")) != null ? r : "0", 10)
      });
    });
    s(this, "updateTexture", (t, n, r, o) => {
      const c = this.context.LUMINANCE, d = this.context.UNSIGNED_BYTE;
      this.context.bindTexture(this.context.TEXTURE_2D, t), this.context.texImage2D(this.context.TEXTURE_2D, 0, c, n, r, 0, c, d, o);
    });
    s(this, "setupPositionVertexAttributes", () => {
      const t = this.context.getAttribLocation(this.program, "position");
      this.context.enableVertexAttribArray(t), this.context.vertexAttribPointer(t, 2, this.context.FLOAT, !1, 0, 0);
    });
    s(this, "setSize", (t) => {
      Be(t, this.size) || (this.size = t, this.canvas.setAttribute("width", t.width.toString()), this.canvas.setAttribute("height", t.height.toString()), this.context.viewport(0, 0, t.width, t.height), this.setModelMatrix(t.width / t.codedWidth, t.height / t.codedHeight));
    });
    s(this, "setModelMatrix", (t, n) => {
      const r = this.context.getUniformLocation(this.program, "model");
      this.context.uniformMatrix4fv(r, !1, this.transformMatrix(t, n));
    });
    s(this, "setConversionMatrix", (t) => {
      const n = this.context.getUniformLocation(this.program, "conversion");
      this.context.uniformMatrix4fv(n, !1, t);
    });
    // prettier-ignore
    s(this, "transformMatrix", (t, n) => [
      2 / t,
      0,
      0,
      0,
      0,
      -2 / n,
      0,
      0,
      0,
      0,
      2 / 1,
      0,
      -1,
      1,
      0,
      1
    ]);
    // prettier-ignore
    s(this, "rec709", () => [
      1.16438,
      0,
      1.79274,
      -0.97295,
      1.16438,
      -0.21325,
      -0.53291,
      0.30148,
      1.16438,
      2.1124,
      0,
      -1.1334,
      0,
      0,
      0,
      1
    ]);
    // prettier-ignore
    s(this, "rec601", () => [
      1.16438,
      0,
      1.59603,
      -0.87079,
      1.16438,
      -0.39176,
      -0.81297,
      0.52959,
      1.16438,
      2.01723,
      0,
      -1.08139,
      0,
      0,
      0,
      1
    ]);
    this.canvas.addEventListener("webglcontextlost", this.onContextLost), this.canvas.addEventListener("webglcontextrestored", this.onContextRestored, !1), this.canvas.style.width = "100%", this.canvas.style.position = "relative";
  }
  getTextRenderer() {
    return this.textRenderer || (this.textRenderer = new ro(this.context)), this.textRenderer;
  }
};
s(Xe, "SQUARE_VERTICES", new Float32Array([0, 0, 0, 1, 1, 0, 1, 1]));
let si = Xe;
const wt = class wt {
  constructor(e, t, n, r) {
    s(this, "oldTimestampLimit", 400);
    s(this, "pool");
    s(this, "logger");
    s(this, "videoRenderer", new si());
    s(this, "renderQueue", []);
    s(this, "clockSource");
    s(this, "isFirstFrame", !0);
    s(this, "animationFrameRequest");
    s(this, "renderedFrameCount", 0);
    s(this, "rendererDroppedFrameCount", 0);
    s(this, "renderTargetSize");
    s(this, "load", () => {
      this.videoRenderer.load();
    });
    s(this, "unload", () => (this.stopRender(), this.videoRenderer.unload(), Promise.resolve()));
    s(this, "suspend", () => {
      this.renderQueue = [], this.stopRender();
    });
    s(this, "unsuspend", () => {
      this.animationFrameRequest = requestAnimationFrame(this.render);
    });
    s(this, "element", () => this.videoRenderer.canvas);
    s(this, "getStatistics", () => ({
      renderedFrameCount: this.renderedFrameCount,
      rendererDroppedFrameCount: this.rendererDroppedFrameCount,
      contextLostCount: 0,
      contextRestoredCount: 0
    }));
    s(this, "resetSize", () => {
      this.videoRenderer.resetSize();
    });
    s(this, "setActiveCues", (e, t) => {
      this.videoRenderer.getTextRenderer().setActiveCues(e, t);
    });
    s(this, "onDecodedFrame", (e) => {
      if (e.type === "video")
        if (this.isFirstFrame)
          this.isFirstFrame = !1, requestAnimationFrame(() => {
            this.renderSample(e);
          });
        else {
          const t = (this.clockSource.currentTime - this.oldTimestampLimit) / 1e3;
          this.renderQueue = this.renderQueue.filter((n) => {
            const r = n.timestamp / n.timescale, o = e.timestamp / e.timescale, a = r > t && r <= o;
            return a || this.pool.reclaim(n.buffer), a;
          }), this.renderQueue.push(e);
        }
    });
    s(this, "render", () => {
      const e = this.clockSource.currentTime;
      let t = this.renderQueue[0], n, r = 0;
      for (; t && t.timestamp / t.timescale * 1e3 <= e; )
        t = this.renderQueue.shift(), t && (r++, n && this.pool.reclaim(n.buffer), n = t), t = this.renderQueue[0];
      n && this.renderSample(n), this.rendererDroppedFrameCount += Math.max(r - 1, 0), this.animationFrameRequest = requestAnimationFrame(this.render);
    });
    s(this, "renderSample", (e) => {
      this.renderedFrameCount++, this.videoRenderer.render(e, this.renderTargetSize), this.pool.reclaim(e.buffer);
    });
    s(this, "stopRender", () => {
      this.animationFrameRequest && cancelAnimationFrame(this.animationFrameRequest);
    });
    this.logger = e, this.clockSource = t, this.pool = n, this.renderTargetSize = r || this.videoRenderer.canvas;
  }
};
s(wt, "create", (e, t, n, r) => new wt(e, t, n, r));
let ct = wt;
const St = class St {
  constructor(e, t, n, r, o) {
    s(this, "logger");
    s(this, "emitter");
    s(this, "audioPlayer");
    s(this, "videoPlayer");
    s(this, "pool");
    s(this, "unmuter", new to());
    s(this, "_isPaused", !1);
    s(this, "isDisconnected", !1);
    s(this, "timers", new N());
    s(this, "textTracks", new ss());
    s(this, "playbackRate");
    s(this, "reset", () => {
    });
    s(this, "load", () => {
      this.audioPlayer.useDefaultDestination(), this.emitter.on("decoded frame", this.onDecodedFrame), this.emitter.on("flush buffers", this.flushBuffers), this.videoPlayer.load(), this.timers.setInterval(() => {
        if (!this.textTracks.language)
          return;
        const e = this.textTracks.getActiveCues(this.currentTime / 1e3);
        this.videoPlayer.setActiveCues(e, {
          width: this.videoPlayer.element().clientWidth,
          height: this.videoPlayer.element().clientHeight
        });
      }, 100);
    });
    s(this, "unload", () => {
      this.emitter.off("decoded frame", this.onDecodedFrame), this.emitter.off("flush buffers", this.flushBuffers), this.audioPlayer.unload(), this.videoPlayer.unload(), this.timers.unload();
    });
    s(this, "suspend", () => {
      this.videoPlayer.suspend(), this.audioPlayer.suspend();
    });
    s(this, "unsuspend", () => {
      this.videoPlayer.unsuspend(), this.audioPlayer.unsuspend();
    });
    s(this, "element", () => this.videoPlayer.element());
    s(this, "getStatistics", () => this.videoPlayer.getStatistics());
    s(this, "flushBuffers", () => {
      this.audioPlayer.flushBuffer();
    });
    s(this, "activateAudioPlayer", () => (this.isDisconnected && (this.isDisconnected = !1, this.audioPlayer.useDefaultDestination()), this._isPaused = !1, this.unmuter.unmute(), this.audioPlayer.play()));
    s(this, "onDecodedFrame", (e) => {
      try {
        this.audioPlayer.onDecodedFrame(e);
      } catch (t) {
        t instanceof Error && this.emitter.emit("error", qi(!1, t));
      }
      this.videoPlayer.onDecodedFrame(e);
    });
    this.logger = t, this.emitter = e, this.pool = n, this.audioPlayer = at.create(this.logger.createContext("AudioPlayerModule"), r, {
      muted: o,
      reInitWhenStuck: !0
    }), this.audioPlayer.on("stuck", () => {
      this.isDisconnected = !0;
    }), this.audioPlayer.on("state change", () => {
      this.emitter.emit("volume state", {
        volume: this.volume,
        isMuted: this.muted
      });
    }), this.videoPlayer = ct.create(this.logger.createContext("VideoPlayerModule"), this.audioPlayer, this.pool);
  }
  get volume() {
    return this.audioPlayer.volume;
  }
  set volume(e) {
    this.audioPlayer.volume = e;
  }
  get muted() {
    return this.audioPlayer.muted;
  }
  set muted(e) {
    const t = this.muted;
    this.audioPlayer.muted = e, !e && t && this.activateAudioPlayer().catch(ce);
  }
  get currentTime() {
    return this.audioPlayer.currentTime;
  }
  set currentTime(e) {
    this.audioPlayer.currentTime = e;
  }
  get isActivated() {
    return this.audioPlayer.isActivated;
  }
  set isActivated(e) {
    this.audioPlayer.isActivated = e;
  }
  get seekTime() {
    return this.audioPlayer.seekTime;
  }
  get isPaused() {
    return this._isPaused;
  }
  get isSeeking() {
    return this.audioPlayer.isSeeking;
  }
  play() {
    this.activateAudioPlayer().then(() => {
      this.emitter.emit("media element state", "playing");
    }).catch(() => {
      this.emitter.emit("needs user input", {
        forAudio: !0,
        forVideo: !1
      });
    });
  }
  pause() {
    this._isPaused = !0, this.audioPlayer.pause(), this.emitter.emit("media element state", "paused");
  }
};
s(St, "create", (e, t, n, r, o) => new St(e, t, n, r, o));
let ni = St;
const vt = class vt {
  constructor(e, t, n, r, { muted: o, type: a, poster: c }) {
    s(this, "logger");
    s(this, "emitter");
    s(this, "mediaElement");
    s(this, "audioPlayer");
    s(this, "videoPlayer");
    s(this, "pool");
    s(this, "isDisconnected", !0);
    s(this, "_userProvidedMuted", !1);
    s(this, "timers", new N());
    s(this, "volumeState");
    s(this, "textTracks", new ss());
    s(this, "reset", () => {
    });
    s(this, "load", () => {
      this.mediaElement.load(), this.emitter.on("decoded frame", this.onDecodedFrame), this.emitter.on("flush buffers", this.flushBuffers), this.emitter.on("ios-hack: reset size", this.resetCanvasSize), this.emitter.on("enter picture in picture", this.onEnterIOSHack), this.emitter.on("exit picture in picture", this.onExitIOSHack), this.element().element.addEventListener("webkitendfullscreen", this.onExitIOSHack), this.element().element.addEventListener("webkitbeginfullscreen", this.onEnterIOSHack), this.videoPlayer.load(), this.timers.setInterval(() => {
        if (!this.textTracks.language)
          return;
        const e = this.textTracks.getActiveCues(this.currentTime / 1e3);
        this.videoPlayer.setActiveCues(e, {
          width: this.mediaElement.element.clientWidth,
          height: this.mediaElement.element.clientHeight
        });
      }, 100);
    });
    s(this, "unload", () => {
      this.emitter.off("decoded frame", this.onDecodedFrame), this.emitter.off("flush buffers", this.flushBuffers), this.emitter.off("ios-hack: reset size", this.resetCanvasSize), this.emitter.off("enter picture in picture", this.onEnterIOSHack), this.emitter.off("exit picture in picture", this.onExitIOSHack), this.element().element.removeEventListener("webkitendfullscreen", this.onExitIOSHack), this.element().element.removeEventListener("webkitbeginfullscreen", this.onEnterIOSHack), this.mediaElement.unload(), this.timers.unload(), this.audioPlayer.unload(), this.videoPlayer.unload();
    });
    s(this, "suspend", () => {
      this.videoPlayer.suspend(), this.audioPlayer.suspend();
    });
    s(this, "unsuspend", () => {
      this.videoPlayer.unsuspend(), this.audioPlayer.unsuspend();
    });
    s(this, "element", () => this.mediaElement);
    s(this, "getStatistics", () => this.videoPlayer.getStatistics());
    s(this, "activateAudioPlayer", () => (this.isDisconnected && this.connectStreams(), this.audioPlayer.play()));
    s(this, "flushBuffers", () => {
      this.audioPlayer.flushBuffer();
    });
    s(this, "resetCanvasSize", () => {
      this.videoPlayer.resetSize();
    });
    s(this, "onEnterIOSHack", () => {
      this.mediaElement._iosHackEnterPiPMode();
    });
    s(this, "onExitIOSHack", () => {
      this.mediaElement._iosHackExitPiPMode();
    });
    s(this, "onDecodedFrame", (e) => {
      try {
        this.audioPlayer.onDecodedFrame(e);
      } catch (t) {
        t instanceof Error && this.emitter.emit("error", qi(!1, t));
      }
      this.videoPlayer.onDecodedFrame(e);
    });
    s(this, "connectStreams", () => {
      const e = this.videoPlayer.element().captureStream(), t = this.audioPlayer.useMediaStreamDestination().stream, n = [];
      n.push(...e.getTracks(), ...t.getTracks()), this.mediaElement.element.srcObject = new MediaStream(n), this.isDisconnected = !1;
    });
    s(this, "updateVolumeState", () => {
      const e = {
        isMuted: this.muted,
        volume: this.volume
      };
      Be(e, this.volumeState) || (this.volumeState = e, this.emitter.emit("volume state", this.volumeState));
    });
    this.logger = t, this.emitter = e, this.pool = n, this._userProvidedMuted = o, this.mediaElement = new Wt({
      poster: c,
      type: a,
      muted: o,
      autoplay: !1,
      logger: this.logger.createContext("MediaElement")
    }), this.mediaElement.on("volume state", (d) => {
      this.updateVolumeState(), !d.isMuted && !this.audioPlayer.isContextRunning && this.activateAudioPlayer().catch(ce), d.isMuted || (this._userProvidedMuted = !1);
    }), this.mediaElement.on("media element state", (d) => {
      d === "paused" && this.audioPlayer.flushBuffer(), this.emitter.emit("media element state", d);
    }), this.audioPlayer = at.create(this.logger.createContext("AudioPlayerModule"), r, {
      muted: !1,
      // Never muted because its the media element that limits audio output,
      reInitWhenStuck: !1
    }), this.audioPlayer.on("stuck", () => {
      this.isDisconnected = !0;
    }), this.audioPlayer.on("state change", (d) => {
      d === "suspended" || d === "interrupted" ? this.mediaElement.muted = !0 : d === "running" && (this.mediaElement.muted = this._userProvidedMuted || document.visibilityState === "hidden"), this.updateVolumeState();
    }), this.videoPlayer = ct.create(
      this.logger.createContext("VideoPlayerModule"),
      this.audioPlayer,
      this.pool,
      this.mediaElement.element
    ), this.volumeState = { volume: this.volume, isMuted: this.muted };
  }
  get volume() {
    return this.mediaElement.volume;
  }
  set volume(e) {
    this.mediaElement.volume = e;
  }
  get muted() {
    return this.mediaElement.muted || this.audioPlayer.muted;
  }
  set muted(e) {
    const t = this.muted;
    this._userProvidedMuted = e, this.mediaElement.muted = e, !e && t && this.activateAudioPlayer().catch(ce);
  }
  get currentTime() {
    return this.audioPlayer.currentTime;
  }
  set currentTime(e) {
    this.audioPlayer.currentTime = e;
  }
  get isActivated() {
    return this.mediaElement.isActivated;
  }
  set isActivated(e) {
    this.mediaElement.isActivated = e;
  }
  get seekTime() {
    return this.mediaElement.seekTime;
  }
  get isPaused() {
    return this.mediaElement.isPaused;
  }
  get isSeeking() {
    return this.mediaElement.isSeeking;
  }
  play() {
    const e = this._userProvidedMuted;
    return this.activateAudioPlayer().catch(() => {
      e || this.emitter.emit("needs user input", {
        forAudio: !0,
        forVideo: !1
      });
    }), this.mediaElement.play();
  }
  pause() {
    this.mediaElement.pause();
  }
};
s(vt, "create", (e, t, n, r, o) => new vt(e, t, n, r, o));
let ri = vt;
const oo = () => (i) => cs(i.buffered.start(0), i.buffered.end(i.buffered.length - 1)), cs = (i, e) => (t) => t.remove(Math.max(0, i), Math.min(Number.POSITIVE_INFINITY, e)), Fi = (i) => (e) => e.appendBuffer(i), ao = (i) => (e) => e.changeType(i), co = (i) => (e) => i(e);
class ho {
  constructor(e) {
    s(this, "commandQueue", []);
    s(this, "sourceBuffer");
    s(this, "currentInit");
    s(this, "handleQueue", () => {
      var e;
      this.sourceBuffer.updating || (e = this.commandQueue.shift()) == null || e.execute(this.sourceBuffer);
    });
    s(this, "appendBuffer", (e, t) => new Promise((n, r) => {
      if (t && this.currentInit !== t) {
        const a = new Re(Fi(t), n, r);
        this.commandQueue.push(a), this.currentInit = t;
      }
      const o = new Re(Fi(e), n, r);
      this.commandQueue.push(o), this.handleQueue();
    }));
    s(this, "execute", (e) => new Promise((t, n) => {
      const r = new Re(co(e), t, n);
      this.commandQueue.push(r), this.handleQueue();
    }));
    s(this, "buffered", () => this.sourceBuffer.buffered);
    s(this, "removeFromMediaSource", (e) => {
      e.removeSourceBuffer(this.sourceBuffer);
    });
    s(this, "changeType", (e) => new Promise((t, n) => {
      const r = new Re(ao(e), t, n);
      this.commandQueue.push(r), this.handleQueue();
    }));
    s(this, "removeBuffer", (e, t) => new Promise((n, r) => {
      const o = new Re(cs(e, t), n, r);
      this.commandQueue.push(o), this.handleQueue();
    }));
    s(this, "flush", () => new Promise((e, t) => {
      const n = new Re(oo, e, t);
      this.commandQueue.push(n), this.handleQueue();
    }));
    this.sourceBuffer = e, this.sourceBuffer.addEventListener("updateend", this.handleQueue);
  }
}
class ds extends pe {
  constructor() {
    super();
    s(this, "MediaSource", We());
    s(this, "mediaSource", new this.MediaSource());
    s(this, "isOpen", () => this.mediaSource.readyState === "open");
    s(this, "isClosed", () => this.mediaSource.readyState === "closed");
    s(this, "isEnded", () => this.mediaSource.readyState === "ended");
    s(this, "createObjectURL", () => URL.createObjectURL(this.mediaSource));
    s(this, "attach", (t) => {
      const n = t;
      if ("srcObject" in n)
        try {
          n.srcObject = this.mediaSource;
        } catch (r) {
          if (r instanceof Error && r.name !== "TypeError")
            throw r;
          n.src = this.createObjectURL();
        }
      else
        t.src = this.createObjectURL();
    });
    s(this, "detach", (t) => {
      if (this.mediaSource && this.mediaSource.readyState === "open")
        try {
          this.mediaSource.endOfStream();
        } catch (n) {
        }
      t.srcObject && (t.srcObject = null), t.src !== "" && (URL.revokeObjectURL(t.src), t.removeAttribute("src")), t.load();
    });
    s(this, "addSourceBuffer", (t) => {
      const n = this.mediaSource.addSourceBuffer(t);
      return new ho(n);
    });
    s(this, "removeSourceBuffer", (t) => {
      t.removeFromMediaSource(this.mediaSource);
    });
    s(this, "endOfStream", (t) => {
      this.mediaSource.endOfStream(t);
    });
    s(this, "onSourceOpen", () => {
      this.setDurationIfNeeded(), this.emit("source open");
    });
    s(this, "onSourceEnded", () => this.emit("source ended"));
    s(this, "onSourceClosed", () => this.emit("source close"));
    s(this, "setDurationIfNeeded", () => {
      if (Number.isNaN(this.mediaSource.duration) && this.mediaSource.readyState === "open") {
        for (let t = 0; t < this.mediaSource.sourceBuffers.length; t++) {
          const n = this.mediaSource.sourceBuffers[t];
          if (n != null && n.updating)
            return;
        }
        this.mediaSource.duration = Number.POSITIVE_INFINITY;
      }
    });
    this.mediaSource.addEventListener("sourceopen", this.onSourceOpen), this.mediaSource.addEventListener("sourceclose", this.onSourceClosed), this.mediaSource.addEventListener("sourceended", this.onSourceEnded);
  }
}
s(ds, "isTypeSupported", (t) => {
  var n, r;
  return (r = (n = We()) == null ? void 0 : n.isTypeSupported(t)) != null ? r : !1;
});
class hs {
  constructor() {
    s(this, "initSegments", /* @__PURE__ */ new Map());
    s(this, "set", (e, t, n) => {
      var o;
      const r = (o = this.initSegments.get(e)) != null ? o : /* @__PURE__ */ new Map();
      r.set(t, n), this.initSegments.set(e, r);
    });
    s(this, "get", (e, t) => {
      var n;
      return (n = this.initSegments.get(e)) == null ? void 0 : n.get(t);
    });
  }
}
function uo(i, { mediaSource: e, mimeType: t }) {
  return L(g({}, i), {
    state: "initialized",
    mimeType: t,
    sourceBuffer: e.addSourceBuffer(t),
    isWorkingOnPendingSamples: !1,
    sequenceNumber: 0,
    lastBufferCleanupTime: Date.now()
  });
}
function Ni({
  initSegments: i,
  pendingSamples: e
}) {
  return {
    state: "uninitialized",
    initSegments: i != null ? i : new hs(),
    sequenceNumber: 0,
    isWorkingOnPendingSamples: !1,
    hasFirstSync: !!e,
    pendingSamples: e != null ? e : [],
    consecutiveQuotaExceededErrorCount: 0,
    successfulAppendCalls: 0
  };
}
const bt = class bt {
  constructor(e, t, n) {
    s(this, "maxChunkSize", 20);
    s(this, "minConsecutiveErrorsBeforeEmit", 5);
    s(this, "maxSecondsInBuffer", 60);
    s(this, "logger");
    s(this, "timers", N.create());
    s(this, "emitter");
    s(this, "mediaElement");
    s(this, "mediaSource", new ds());
    s(this, "trackContexts", /* @__PURE__ */ new Map());
    s(this, "autoRecoverFromMediaErrors", !0);
    s(this, "quotaErrorCount", 0);
    s(this, "recoveredFromErrorCount", 0);
    s(this, "sourceOpenStartTime", Date.now());
    s(this, "sourceOpenEndTime", Date.now());
    s(this, "pendingTracksToAddSourceBuffers");
    s(this, "hasAddedInitialPosterFrame", !0);
    s(this, "load", () => {
      this.emitter.on("init segment", this.init), this.emitter.on("coded sample", this.onCodedSample), this.emitter.on("flush buffers", this.flushBuffers);
    });
    s(this, "unload", () => {
      this.logger.debug("Unloading module..."), this.emitter.off("init segment", this.init), this.emitter.off("coded sample", this.onCodedSample), this.emitter.off("flush buffers", this.flushBuffers), this.mediaSource.off("source ended", this.onSourceEnded), this.mediaSource.off("source open", this.onSourceOpen), this.mediaSource.detach(this.mediaElement), this.trackContexts.forEach((e) => e.pendingSamples = []), this.timers.unload(), this.logger.debug("Unloaded module");
    });
    s(this, "getStatistics", () => {
      var t, n, r, o;
      const e = {
        quotaErrorCount: this.quotaErrorCount,
        mediaSourceOpenTime: this.sourceOpenEndTime - this.sourceOpenStartTime,
        successfulAudioAppendsCalls: (t = this.trackContexts.get("audio")) == null ? void 0 : t.successfulAppendCalls,
        successfulVideoAppendCalls: (n = this.trackContexts.get("video")) == null ? void 0 : n.successfulAppendCalls
      };
      if (this.mediaElement instanceof HTMLVideoElement) {
        const a = (o = (r = this.mediaElement).getVideoPlaybackQuality) == null ? void 0 : o.call(r);
        e.totalVideoFrames = a == null ? void 0 : a.totalVideoFrames, e.droppedVideoFrames = a == null ? void 0 : a.droppedVideoFrames;
      }
      return e;
    });
    s(this, "flushBuffers", () => {
      this.trackContexts.forEach((e) => {
        e.pendingSamples = [], e.hasFirstSync = !1, e.state !== "uninitialized" && this.mediaSource.isOpen() && e.sourceBuffer.removeBuffer(0, Number.POSITIVE_INFINITY).catch((t) => {
          this.logger.error("Failed to remove buffer", t);
        });
      });
    });
    s(this, "setTrackContexts", (e = /* @__PURE__ */ new Map()) => {
      this.logger.debug("setTrackContexts"), ["audio", "video"].forEach((n) => {
        var a, c, d, h;
        const r = (c = (a = e.get(n)) == null ? void 0 : a.pendingSamples) != null ? c : [], o = (d = e.get(n)) == null ? void 0 : d.initSegments;
        for (; r.length > 0 && !((h = r[0]) != null && h.isSync); )
          r.shift();
        this.trackContexts.set(n, Ni({ pendingSamples: r, initSegments: o }));
      });
    });
    s(this, "setSourceBuffers", (e) => I(this, null, function* () {
      if (this.mediaSource.isClosed()) {
        this.pendingTracksToAddSourceBuffers = e;
        return;
      }
      let t = !0;
      for (const n of e) {
        const r = this.trackContexts.get(n.type);
        if (!r || r.state === "uninitialized" || r.mimeType !== n.mimeType) {
          t = !1;
          break;
        }
      }
      if (t) {
        this.logger.debug("Already setup with the correct mime types");
        return;
      }
      for (const n of e) {
        let r = this.trackContexts.get(n.type);
        r || (r = Ni({ pendingSamples: [], initSegments: new hs() }), this.trackContexts.set(n.type, r)), r.state === "initialized" ? n.mimeType !== r.mimeType && (yield r.sourceBuffer.changeType(n.mimeType)) : this.trackContexts.set(
          n.type,
          uo(r, { mimeType: n.mimeType, mediaSource: this.mediaSource })
        );
      }
    }));
    s(this, "getBuffer", (e) => {
      const t = [];
      if (this.mediaSource.isClosed())
        return [];
      const n = this.trackContexts.get(e);
      if (!n || n.state === "uninitialized")
        return [];
      try {
        const r = n.sourceBuffer.buffered();
        if (!r)
          return [];
        for (let o = 0; o < r.length; o++)
          t.push({ start: r.start(o) * 1e3, end: r.end(o) * 1e3 });
        return t;
      } catch (r) {
        return [];
      }
    });
    s(this, "init", ({ initSegment: e, mimeType: t }) => {
      this.logger.debug("Added init segment", { channel: e.channelId, renditionId: e.renditionId });
      const n = this.trackContexts.get(e.type);
      if (!n)
        throw Dt(e.type, e.renditionId);
      n.state === "initialized" && (n.mimeType = t);
      const r = wr(e.codec, e.data, e.timescale);
      r && n.initSegments.set(e.channelId, e.renditionId, r);
    });
    s(this, "append", (e, t) => I(this, null, function* () {
      var c;
      const n = e[0];
      if (!n)
        return;
      const r = this.trackContexts.get(n.type), o = r == null ? void 0 : r.initSegments.get(n.channelId, n.renditionId);
      if (this.mediaSource.isClosed())
        return;
      if (!o)
        throw nn(n.renditionId, n.channelId);
      if (!r)
        throw Dt(n.type, n.renditionId);
      if (r.state === "uninitialized")
        throw rn(n.type, n.renditionId);
      if (t) {
        const d = (n.timestamp + ((c = n.compositionTimeOffset) != null ? c : 0)) / n.timescale;
        yield r.sourceBuffer.removeBuffer(d, Number.POSITIVE_INFINITY);
        const h = r.previousSample;
        if (h && h.codec !== n.codec && r.sourceBuffer.changeType)
          try {
            yield r.sourceBuffer.changeType(r.mimeType);
          } catch (l) {
          }
        yield r.sourceBuffer.appendBuffer(o);
      }
      const a = Math.max(0, n.timestamp / n.timescale - this.maxSecondsInBuffer);
      a > 0 && Date.now() - r.lastBufferCleanupTime > 1e4 && (r.lastBufferCleanupTime = Date.now(), yield r.sourceBuffer.removeBuffer(0, a + 10));
      try {
        let d = r.sequenceNumber;
        const h = lo(e.map((l) => Tr(l, d++)));
        yield r.sourceBuffer.appendBuffer(h), r.sequenceNumber = d, r.consecutiveQuotaExceededErrorCount = 0, r.successfulAppendCalls++;
      } catch (d) {
        throw d instanceof DOMException && (d.code === DOMException.QUOTA_EXCEEDED_ERR ? (this.quotaErrorCount++, r.consecutiveQuotaExceededErrorCount++, this.logger.error("quota exceeded error", { error: d }), r.pendingSamples.unshift(...e)) : this.mediaElement.error && r.pendingSamples.unshift(...e)), d;
      }
    }));
    s(this, "onCodedSample", (e) => {
      if (e.duration === 0)
        return;
      const t = this.trackContexts.get(e.type);
      if (!t)
        throw Dt(e.type, e.renditionId);
      if (!(!t.hasFirstSync && !e.isSync)) {
        if (this.hasAddedInitialPosterFrame && e.isSync && e.type === "video") {
          this.hasAddedInitialPosterFrame = !1;
          const n = g({}, e);
          n.timestamp = 0, t.pendingSamples.push(n);
        }
        t.hasFirstSync = !0, t.pendingSamples.push(e), t.state !== "uninitialized" && (t.isWorkingOnPendingSamples || mo(t, this.append, this.maxChunkSize).catch((n) => {
          if (t.isWorkingOnPendingSamples = !1, n instanceof Error) {
            if (this.logger.error("append failed", { message: n.message, name: n.name }), n instanceof DOMException && n.code === DOMException.QUOTA_EXCEEDED_ERR) {
              if (t.consecutiveQuotaExceededErrorCount >= this.minConsecutiveErrorsBeforeEmit) {
                const r = yi(!1, n, t.consecutiveQuotaExceededErrorCount, e.type);
                this.emitter.emit("error", r);
              }
            } else {
              const r = yi(!1, n, t.consecutiveQuotaExceededErrorCount, e.type);
              this.emitter.emit("error", r);
            }
            this.mediaElement.error && this.onSourceEnded();
          }
        }));
      }
    });
    s(this, "onSourceOpen", () => {
      this.logger.debug("source opened"), this.sourceOpenEndTime = Date.now(), this.pendingTracksToAddSourceBuffers && (this.setSourceBuffers(this.pendingTracksToAddSourceBuffers), this.pendingTracksToAddSourceBuffers = void 0);
    });
    s(this, "onSourceEnded", () => {
      const { error: e } = this.mediaElement;
      if (e) {
        const t = /AUDIO_RENDERER/.test(e.message) || !this.autoRecoverFromMediaErrors, n = tn(t, e);
        if (this.logger.error("MediaElement error", { error: n }), this.emitter.emit("error", n), !n.isFatal()) {
          this.logger.info("Re-opening MediaSource"), this.emitter.emit("recovered from media error", { error: n, count: this.recoveredFromErrorCount }), this.recoveredFromErrorCount++;
          const r = !this.mediaElement.paused, o = [];
          this.trackContexts.forEach((a, c) => {
            a.state === "initialized" && o.push({ type: c, mimeType: a.mimeType });
          }), this.sourceOpenStartTime = Date.now(), this.pendingTracksToAddSourceBuffers = o, this.mediaElement.src = "", this.setTrackContexts(this.trackContexts), this.mediaSource.attach(this.mediaElement), r && this.mediaElement.play().catch(ce);
        }
      }
      this.logger.debug("source ended");
    });
    this.logger = e, this.mediaElement = n, this.emitter = t;
  }
};
s(bt, "create", (e, t, n) => {
  const r = new bt(e, t, n);
  return r.setTrackContexts(), r.mediaSource.on("source ended", r.onSourceEnded), r.mediaSource.on("source open", r.onSourceOpen), r.mediaSource.attach(n), r;
});
let oi = bt;
const Vi = (i, e) => {
  var a;
  const t = i.renditionId !== e.renditionId, n = i.channelId !== e.channelId, r = ((a = i.timestamp) != null ? a : 0) > e.timestamp;
  let o = !1;
  return i.type === "video" && e.type === "video" && (o = e.width !== i.width || e.height !== i.height), n || t || r || o;
}, lo = function(i) {
  const e = i.reduce((r, o) => r + o.byteLength, 0), t = new Uint8Array(e);
  let n = 0;
  return i.forEach((r) => {
    t.set(new Uint8Array(r), n), n += r.byteLength;
  }), t.buffer;
}, mo = (i, e, t) => I(void 0, null, function* () {
  for (i.isWorkingOnPendingSamples = !0; i.pendingSamples.length > 0; ) {
    const n = [];
    let r = 0;
    for (let c = 0; c < i.pendingSamples.length; c++) {
      r = c;
      const d = i.pendingSamples[c], h = i.pendingSamples[c + 1];
      if (d && (n.push(d), h && Vi(d, h)) || c === t - 1)
        break;
    }
    const o = n[0];
    if (!o)
      break;
    const a = i.previousSample ? Vi(i.previousSample, o) : !0;
    yield e(n, a), i.pendingSamples = i.pendingSamples.slice(r + 1), i.previousSample = n[n.length - 1];
  }
  i.isWorkingOnPendingSamples = !1;
}), Et = class Et {
  constructor(e, t) {
    s(this, "logger");
    s(this, "emitter");
    s(this, "element");
    s(this, "pictureInPictureWindow");
    s(this, "unload", () => {
      this.emitter.off("add picture in picture listener", this.onEnablePictureInPicture);
    });
    s(this, "onEnablePictureInPicture", (e) => {
      this.element = e.element, e.element.addEventListener("leavepictureinpicture", () => {
        this.pictureInPictureWindow = void 0, this.logger.debug("Leave picture in picture"), this.emitter.emit("exit picture in picture");
      }), e.element.addEventListener("enterpictureinpicture", (t) => {
        this.pictureInPictureWindow = t.pictureInPictureWindow, this.logger.debug("Enter picture in picture"), this.emitter.emit("enter picture in picture", this);
      }), e.element.autopictureinpicture = !0;
    });
    s(this, "getPictureInPictureSize", () => this.pictureInPictureWindow);
    s(this, "isPictureInPictureActive", () => this.isWebkitPresentationModeActive() || this.isStandardPictureInPictureActive());
    s(this, "isPictureInPictureSupported", () => this.isWebkitPresentationModeSupported() || this.isStandardPictureInPictureSupported());
    s(this, "requestPictureInPicture", () => (this.emitter.emit("ios-hack: reset size"), this.isStandardPictureInPictureSupported() ? this.requestStandardPictureInPicture() : this.isWebkitPresentationModeSupported() ? this.requestWebkitPresentationMode("picture-in-picture") : Promise.reject(new Error("Picture in picture is not supported"))));
    s(this, "exitPictureInPicture", () => this.isStandardPictureInPictureSupported() ? this.exitStandardPictureInPicture() : this.isWebkitPresentationModeSupported() ? this.requestWebkitPresentationMode("inline") : Promise.reject(new Error("Picture in picture is not supported")));
    s(this, "getStatistics", () => ({
      isPictureInPictureActive: this.isPictureInPictureActive()
    }));
    /* eslint-disable @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-call */
    s(this, "requestStandardPictureInPicture", () => I(this, null, function* () {
      return yield this.element.requestPictureInPicture();
    }));
    s(this, "exitStandardPictureInPicture", () => I(this, null, function* () {
      return yield document.exitPictureInPicture();
    }));
    s(this, "isStandardPictureInPictureSupported", () => !!this.element && !!this.element.requestPictureInPicture && !!document.pictureInPictureEnabled);
    s(this, "isStandardPictureInPictureActive", () => !!this.element && !!document.pictureInPictureElement);
    s(this, "isWebkitPresentationModeActive", () => !!this.element && this.element.webkitPresentationMode === "picture-in-picture");
    s(this, "requestWebkitPresentationMode", (e) => I(this, null, function* () {
      return this.element.webkitSetPresentationMode(e), Promise.resolve();
    }));
    s(this, "isWebkitPresentationModeSupported", () => !!this.element && !!this.element.webkitSetPresentationMode);
    this.emitter = e, this.logger = t, this.emitter.on("add picture in picture listener", this.onEnablePictureInPicture);
  }
  /* eslint-enable @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-call */
};
s(Et, "create", (e, t) => new Et(e, t));
let ai = Et;
const yt = class yt {
  constructor(e, t, n, r) {
    s(this, "emitter");
    s(this, "logger");
    s(this, "clockSource");
    s(this, "state", "buffering");
    s(this, "bufferFullness", 0);
    s(this, "targetBufferTime");
    s(this, "lastBufferStateEvent", "drained");
    s(this, "firstFrameTime");
    s(this, "currentTimeIsInRange", !1);
    s(this, "needsInputForAudioCount", 0);
    s(this, "needsInputForVideoCount", 0);
    s(this, "unload", () => {
      this.emitter.off("buffer state", this.onBufferedStateChanged), this.emitter.off("needs user input", this.onNeedsUserInput);
    });
    s(this, "setTargetBufferTime", (e) => void (this.targetBufferTime = e));
    s(this, "getTargetBufferTime", () => this.targetBufferTime);
    s(this, "getBufferFullness", () => this.bufferFullness);
    s(this, "getLastBufferStateEvent", () => this.lastBufferStateEvent);
    s(this, "getState", () => this.state);
    s(this, "getFirstFrameTime", () => this.firstFrameTime);
    s(this, "getStatistics", () => ({
      bufferTime: this.targetBufferTime,
      needsInputForAudioCount: this.needsInputForAudioCount,
      needsInputForVideoCount: this.needsInputForVideoCount
    }));
    s(this, "onBufferedStateChanged", ({ buffered: e, isPaused: t }) => {
      const n = this.clockSource.currentTime, r = e.some((l) => l.start < n && n < l.end), o = e[e.length - 1], a = o ? o.end - o.start >= this.targetBufferTime : !1, c = o ? Math.max(0, o.end - n) / this.targetBufferTime : 0, d = t ? "paused" : r ? "playing" : "buffering", h = this.state;
      this.currentTimeIsInRange !== r && !r ? (this.lastBufferStateEvent = "drained", this.emitter.emit("buffer state event", this.lastBufferStateEvent)) : r && a && this.lastBufferStateEvent === "drained" && (this.lastBufferStateEvent = "filled", this.emitter.emit("buffer state event", this.lastBufferStateEvent)), d === "playing" && !this.firstFrameTime && (this.firstFrameTime = Date.now()), this.currentTimeIsInRange = r, this.state = d, this.bufferFullness = r ? c : 0, h !== d && this.emitter.emit("playback state", d), this.emitter.emit("buffer fullness", this.bufferFullness);
    });
    s(this, "onNeedsUserInput", ({ forAudio: e, forVideo: t }) => {
      e && this.needsInputForAudioCount++, t && this.needsInputForVideoCount++;
    });
    this.emitter = e, this.logger = t, this.clockSource = n, this.targetBufferTime = r, this.emitter.on("buffer state", this.onBufferedStateChanged), this.emitter.on("needs user input", this.onNeedsUserInput);
  }
};
s(yt, "create", (e, t, n, r) => new yt(e, t, n, r));
let ci = yt;
const di = () => ({
  upgradesFromLevel: [],
  downgradesFromLevel: [],
  bufferingRanges: [],
  activeRanges: [],
  decodeRate: Number.MAX_SAFE_INTEGER
}), Ao = () => ({
  levels: {},
  levelDowngrades: [],
  levelUpgrades: [],
  bufferFullness: 0,
  general: di()
}), Tt = class Tt {
  constructor(e, t) {
    s(this, "minBufferFullnessLengthForRegression", 6);
    s(this, "logger");
    s(this, "emitter");
    s(this, "timers", N.create());
    s(this, "metrics", Ao());
    s(this, "bufferFullness", new X(30));
    s(this, "bufferFullnessRegression");
    s(this, "currentLevel");
    s(this, "isSuspended", !1);
    s(this, "_fatalQosCount", 0);
    s(this, "hasAsserted", !1);
    s(this, "load", () => {
      this.emitter.on("playback state", this.onPlaybackState), this.emitter.on("buffer fullness", this.onBufferFullness), this.emitter.on("rendition level changed", this.onRenditionLevelChanged), this.emitter.on("video decode rate", this.onVideoDecodeRate);
    });
    s(this, "unload", () => {
      this.emitter.off("playback state", this.onPlaybackState), this.emitter.off("buffer fullness", this.onBufferFullness), this.emitter.off("rendition level changed", this.onRenditionLevelChanged), this.emitter.off("video decode rate", this.onVideoDecodeRate), this.suspend();
    });
    s(this, "suspend", () => {
      this.isSuspended = !0, this.timers.unload(), this.stopBuffering(), this.unsetActive();
    });
    s(this, "unsuspend", () => {
      this.isSuspended = !1, this.currentLevel && this.setActive();
    });
    s(this, "fatalQosGraceTime", () => 1e4 * (this.fatalQosCount + 1));
    s(this, "incrementFatalQosCount", () => {
      this._fatalQosCount++;
    });
    s(this, "getMetrics", () => this.metrics);
    s(this, "getLevelStats", (e) => {
      var n, r, o, a;
      const t = ((r = (n = e.video) == null ? void 0 : n.bitRate) != null ? r : 0) + ((a = (o = e.audio) == null ? void 0 : o.bitRate) != null ? a : 0);
      return this.metrics.levels[t];
    });
    s(this, "getBufferFullnessRegression", () => this.bufferFullnessRegression);
    s(this, "activeRatios", () => {
      const e = /* @__PURE__ */ new Map(), t = Pe(this.metrics.general.activeRanges);
      if (Object.entries(this.metrics.levels).forEach(([n, r]) => {
        e.set(n, t ? Pe(r.activeRanges) / t : 0);
      }), !this.hasAsserted) {
        const n = e.size ? Math.abs(Array.from(e.values()).reduce((r, o) => r + o, 0) - 1) <= 0.02 : !0;
        n || (this.hasAsserted = !0, console.assert(
          n,
          `Active ratios should be close to 1 - actual: ${Array.from(e.values()).reduce(
            (r, o) => r + o,
            0
          )}`
        ));
      }
      return e;
    });
    s(this, "bufferingRatios", () => {
      const e = /* @__PURE__ */ new Map(), t = Pe(this.metrics.general.bufferingRanges);
      if (Object.entries(this.metrics.levels).forEach(([n, r]) => {
        e.set(n, t ? Pe(r.bufferingRanges) / t : 0);
      }), !this.hasAsserted) {
        const n = Array.from(e.values()).reduce((r, o) => r + o, 0) <= 1;
        n || (this.hasAsserted = !0, console.assert(
          n,
          `Buffering ratios should be less than 1 - actual: ${Array.from(e.values()).reduce(
            (r, o) => r + o,
            0
          )}`
        ));
      }
      return e;
    });
    s(this, "bufferingEventsLast", (e) => this.metrics.general.bufferingRanges.filter((t) => t.start >= Date.now() - e).length);
    s(this, "timeSpentBufferingLast", (e) => vi(this.metrics.general.bufferingRanges, e));
    s(this, "timeSpentActiveLast", (e) => vi(this.metrics.general.activeRanges, e));
    s(this, "timeSpentPlayingInAtLeastLevelRatio", (e) => {
      var d, h, l, m;
      const t = this.timeSpentBuffering(), n = this.timeActive(), r = this.bufferingRatios(), o = this.activeRatios(), a = ((h = (d = e.video) == null ? void 0 : d.bitRate) != null ? h : 0) + ((m = (l = e.audio) == null ? void 0 : l.bitRate) != null ? m : 0), c = t / n;
      return Object.keys(this.metrics.levels).map((f) => parseInt(f, 10)).filter((f) => f >= a).reduce(
        (f, p) => {
          var v, B;
          return ((v = o.get(p.toString())) != null ? v : 0) - ((B = r.get(p.toString())) != null ? B : 0) * c + f;
        },
        0
      );
    });
    s(this, "timeSpentBuffering", () => Pe(this.metrics.general.bufferingRanges));
    s(this, "timeActive", () => Pe(this.metrics.general.activeRanges));
    s(this, "getStatistics", () => ({
      timeSpentBuffering: this.timeSpentBuffering(),
      bufferingEventsCount: this.metrics.general.bufferingRanges.length,
      timeSpentRatio: [...this.activeRatios()].reduce((e, [t, n]) => (e[t] = n, e), {}),
      fatalQosCount: this.fatalQosCount
    }));
    s(this, "onRenditionLevelChanged", (e) => {
      var o, a, c, d, h, l, m, f, p, v, B, k, M, C;
      const t = ((c = (a = (o = e.from) == null ? void 0 : o.video) == null ? void 0 : a.bitRate) != null ? c : 0) + ((l = (h = (d = e.from) == null ? void 0 : d.audio) == null ? void 0 : h.bitRate) != null ? l : 0), n = ((p = (f = (m = e.to) == null ? void 0 : m.video) == null ? void 0 : f.bitRate) != null ? p : 0) + ((k = (B = (v = e.to) == null ? void 0 : v.audio) == null ? void 0 : B.bitRate) != null ? k : 0);
      this.logger.info("rendition level changed", { fromLevel: t, toLevel: n }), this.metrics.general.activeRanges.length === 0 && this.setActive(), e.from && e.to && (t < n ? this.metrics.general.upgradesFromLevel.push(Date.now()) : this.metrics.general.downgradesFromLevel.push(Date.now()));
      let r = !1;
      if (e.from) {
        const E = (M = this.metrics.levels[t]) != null ? M : di();
        t < n ? E.upgradesFromLevel.push(Date.now()) : E.downgradesFromLevel.push(Date.now()), Se(E.activeRanges);
        const H = E.bufferingRanges[E.bufferingRanges.length - 1];
        r = !!H && !H.end, Se(E.bufferingRanges), this.metrics.levels[t] = E;
      }
      if (e.to) {
        const E = (C = this.metrics.levels[n]) != null ? C : di();
        ke(E.activeRanges), r && ke(E.bufferingRanges), this.metrics.levels[n] = E, this.currentLevel = n;
      }
    });
    s(this, "onBufferFullness", (e) => {
      this.bufferFullness.push(e), this.metrics.bufferFullness = e, this.bufferFullness.items().length >= this.minBufferFullnessLengthForRegression && (this.bufferFullnessRegression = this.calculateLinearRegression());
    });
    s(this, "onPlaybackState", (e) => {
      switch (this.logger.info("Playback state", { state: e, currentLevel: this.currentLevel }), e) {
        case "playing":
          this.stopBuffering();
          break;
        case "buffering":
          this.isSuspended || this.startBuffering();
          break;
      }
    });
    s(this, "onVideoDecodeRate", (e) => {
      var n;
      if (this.metrics.general.decodeRate = e, !this.currentLevel)
        return;
      const t = this.metrics.levels[(n = this.currentLevel) != null ? n : 0];
      t && (t.decodeRate = e);
    });
    s(this, "calculateLinearRegression", () => Us(
      this.bufferFullness.items().map((e, t) => ({
        x: t,
        y: e
      }))
    ));
    s(this, "stopBuffering", () => {
      if (this.currentLevel) {
        const e = this.metrics.levels[this.currentLevel];
        e && Se(e.bufferingRanges);
      }
      Se(this.metrics.general.bufferingRanges);
    });
    s(this, "startBuffering", () => {
      if (this.currentLevel) {
        const e = this.metrics.levels[this.currentLevel];
        e && ke(e.bufferingRanges);
      }
      ke(this.metrics.general.bufferingRanges);
    });
    s(this, "unsetActive", () => {
      if (this.currentLevel) {
        const e = this.metrics.levels[this.currentLevel];
        e && Se(e.activeRanges);
      }
      Se(this.metrics.general.activeRanges);
    });
    this.logger = t, this.emitter = e;
  }
  get fatalQosCount() {
    return this._fatalQosCount;
  }
  setActive() {
    if (this.currentLevel) {
      const e = this.metrics.levels[this.currentLevel];
      e && ke(e.activeRanges);
    }
    ke(this.metrics.general.activeRanges);
  }
};
s(Tt, "create", (e, t) => new Tt(e, t));
let hi = Tt;
const Ct = class Ct {
  constructor(e, t) {
    s(this, "renditions", /* @__PURE__ */ new Map());
    s(this, "renditionLevels", []);
    s(this, "languages", []);
    s(this, "emitter");
    s(this, "subscriptionSource");
    s(this, "renditionLevelChangeCount", 0);
    s(this, "unload", () => {
      this.emitter.off("renditions", this.onRenditions), this.emitter.off("subscription changed", this.onSubscriptionChanged);
    });
    s(this, "getRenditionLevels", (e) => e ? this.createRenditionLevels(e) : this.renditionLevels);
    s(this, "getRenditionLevel", (e) => {
      var c;
      const t = e != null ? e : this.getCurrentSubscription(), n = e ? this.createRenditionLevels(e) : this.renditionLevels;
      if (!t.video)
        return n.length ? n[0] : void 0;
      const r = t.video.bitRate || Number.MAX_SAFE_INTEGER, o = t.video.width || Number.MAX_SAFE_INTEGER, a = t.video.height || Number.MAX_SAFE_INTEGER;
      return (c = n.filter(
        (d) => d.video && t.video ? d.video.bitRate <= r && d.video.width <= o && d.video.height <= a : !0
      ).pop()) != null ? c : n[0];
    });
    s(this, "setRenditions", (e, t) => {
      this.renditions.set(e, t);
    });
    s(this, "getLanguages", () => this.languages);
    s(this, "getVideoRendition", (e, t = this.getCurrentSubscription().channelId) => {
      const n = this.getRendition(e, t);
      if (n && De(n))
        return n;
    });
    s(this, "getAudioRenditions", (e) => {
      const t = this.renditions.get(e);
      return t == null ? void 0 : t.filter((r) => Oe(r));
    });
    s(this, "getVideoRenditions", (e) => {
      const t = this.renditions.get(e);
      return t == null ? void 0 : t.filter((r) => De(r));
    });
    s(this, "getAudioRendition", (e, t = this.getCurrentSubscription().channelId) => {
      const n = this.getRendition(e, t);
      if (n && Oe(n))
        return n;
    });
    s(this, "getRendition", (e, t = this.getCurrentSubscription().channelId) => {
      var n;
      return (n = this.renditions.get(t)) == null ? void 0 : n.find((r) => r.id === e);
    });
    s(this, "getStatistics", () => {
      var t, n, r, o, a, c, d, h, l, m;
      const e = this.getRenditionLevel();
      return {
        videoCodec: (t = e == null ? void 0 : e.video) == null ? void 0 : t.codec,
        audioCodec: (n = e == null ? void 0 : e.audio) == null ? void 0 : n.codec,
        videoRenditionId: (r = e == null ? void 0 : e.video) == null ? void 0 : r.id,
        audioRenditionId: (o = e == null ? void 0 : e.audio) == null ? void 0 : o.id,
        videoWidth: (a = e == null ? void 0 : e.video) == null ? void 0 : a.width,
        videoHeight: (c = e == null ? void 0 : e.video) == null ? void 0 : c.height,
        expectedVideoBitRate: (d = e == null ? void 0 : e.video) == null ? void 0 : d.bitRate,
        expectedAudioBitRate: (h = e == null ? void 0 : e.audio) == null ? void 0 : h.bitRate,
        frameRate: (l = e == null ? void 0 : e.video) == null ? void 0 : l.frameRate,
        language: (m = e == null ? void 0 : e.audio) == null ? void 0 : m.language,
        renditionLevelChangeCount: this.renditionLevelChangeCount
      };
    });
    s(this, "onRenditions", (e) => {
      const t = this.subscriptionSource.getCurrentSubscription();
      this.renditions.set(e.channelId, e.renditions), this.updateRenditionLevels({ to: t, from: t });
    });
    s(this, "onSubscriptionChanged", (e) => {
      this.updateRenditionLevels(e);
    });
    s(this, "updateRenditionLevels", ({ to: e, from: t }) => {
      var h;
      const { channelId: n, initiator: r } = e, o = this.getRenditionLevel(t), a = /* @__PURE__ */ new Set();
      ((h = this.renditions.get(n)) != null ? h : []).filter((l) => l.codec !== "webvtt").forEach((l) => l.language ? a.add(l.language) : void 0), this.languages = Array.from(a), this.renditionLevels = this.createRenditionLevels(e);
      const d = this.getRenditionLevel(e);
      Be(o, d) || (this.renditionLevelChangeCount++, this.emitter.emit("rendition level changed", {
        to: d,
        from: o,
        reason: r ? "manual" : "abr"
      }));
    });
    s(this, "createRenditionLevels", (e) => {
      var l;
      const { video: t, audio: n, channelId: r } = e, o = (l = this.renditions.get(r)) != null ? l : [], a = o.filter(De).filter((m) => t && m.codec === t.codec), c = o.filter(Oe).filter((m) => n && m.codec === n.codec && m.language === n.language), d = Math.max(a.length, c.length), h = [];
      for (let m = 0; m < d; m++) {
        const f = a[Math.min(a.length - 1, m)], p = c[Math.min(c.length - 1, m)];
        h.push({
          audio: p,
          video: f
        });
      }
      return h;
    });
    s(this, "getCurrentSubscription", () => this.subscriptionSource.getCurrentSubscription());
    this.subscriptionSource = t, this.emitter = e, this.emitter.on("renditions", this.onRenditions), this.emitter.on("subscription changed", this.onSubscriptionChanged);
  }
};
s(Ct, "create", (e, t) => new Ct(e, t));
let ui = Ct;
const Qi = (i) => JSON.parse(JSON.stringify(i)), It = class It {
  constructor(e, t, n) {
    s(this, "logger");
    s(this, "timers", new N());
    s(this, "emitter");
    s(this, "targetSubscription");
    s(this, "currentSubscription");
    s(this, "_isSwitchingSubscription", !1);
    s(this, "pendingSubscriptionTimeoutId");
    s(this, "burstMs", 0);
    s(this, "unload", () => {
      this.logger.debug("Unloading module..."), this.timers.unload(), this.emitter.off("subscription changed", this.onSubscriptionChanged), this.logger.debug("Unloaded module");
    });
    s(this, "isSwitchingSubscription", () => this._isSwitchingSubscription);
    s(this, "getTargetSubscription", () => this.targetSubscription);
    s(this, "getCurrentSubscription", () => this.currentSubscription);
    s(this, "enableBurst", (e) => {
      this.burstMs = e;
    });
    s(this, "setSize", (e) => {
      this.targetSubscription.video.width = e.width, this.targetSubscription.video.height = e.height, this.scheduleSubscriptionChange();
    });
    s(this, "setVideoConstraint", (e) => {
      this.targetSubscription.video = e, this.scheduleSubscriptionChange();
    });
    s(this, "setAudioConstraint", (e) => {
      this.targetSubscription.audio = e, this.scheduleSubscriptionChange();
    });
    s(this, "setVideoBitRate", (e) => {
      this.targetSubscription.video.bitRate = e, this.scheduleSubscriptionChange();
    });
    s(this, "setAudioBitRate", (e) => {
      this.targetSubscription.audio.bitRate = e, this.scheduleSubscriptionChange();
    });
    s(this, "setChannelId", (e) => {
      this.targetSubscription.channelId = e, this.scheduleSubscriptionChange();
    });
    s(this, "setLanguage", (e) => {
      this.targetSubscription.audio.language = e, this.scheduleSubscriptionChange();
    });
    s(this, "setVideoCodec", (e) => {
      this.targetSubscription.video.codec = e, this.scheduleSubscriptionChange();
    });
    s(this, "setAudioCodec", (e) => {
      this.targetSubscription.audio.codec = e, this.scheduleSubscriptionChange();
    });
    s(this, "setBurst", (e) => {
      e ? this.targetSubscription.burstMs = e : delete this.targetSubscription.burstMs;
    });
    s(this, "isNewSubscription", () => {
      const e = ["burstMs", "meta", "initiator", "channelGroupId"];
      return !Be(Si(this.currentSubscription, e), Si(this.targetSubscription, e));
    });
    s(this, "onSubscriptionChanged", ({ to: e }) => {
      this.logger.debug("onSubscriptionChanged", { to: e }), this.currentSubscription = g({}, e), this._isSwitchingSubscription = this.isNewSubscription();
    });
    s(this, "scheduleSubscriptionChange", () => {
      this.targetSubscription = Qi(this.targetSubscription), this._isSwitchingSubscription = this.isNewSubscription();
      const e = this.currentSubscription.channelId !== this.targetSubscription.channelId;
      this._isSwitchingSubscription && (e && this.burstMs ? this.setBurst(this.burstMs) : this.setBurst(0), this.pendingSubscriptionTimeoutId && (this.timers.clearTimeout(this.pendingSubscriptionTimeoutId), this.pendingSubscriptionTimeoutId = void 0), this.pendingSubscriptionTimeoutId = this.timers.setTimeout(
        () => this.emitter.emit(
          "send signal",
          JSON.stringify({
            type: "subscribe",
            subscription: this.getTargetSubscription()
          })
        ),
        0
      ));
    });
    this.logger = e, this.targetSubscription = t, this.currentSubscription = Qi(t), this.emitter = n, this.emitter.on("subscription changed", this.onSubscriptionChanged);
  }
};
s(It, "create", (e, t, n) => new It(e, n, t));
let li = It;
const fo = 5e3, go = () => ji() || Pt() || Bs(), zi = () => go() ? 100 : 0, Hi = (i) => (e) => e > i, Bt = class Bt {
  constructor(e, t, n, r, o) {
    s(this, "emitter");
    s(this, "logger");
    s(this, "playbackSource");
    s(this, "bufferSource");
    s(this, "keyframeTimestamps", new X(10));
    s(this, "lastSeekTime", Date.now());
    s(this, "seekCooldownTime", 1e3);
    s(this, "seekTimeoutTime", 5e3);
    s(this, "seekKeyframeOvershoot", 50);
    /**
     * The minimum precision to achieve
     */
    s(this, "syncMaxBehind");
    s(this, "syncMaxBehindMultiplierStep", 1);
    s(this, "syncMaxBehindIncreaseEvery", 2);
    s(this, "syncMaxBehindMaximumAllowed", 2e3);
    s(this, "syncMaxBehindMultiplier", 1);
    s(this, "timeshiftOnAudio", !1);
    /**
     * No more than 150 ms ahead of current time
     */
    s(this, "syncMaxAhead", 150);
    /**
     * Playback rate will be used for diffs greater than playbackRate.maxBehind ms
     */
    s(this, "timeshiftSync", {
      enabled: !1,
      maxBehind: 50,
      multiplier: 1,
      maxBehindAllowed: 600,
      overshoot: zi(),
      minOvershootAllowed: zi(),
      maxOvershootAllowed: 500
    });
    /**
     * The max difference tolerated between server side sync info and local estimation
     */
    s(this, "maxTimeSyncDifferenceTolerance", 150);
    s(this, "timers", N.create());
    s(this, "rtt", 0);
    s(this, "channelSyncInfo", /* @__PURE__ */ new Map());
    s(this, "driftAdjustmentsCount", 0);
    s(this, "timeshiftDriftAdjustmentCount", 0);
    s(this, "driftAdjustments", []);
    s(this, "timeShiftAdjustments", []);
    /**
     * This is the timestamp of the first received sample.
     * Every timestamp is offset by this in order to start the media element timeline from MIN_TIME.
     */
    s(this, "timestampOffset");
    s(this, "currentChannelId");
    s(this, "highestSeenTimestamps", /* @__PURE__ */ new Map());
    s(this, "isSuspended", !1);
    s(this, "isSyncAdjustmentActivated", !1);
    s(this, "load", () => {
      this.timers.setInterval(this.onSync, 100);
    });
    s(this, "unload", () => {
      this.logger.debug("Unloading module..."), this.emitter.off("rtt", this.updateRtt), this.timers.unload(), this.logger.debug("Unloaded module");
    });
    s(this, "suspend", () => {
      this.isSuspended = !0;
    });
    s(this, "unsuspend", () => {
      this.resetSyncState(), this.isSuspended = !1;
    });
    s(this, "deactivateSyncAdjustments", () => {
      this.isSyncAdjustmentActivated = !1;
    });
    s(this, "activateSyncAdjustments", () => {
      this.tryApplySyncInfo(0), this.lastSeekTime = Date.now(), this.isSyncAdjustmentActivated = !0;
    });
    s(this, "reset", () => {
      this.logger.info("Reset sync state"), this.currentChannelId = void 0, this.timestampOffset = void 0, this.resetSyncState(), this.highestSeenTimestamps.clear();
    });
    s(this, "getTimeshiftOffset", () => {
      var e;
      return (e = this.timestampOffset) != null ? e : 0;
    });
    s(this, "getCurrentChannelId", () => this.currentChannelId);
    s(this, "resetSyncState", () => {
      this.timeshiftSync.multiplier = 1, this.syncMaxBehindMultiplier = 1, this.driftAdjustments = [], this.timeShiftAdjustments = [];
    });
    /**
     * @param channelId the channel id to get the live edge time of
     * @returns the estimated live edge time based on edge sync info in ms
     */
    s(this, "getLiveEdgeTime", (e) => {
      const t = this.channelSyncInfo.get(e);
      if (!t)
        return;
      const n = Date.now() - t.localTimestamp;
      return t.timestamp + n;
    });
    /**
     * @param channelId the channel id to get the live edge time of
     * @returns the estimated live edge time based on edge sync info in ms adjusted for latency
     */
    s(this, "getLiveEdgeTimeLatencyAdjusted", (e) => {
      const t = this.getLiveEdgeTime(e);
      if (t)
        return t + this.rtt / 2;
    });
    /**
     * @param channelId the channel id to get the edge wallclock time of
     * @returns the estimated edge wallclock time based on edge sync info in ms
     */
    s(this, "getWallclockTime", (e) => {
      const t = this.channelSyncInfo.get(e);
      if (!t)
        return;
      const n = Date.now() - t.localTimestamp;
      return t.wallclockTime + n;
    });
    /**
     * @param channelId the channel id to get the edge wallclock time of
     * @returns the estimated edge wallclock time based on edge sync info in ms adjusted for latency
     */
    s(this, "getWallclockTimeLatencyAdjusted", (e) => {
      const t = this.getWallclockTime(e);
      if (t)
        return t + this.rtt / 2;
    });
    s(this, "processSample", (e) => {
      var r;
      if (!e.channelId)
        throw new Error("Sample must be assigned to a channel");
      this.currentChannelId || (this.currentChannelId = e.channelId), this.timestampOffset || (this.timestampOffset = e.timestamp / e.timescale * 1e3 - fo);
      const t = e.type === "video" && e.isSync;
      if (this.currentChannelId !== e.channelId) {
        let o = Number.MAX_SAFE_INTEGER;
        console.assert(this.highestSeenTimestamps.size !== 0, "no known timestamps"), this.highestSeenTimestamps.forEach((c) => {
          o = Math.min(o, c);
        });
        const a = e.timestamp / e.timescale * 1e3;
        this.currentChannelId = e.channelId, this.timestampOffset = a - o;
      } else
        (t || this.timeshiftOnAudio) && this.tryTimeshiftSync();
      const n = this.timestampOffset * e.timescale / 1e3;
      return e.timestamp -= n, t && this.keyframeTimestamps.push(e.timestamp / e.timescale * 1e3), this.highestSeenTimestamps.set(
        e.type,
        Math.max((r = this.highestSeenTimestamps.get(e.type)) != null ? r : 0, e.timestamp / e.timescale * 1e3)
      ), e;
    });
    s(this, "getStatistics", () => ({
      drift: this.drift,
      driftAdjustmentCount: this.driftAdjustmentsCount,
      timeshiftDriftAdjustmentCount: this.timeshiftDriftAdjustmentCount,
      seekTime: this.playbackSource.seekTime
    }));
    s(this, "updateRtt", (e) => void (this.rtt = e));
    s(this, "isPlaybackSourceReadyToSeek", () => !this.isSeeking() && this.isSeekCooldownExpired() && this.isSyncAdjustmentActivated);
    /*
     * If the cooldown has expired, we consider us not seeking even though the source still is - this avoids the player getting stuck seeking forever
     */
    s(this, "isSeeking", () => this.playbackSource.isSeeking ? !this.isSeekTimeoutExpired() : !1);
    s(this, "isAllowedToSync", () => this.isPlaybackSourceReadyToSeek() && !!this.currentChannelId && !this.isSuspended && !this.playbackSource.isPaused);
    // Seek cooldown is the min time between seeks
    s(this, "isSeekCooldownExpired", () => Date.now() - this.lastSeekTime > this.seekCooldownTime);
    // Seek timeout is the max time to wait for an actual seek to finish
    s(this, "isSeekTimeoutExpired", () => Date.now() - this.lastSeekTime > this.seekTimeoutTime);
    s(this, "currentTimeshiftMaxBehind", () => Math.min(this.timeshiftSync.maxBehind * this.timeshiftSync.multiplier, this.timeshiftSync.maxBehindAllowed));
    s(this, "currentSyncMaxBehind", () => Math.min(this.syncMaxBehindMultiplier * this.syncMaxBehind, this.syncMaxBehindMaximumAllowed));
    s(this, "currentSyncMaxAhead", () => this.playbackSource.seekTime > 500 ? Math.max(this.syncMaxAhead * this.syncMaxBehindMultiplier, 300) : this.syncMaxAhead);
    s(this, "tryTimeshiftSync", () => {
      var o;
      if (!this.timeshiftSync.enabled || !this.isAllowedToSync())
        return;
      const e = (o = this.drift) != null ? o : 0;
      if (e >= this.syncMaxBehind)
        return;
      if (e < this.currentTimeshiftMaxBehind()) {
        this.timeshiftSync.overshoot = 0;
        return;
      }
      if (!this.timestampOffset)
        return;
      const t = Date.now() - this.seekTimeoutTime * this.timeshiftSync.multiplier, n = this.timeShiftAdjustments.filter(Hi(t)).length;
      if (n && this.timeshiftSync.multiplier > 2)
        return this.logger.debug("Too many diff timeShifts within sliding window", {
          timeShiftsCooldownMs: t,
          timeShiftsWithinCooldownTime: n
        }), !1;
      const r = e + this.timeshiftSync.overshoot;
      this.logger.info("Adjusting for drift using timeshift", {
        drift: e,
        syncAmount: r,
        currentTime: this.playbackSource.currentTime,
        rtt: this.rtt,
        overshoot: this.timeshiftSync.overshoot
      }), this.timestampOffset += r, this.lastSeekTime = Date.now(), !this.playbackSource.isPaused && (this.timeShiftAdjustments.push(this.lastSeekTime), this.timeshiftDriftAdjustmentCount++, this.timeshiftSync.multiplier++, this.timeshiftSync.overshoot = Math.max(
        this.timeshiftSync.minOvershootAllowed,
        Math.min(this.timeshiftSync.multiplier * e / 2, this.timeshiftSync.maxOvershootAllowed)
      ));
    });
    /**
     * Tries to sync by either adjusting playback rate or setting current time
     */
    s(this, "onSync", () => {
      var c;
      if (!this.isAllowedToSync())
        return;
      const e = (c = this.drift) != null ? c : 0;
      if (e < 0 && -e < this.currentSyncMaxAhead() || e > 0 && e < this.currentSyncMaxBehind() || Math.abs(e) < 1 || !this.isSeekCooldownExpired())
        return;
      const t = Date.now() - this.seekTimeoutTime * this.syncMaxBehindMultiplier, n = this.driftAdjustments.filter(Hi(t)).length;
      if (n && this.syncMaxBehindMultiplier > 2)
        return this.logger.debug("Too many diff adjustments within sliding window", {
          adjustmentsCooldownMs: t,
          adjustmentsWithinCooldownTime: n
        }), !1;
      const r = this.playbackSource.seekTime, o = this.playbackSource.currentTime + e, a = this.findKeyframeCloseToTimestamp(o);
      if (a || this.keyframeTimestamps.isEmpty()) {
        const d = a ? a + this.seekKeyframeOvershoot : o;
        if (this.logger.info("Adjusting for drift using seek", {
          drift: e,
          currentTime: this.playbackSource.currentTime,
          targetCurrentTime: d,
          seekTime: r,
          rtt: this.rtt
        }), this.lastSeekTime = Date.now(), this.driftAdjustments.push(this.lastSeekTime), this.driftAdjustmentsCount++, this.playbackSource.currentTime = d + r, this.timeshiftSync.overshoot = Math.max(this.timeshiftSync.minOvershootAllowed, this.timeshiftSync.overshoot / 2), this.driftAdjustmentsCount % this.syncMaxBehindIncreaseEvery === 0 && !this.playbackSource.isPaused) {
          const h = this.currentSyncMaxBehind;
          this.syncMaxBehindMultiplier += this.syncMaxBehindMultiplierStep, h !== this.currentSyncMaxBehind && this.logger.info("Increasing max drift behind allowed", { from: h, to: this.currentSyncMaxBehind });
        }
      }
    });
    s(this, "findKeyframeCloseToTimestamp", (e) => {
      const t = this.keyframeTimestamps.items();
      for (const n of t)
        if (n >= e && n <= e + 200)
          return n;
    });
    this.logger = t, this.emitter = e, this.playbackSource = n, this.bufferSource = r, this.timeshiftSync.enabled = o, this.syncMaxBehind = this.timeshiftSync.enabled ? 1e3 : 200, this.emitter.on("rtt", this.updateRtt);
  }
  updateChannelSyncInfo(e, t) {
    const n = Date.now(), r = this.channelSyncInfo.get(e), o = this.getLiveEdgeTime(e);
    if (this.isSuspended)
      return;
    if (!r || !o) {
      this.logger.info("Initial timing info", { syncInfo: t }), this.channelSyncInfo.set(e, L(g({}, t), { localTimestamp: n, timeDifferences: new X(12) }));
      return;
    }
    const a = t.wallclockTime - r.wallclockTime, c = t.timestamp - r.timestamp, d = n - r.localTimestamp, h = c - d;
    if (r.timeDifferences.push(h), this.logger.debug("Timing info", {
      rtt: this.rtt,
      channelId: e,
      syncInfo: t,
      localTimestamp: n,
      diffFromEstimated: h,
      timestampDelta: c,
      wallclockDelta: a,
      localWallclockDelta: d
    }), Math.abs(h) >= this.bufferSource.getTargetBufferTime() * 2) {
      this.logger.info("Resetting sync info", { diffFromEstimated: h }), this.channelSyncInfo.set(e, L(g({}, t), {
        localTimestamp: n,
        timeDifferences: new X(r.timeDifferences.maxSize + 1)
      })), this.currentChannelId && this.currentChannelId === e && (this.reset(), this.emitter.emit("channel reset"));
      return;
    }
    r.timeDifferences.isFull() && this.tryApplySyncInfo(this.maxTimeSyncDifferenceTolerance);
  }
  tryApplySyncInfo(e) {
    const t = this.getCurrentChannelId();
    if (!t)
      return;
    const n = this.channelSyncInfo.get(t);
    if (!n)
      return;
    const r = et(n.timeDifferences.items());
    Math.abs(r) > e && (this.logger.info("Adjusting sync info", { averageDifference: r }), n.timestamp += r, n.timeDifferences.clear());
  }
  /**
   * Local current time normalized between all channels in the channel group
   */
  get serverCurrentTime() {
    return this.channelCurrentTime - this.getTimeshiftOffset();
  }
  get channelCurrentTime() {
    const e = this.getCurrentChannelId();
    if (!e)
      return 0;
    const t = this.getLiveEdgeTime(e);
    return t ? t - this.bufferSource.getTargetBufferTime() : 0;
  }
  get drift() {
    return this.serverCurrentTime - this.playbackSource.currentTime;
  }
};
s(Bt, "create", (e, t, n, r, o) => new Bt(e, t, n, r, o));
let mi = Bt;
const po = {
  enabled: !0,
  interval: 3e4,
  includeErrors: !0,
  includeEvents: !0,
  includeStats: !0,
  maxRetries: 10,
  maxErrorReports: 50,
  maxEvents: 50
}, zt = (i, e) => L(g({}, e), { type: i, timestamp: (/* @__PURE__ */ new Date()).toISOString(), discriminator: "web" }), Rt = class Rt {
  constructor(e, t, n, r) {
    s(this, "logger");
    s(this, "timers", new N());
    s(this, "emitter");
    s(this, "options");
    s(this, "parentContext");
    s(this, "unsentLines", new X(100));
    s(this, "retries", 0);
    s(this, "errorCount", 0);
    s(this, "eventCount", 0);
    s(this, "statsCount", 0);
    s(this, "unload", () => {
      this.logger.debug("Unloading module..."), window.removeEventListener("error", this.onError), window.removeEventListener("unhandledrejection", this.onRejection), this.timers.unload(), this.emitter.off("error", this.addError), this.emitter.off("visibilitystate", this.onVisibilityChange), this.emitter.off("pagehide", this.onPageHide), this.addStats({ isFinal: !0, initiator: "unload" }), this.send("beacon"), this.logger.debug("Unloaded module");
    });
    s(this, "load", () => {
      window.addEventListener("error", this.onError), window.addEventListener("unhandledrejection", this.onRejection), this.emitter.on("error", this.addError), this.emitter.on("visibilitystate", this.onVisibilityChange), this.emitter.on("pagehide", this.onPageHide), this.timers.setInterval(() => {
        this.addStats(), this.send("fetch");
      }, this.options.interval);
    });
    s(this, "addStats", ({ isFinal: e, initiator: t } = { isFinal: !1, initiator: "interval" }, n = {}) => {
      if (!this.options.includeStats)
        return;
      const r = this.parentContext.getStatistics(), o = zt("stats", L(g(g({}, n), r), { isFinal: e, initiator: t, count: this.statsCount++ }));
      this.unsentLines.push(o);
    });
    s(this, "addEvent", (e) => {
      if (!this.options.includeEvents || this.eventCount > this.options.maxEvents)
        return;
      const t = this.parentContext.getStatistics(), n = zt("event", g(g({}, t), e));
      this.eventCount++, this.unsentLines.push(n);
    });
    s(this, "getStatistics", () => ({
      errorCount: this.errorCount
    }));
    s(this, "send", (e) => I(this, null, function* () {
      if (this.options.enabled && !(this.retries >= this.options.maxRetries) && !this.unsentLines.isEmpty()) {
        this.logger.debug("Sending telemetry", { lines: this.unsentLines.items() });
        try {
          const t = this.unsentLines.items().map((n) => JSON.stringify(n)).reverse().join(`
`);
          switch (e) {
            case "beacon":
              navigator.sendBeacon(this.options.url, t);
              break;
            case "fetch":
            default:
              this.parentContext.connectionState === "connected" ? this.emitter.emit(
                "send signal",
                JSON.stringify({
                  type: "telemetry",
                  body: t
                })
              ) : yield Ss(new URL(this.options.url), { body: t, headers: { "Content-Type": "text/plain" } });
              break;
          }
          this.retries = 0, this.unsentLines.clear();
        } catch (t) {
          this.retries++;
        }
      }
    }));
    s(this, "onVisibilityChange", (e) => {
      e === "hidden" && (this.addStats({ isFinal: !0, initiator: "visibilitychange" }), this.send("beacon"));
    });
    s(this, "onPageHide", (e) => {
      this.addStats({ isFinal: !0, initiator: "pagehide" }, { persisted: e.persisted }), this.send("beacon");
    });
    s(this, "onRejection", (e) => this.addError(e.reason));
    s(this, "onError", (e) => this.addError(e.error));
    s(this, "addError", (e) => {
      const { includeErrors: t, maxErrorReports: n } = this.options;
      if (t && e instanceof b) {
        if (this.errorCount++, this.errorCount > n)
          return;
        const r = this.parentContext.getStatistics();
        this.unsentLines.push(
          zt("error", g(g({}, r), e.toStringifiable()))
        );
      }
    });
    this.logger = e, this.emitter = t, this.options = g(g({}, po), n), this.parentContext = r;
  }
};
s(Rt, "create", (e, t, n, r) => new Rt(e, t, n, r));
let dt = Rt;
const kt = class kt {
  constructor(e, t, n) {
    s(this, "logger");
    s(this, "element");
    s(this, "documentState");
    s(this, "timers", new N());
    s(this, "unload", () => {
      this.timers.unload();
    });
    s(this, "unpause", () => {
      this.element.userHasProvidedInput && this.element.isPaused && this.documentState.isVisible && this.documentState.isOnline && (this.logger.debug("Unpause video"), this.element.tryPlay());
    });
    this.logger = e, this.element = t, this.documentState = n, this.timers.setInterval(this.unpause, 100);
  }
};
s(kt, "create", (e, t, n) => new kt(e, t, n));
let ht = kt;
const wo = 6, So = (i) => {
  let e = [i], t = 0, n = 0, r = !1;
  const o = (c, d) => {
    var k, M, C;
    c.flags && Ge(c.flags) && (t = (k = c.compositionTimeOffset) != null ? k : 0), c.timestamp += t, c.compositionTimeOffset = ((M = c.compositionTimeOffset) != null ? M : 0) - t;
    const h = c.timestamp / c.timescale, m = d.flags && Ge(d.flags) ? (C = d.compositionTimeOffset) != null ? C : 0 : t, p = (d.timestamp + m) / d.timescale, v = Math.max(0, Math.round((p - h) * c.timescale));
    return v > 0 && (n = v), L(g({}, c), {
      /*
        During resync timeshifts we may end up with negative durations (normalized to 0 above) which is not allowed in mse (the MseModule
        drops the frame) so we use the last known duration instead. This is not ideal but it's better than dropping the frame.
       */
      duration: v > 0 ? v : n
    });
  };
  return (c, d = !1) => {
    if (c.flags && Ge(c.flags) && d && (r = !r), !(d && e.length < wo && r) && e.length > 0) {
      r = !1;
      let l = c;
      for (let f = e.length - 1; f > 0; f--) {
        const p = e[f];
        if (!p || !l)
          break;
        p.timestamp >= l.timestamp ? e.splice(f, 1) : l = p;
      }
      const m = e.map(
        (f, p) => o(f, e[p + 1] || c)
      );
      return e = [c], m;
    }
    return e.push(c), [];
  };
}, vo = (i, e) => {
  if (!i)
    return;
  const t = new URL("/subscribe", i);
  return t.searchParams.append("channelId", e.channelId), t.searchParams.append("sessionId", e.sessionId), t.searchParams.append("clientId", e.clientId), e.audio && e.audio.codec && (t.searchParams.append("audio.bitRate", Math.round(e.audio.bitRate).toString()), t.searchParams.append("audio.codec", e.audio.codec), e.audio.language && t.searchParams.append("audio.language", e.audio.language)), e.video && e.video.codec && (t.searchParams.append("video.width", e.video.width.toString()), t.searchParams.append("video.height", e.video.height.toString()), t.searchParams.append("video.bitRate", Math.round(e.video.bitRate).toString()), t.searchParams.append("video.codec", e.video.codec)), e.expectAdditionalConnection && t.searchParams.append("expectAdditionalConnection", e.expectAdditionalConnection.toString()), e.burstMs && t.searchParams.append("burstMs", e.burstMs.toString()), e.channelGroupId && t.searchParams.append("channelGroupId", e.channelGroupId), e.authToken && (t.searchParams.append("auth.token", e.authToken), t.searchParams.append("auth.type", "jwt")), t.toString();
}, bo = (i, e, t) => {
  if (De(e))
    return g(L(g({}, i), {
      type: "video",
      codec: e.codec,
      isSync: Ge(i.flags),
      data: i.payload,
      duration: 0,
      width: e.width,
      height: e.height
    }), t);
  if (e.codec === "webvtt")
    throw new Error("WebVTT is not supported");
  return L(g({}, i), {
    type: "audio",
    channels: e.channels,
    sampleRate: e.sampleRate,
    codec: e.codec,
    language: e.language,
    isSync: Ge(i.flags),
    data: i.payload,
    duration: 0
  });
};
class Eo {
  constructor() {
    s(this, "highEntropyValues");
    var e;
    (e = self.navigator.userAgentData) == null || e.getHighEntropyValues(["architecture", "model", "platformVersion", "fullVersionList"]).then((t) => {
      this.highEntropyValues = t;
    });
  }
  getUserAgentInformation() {
    var o, a, c, d, h, l;
    const e = window.location.origin, n = !e || e == "null" ? "" : `${window.location.pathname}${window.location.search}`.substring(0, 1e3), r = {
      locationOrigin: window.location.origin,
      locationPath: n,
      ancestorOrigins: ((o = window.location.ancestorOrigins) == null ? void 0 : o.length) > 0 ? Array.from(window.location.ancestorOrigins) : void 0,
      hardwareConcurrency: navigator.hardwareConcurrency,
      deviceMemory: navigator.deviceMemory
    };
    if (self.navigator.userAgentData && this.highEntropyValues) {
      const m = "1", f = [...(a = this.highEntropyValues.brands) != null ? a : []];
      f.sort((C, E) => C.brand.localeCompare(E.brand));
      const p = [...(c = this.highEntropyValues.fullVersionList) != null ? c : []];
      p.sort((C, E) => C.brand.localeCompare(E.brand));
      const v = p.map((C) => C.version), B = f.map((C) => C.brand), k = f.map((C) => C.version), M = parseInt((h = (d = this.highEntropyValues.platformVersion) == null ? void 0 : d.split(".")[0]) != null ? h : m);
      return g({
        userAgentLegacy: window.navigator.userAgent,
        ua: {
          browser: {
            brands: B,
            fullVersionBrands: v,
            majorVersions: k
          },
          device: this.highEntropyValues.model || "Other",
          os: {
            family: this.highEntropyValues.platform || "Other",
            version: (l = this.highEntropyValues.platformVersion) != null ? l : m,
            major_version: Number.isFinite(M) ? M : 0
          }
        }
      }, r);
    } else
      return g({
        userAgent: window.navigator.userAgent
      }, r);
  }
}
const Gi = (i, e) => i && typeof i == "object" && e in i, yo = (i) => !(typeof i != "object" || !Gi(i, "channelId") || typeof i.channelId != "string" || !Gi(i, "url") || typeof i.url != "string" || i.channelId.length === 0 || i.url.length === 0), To = (i) => {
  if (!yo(i))
    throw new b("Invalid options", { isFatal: !0, code: "invalid_options" });
  const e = g({}, i);
  return Object.keys(e).forEach((t) => {
    const n = e;
    typeof n[t] == "undefined" && delete n[t];
  }), e;
}, Co = (i) => {
  if (typeof i != "object" || i === null)
    throw new Error("not an object");
  if (!("video" in i))
    throw new Error("missing video in subscription");
  if (!("audio" in i))
    throw new Error("missing audio in subscription");
  if (!("channelId" in i))
    throw new Error("missing channelId");
  return !0;
};
var Ke, Z, Te;
const G = class G extends pe {
  constructor(t) {
    super();
    // 10s
    /**
     * Picture in picture
     */
    s(this, "pictureInPicture");
    s(this, "browser", xs());
    s(this, "options");
    s(this, "element");
    s(this, "playbackSource");
    s(this, "emitter", new pe());
    s(this, "logger");
    s(this, "modules");
    s(this, "clientIp");
    s(this, "sessionId");
    s(this, "clientId", bi());
    s(this, "_channels", []);
    s(this, "createdAt", Date.now());
    s(this, "hasCalledConnect", !1);
    s(this, "apiClient");
    s(this, "latestEmittedLanguages", []);
    s(this, "wakeLock");
    s(this, "cachedEdges", []);
    s(this, "shiftedEdges", []);
    s(this, "pool", new pi(G.MAX_POOL_SIZE));
    s(this, "userAgentInformation", new Eo());
    R(this, Ke, 0);
    R(this, Z, []);
    s(this, "sampleProcessingSesssions", /* @__PURE__ */ new Map());
    s(this, "sizes", /* @__PURE__ */ new Map());
    s(this, "isSuspended", !0);
    s(this, "disconnectTimeout");
    R(this, Te);
    /**
     * Attaches the video view to a DOM element. The Vindral video view will be sized to fill this element while
     * maintaining the correct aspect ratio.
     * @param container the container element to append the video view to. Often a div element.
     * @returns
     */
    s(this, "attach", (t) => {
      var n;
      (n = this.wakeLock) == null || n.attach(t), t.appendChild(this.element);
    });
    // End Undocumented getters/setters
    /**
     * Get active Vindral Options
     */
    s(this, "getOptions", () => this.options.getOptions());
    /**
     * Get url for fetching thumbnail. Note that fetching thumbnails only works for an active channel.
     */
    s(this, "getThumbnailUrl", () => {
      let t = this.options.get("edgeUrl") || this.options.get("url");
      t = t.replace("wss://", "https://"), t = t.replace("ws://", "http://"), t = t.endsWith("/") ? t.slice(0, -1) : t;
      const n = this.options.get("authenticationToken"), r = n ? `&auth.token=${n}` : "";
      return `${t}/api/thumbnail?channelId=${this.options.get("channelId")}${r}`;
    });
    /**
     * Update authentication token on an already established and authenticated connection
     */
    s(this, "updateAuthenticationToken", (t) => {
      this.logger.debug("Got new auth token", { token: t }), this.options.set("authenticationToken", t), this.emitter.emit(
        "send signal",
        JSON.stringify({
          type: "refresh auth",
          token: t
        })
      );
    });
    /**
     * @deprecated since 3.0.0 Use play instead.
     * Connects to the configured channel and starts streaming
     */
    s(this, "connect", () => {
      this.hasCalledConnect || (this.play(), this._connect());
    });
    s(this, "_connect", () => {
      var t, n;
      this.hasCalledConnect || (this.hasCalledConnect = !0, Object.values(this.modules).forEach((r) => {
        r && "load" in r && r.load();
      }), this.unsuspend(), this.playbackSource instanceof Wt && ((n = (t = this.playbackSource).load) == null || n.call(t)), this.modules.connection.connect(this.options.get("media") === "audio+video" ? 2 : 1));
    });
    /**
     * Get options that can be used for CastSender
     */
    s(this, "getCastOptions", () => ({
      url: this.options.get("url"),
      channelId: this.options.get("channelId"),
      channelGroupId: this.options.get("channelGroupId"),
      authenticationToken: this.options.get("authenticationToken"),
      language: this.options.get("language"),
      logLevel: this.options.get("logLevel"),
      minBufferTime: this.options.get("minBufferTime"),
      tags: this.options.get("tags"),
      ownerSessionId: this.sessionId,
      edgeUrl: this.options.get("edgeUrl"),
      media: this.options.get("media")
    }));
    s(this, "connectionInfo", () => I(this, null, function* () {
      try {
        return yield this.apiClient.connect(this.options.getOptions());
      } catch (t) {
        if (Es(t))
          switch (t.status) {
            case 401:
              throw this.emitter.emit("error", ot(t)), ot(t);
            case 403:
              throw this.emitter.emit("error", Ti(t.message)), Ti(t.message);
          }
        throw this.emitter.emit("error", hn(t instanceof Error ? t : void 0)), t;
      }
    }));
    s(this, "estimateRTT", () => I(this, null, function* () {
      const t = Date.now(), n = () => Date.now() - t;
      return Promise.race([
        Zi(G.PING_TIMEOUT),
        fetch(new URL("/api/v2/connect/ping", this.options.get("url")).toString(), {
          method: "HEAD"
        })
      ]).then(n, n);
    }));
    s(this, "connectHandler", () => I(this, null, function* () {
      var M, C;
      this.sessionId = bi();
      const t = this.modules.subscription.getTargetSubscription(), [n, r] = yield Promise.all([this.connectionInfo(), this.estimateRTT()]), o = r / 2, a = qt(o), c = n.channels.find((E) => E.channelId === t.channelId);
      if (this.emitter.emit("connect info", n), this._channels = n.channels, this.updateTextTracks((M = c == null ? void 0 : c.renditions) != null ? M : []), !this.textTrack && this.options.get("textTrack") && (this.textTrack = this.options.get("textTrack")), yield Promise.all(
        n.channels.map((E) => I(this, null, function* () {
          E.overrides && this.options.addOverrides(E.channelId, E.overrides), E.renditions = yield this.filterRenditions(E.renditions), this.modules.renditions.setRenditions(E.channelId, E.renditions);
        }))
      ), !c)
        throw Ji("external");
      const d = this.options.getOverride(
        "sizeBasedResolutionCapEnabled",
        this.channelId
      );
      d !== void 0 && (this.modules.constraintCap.sizeBasedResolutionCapEnabled = d);
      const h = this.options.getOverride("separateVideoSocketEnabled", this.channelId);
      h !== void 0 && this.options.get("media") === "audio+video" && this.modules.connection.setConnectionCount(h ? 2 : 1);
      const l = this.options.getOverride("minBufferTime", this.channelId), m = this.options.getOverride("maxBufferTime", this.channelId);
      if ((l || m) && (this.modules.bufferTime.updateConfig({
        minBufferTime: this.options.get("minBufferTime", this.channelId),
        maxBufferTime: this.options.get("maxBufferTime", this.channelId)
      }), this.targetBufferTime = this.options.get("minBufferTime", this.channelId)), this.options.get("burstEnabled", this.channelId) && this.modules.subscription.enableBurst(this.targetBufferTime), this.emit("is live", c.isLive), !c.isLive)
        throw new Error("Waiting for channel to go live");
      this.patchSubscription(c, a), yield this.initializeDecodingModule(), this.resetModules(), this.emit("rendition levels", this.modules.renditions.getRenditionLevels()), this.emit("channels", this.channels), this.emitLanguagesIfChanged(), this.sampleProcessingSesssions.clear(), this.cachedEdges = this.cachedEdges.length === 0 ? n.edges : this.cachedEdges;
      const p = (this.options.get("edgeUrl") ? [this.options.get("edgeUrl")] : [this.cachedEdges.shift()])[0], v = this.options.get("burstEnabled", this.channelId), B = vo(p, {
        video: this.targetSubscription.video,
        audio: this.targetSubscription.audio,
        burstMs: v ? this.targetBufferTime : void 0,
        sessionId: this.sessionId,
        clientId: this.clientId,
        channelId: this.channelId,
        channelGroupId: this.options.get("channelGroupId"),
        expectAdditionalConnection: this.modules.connection.getConnectionCount() > 1,
        authToken: this.options.get("authenticationToken")
      });
      if (!B || !p)
        throw new b("Failed to resolve edge url", { isFatal: !0, code: "failed_to_resolve_edge_url" });
      const k = this.shiftedEdges[this.shiftedEdges.length - 1];
      return k && ((C = this.modules.telemetry) == null || C.addEvent({ code: "shifted_edge", edgeUrl: k })), this.shiftedEdges.push(p), this.logger.debug("resolved edge url", { edgeUrl: B }), Promise.resolve(B);
    }));
    s(this, "emitLanguagesIfChanged", () => {
      const t = this.modules.renditions.getLanguages(), n = this.latestEmittedLanguages;
      t.length == n.length && t.every((o) => n.includes(o)) || (this.logger.debug("Emitting new languages", { currentLanguages: t }), this.latestEmittedLanguages = t, this.emit("languages", this.latestEmittedLanguages));
    });
    s(this, "updateTextTracks", (t) => {
      const n = t.filter((r) => r.codec === "webvtt");
      n.forEach((r) => {
        if (!u(this, Z).find((a) => a.language === r.language)) {
          if (this.modules.canvasModule) {
            const a = this.modules.canvasModule.textTracks.addTextTrack(
              r.kind,
              r.label || r.language || "",
              r.language || ""
            );
            u(this, Z).push(a);
          } else if (this.mediaElement instanceof HTMLVideoElement) {
            const a = this.mediaElement.addTextTrack(
              r.kind,
              r.label || r.language,
              r.language
            );
            u(this, Z).push(a);
          }
        }
      });
      for (const r of u(this, Z))
        n.find((a) => a.language === r.language) ? r.mode === "disabled" && (r.mode = "hidden") : r.mode = "disabled";
      this.emit("text tracks", this.textTracks);
    });
    s(this, "cleanupTextTracks", (t = this.currentTime - 2e4) => {
      u(this, Z).forEach((n) => {
        if (n.cues)
          for (const r of n.cues)
            r.endTime * 1e3 < t - 2e3 && n.removeCue(r);
      });
    });
    s(this, "filterRenditions", (t) => I(this, null, function* () {
      const n = yield Promise.all(
        t.map((c) => I(this, null, function* () {
          var l, m, f;
          if (Oe(c))
            return !0;
          if (!De(c) || !this.isSupportedVideoCodecProfile(c.codec, c.codecString))
            return !1;
          if (!this.willUseMediaSource()) {
            const p = this.options.get("advanced"), v = (l = p.wasmDecodingConstraint.bitRate) != null ? l : Number.MAX_SAFE_INTEGER, B = (m = p.wasmDecodingConstraint.width) != null ? m : Number.MAX_SAFE_INTEGER, k = (f = p.wasmDecodingConstraint.height) != null ? f : Number.MAX_SAFE_INTEGER;
            return c.bitRate <= v && c.width <= B && c.height <= k;
          }
          const d = yield Nr(c);
          if (!d.supported || c.codec == "av1" && !d.smooth && !d.powerEfficient)
            return !1;
          const h = this.options.getOverride("maxVideoBitRate", this.channelId);
          return h ? h >= c.bitRate : !0;
        }))
      );
      let r = t.filter((c, d) => n[d]);
      const o = r.filter((c) => c.codec === "h264").reverse()[0], a = r.filter((c) => c.codec === "av1").reverse()[0];
      return o && a && o.width > a.width && o.height > a.height && (r = r.filter((c) => c.codec !== "av1")), r;
    }));
    /**
     * Patch the subscription with properties from the channel that isn't known until connection
     * @param channel Channel with the renditions to patch the subscription based on
     */
    s(this, "patchSubscription", (t, n) => {
      const r = Math.min(
        this.options.get("maxVideoBitRate"),
        G.INITIAL_MAX_BIT_RATE,
        n,
        this.targetSubscription.video.bitRate
      ), o = Math.min(
        this.options.get("maxAudioBitRate"),
        G.INITIAL_MAX_BIT_RATE,
        n,
        this.targetSubscription.audio.bitRate
      ), a = this.options.get("media") === "audio" ? [] : this.options.get("videoCodecs", this.channelId), c = this.supportedAudioCodecs(), d = t.renditions.filter(Oe), h = t.renditions.filter(De), l = c.find((v) => d.find((B) => B.codec === v) !== void 0), m = a.find((v) => h.find((B) => B.codec === v) !== void 0), f = d.map((v) => v.language);
      if (this.logger.debug("supported and selected codecs", { audioCodecs: c, videoCodecs: a, audioCodec: l, videoCodec: m }), m) {
        const v = this.options.get("maxSize");
        this.modules.subscription.setVideoConstraint(g({
          codec: m,
          bitRate: this.abrEnabled ? r : this.options.get("maxVideoBitRate")
        }, v));
      }
      l && (this.modules.subscription.setAudioConstraint({
        codec: l,
        bitRate: this.abrEnabled ? o : this.options.get("maxAudioBitRate"),
        language: this.options.get("language")
      }), (!f.includes(this.options.get("language")) || this.language === void 0) && this.modules.subscription.setLanguage(f[0])), this.alignSizeAndBitRate(this.targetSubscription);
      const p = this.modules.subscription.getTargetSubscription();
      this.emitter.emit("subscription changed", {
        to: p,
        from: this.modules.subscription.getCurrentSubscription()
      });
    });
    s(this, "isSupportedVideoCodecProfile", (t, n) => {
      if (this.willUseMediaSource()) {
        const r = We();
        return r ? r.isTypeSupported(Me({ codec: t, codecString: n })) : !0;
      }
      if (t === "h264") {
        const r = !!(n != null && n.startsWith("avc1.42")), o = !!(n != null && n.startsWith("avc1.66."));
        return r || o;
      }
      return t !== "av1";
    });
    s(this, "supportedAudioCodecs", () => {
      if (this.options.get("media") === "video")
        return [];
      const t = [];
      return (this.browser.supportsMp4Opus && this.options.get("mseOpusEnabled") || !this.willUseMediaSource()) && t.push("opus"), this.willUseMediaSource() && t.push("aac"), t;
    });
    s(this, "initializeDecodingModule", () => I(this, null, function* () {
      var r, o;
      const t = this.currentRenditionLevel, n = [];
      if (!t)
        throw new b("No currentRenditionLevel", { code: "no_current_rendition_level", isFatal: !1 });
      if (t != null && t.video && n.push({
        type: "video",
        mimeType: Me(t.video)
      }), t != null && t.audio && n.push({
        type: "audio",
        mimeType: Me(t.audio)
      }), n.length === 0)
        throw new b("Can't initialize decoding module without tracks", { code: "no_tracks", isFatal: !1 });
      if (this.willUseMediaSource() && this.element instanceof HTMLMediaElement)
        this.emitter.emit("flush buffers"), yield (r = this.modules.mseModule) == null ? void 0 : r.setSourceBuffers(n);
      else {
        const a = yield Ai.create(
          this.emitter,
          this.logger.createContext("DecoderModule"),
          n,
          this.playbackSource,
          this.pool
        );
        (o = this.modules.decoder) == null || o.unload(), this.modules.decoder = a, this.modules.decoder.load();
      }
    }));
    /**
     * Fully unloads the instance. This disconnects the clients and stops any background tasks.
     * This client instance can not be used after this has been called.
     */
    s(this, "unload", () => I(this, null, function* () {
      var t, n, r;
      this.logger.debug("Unloading modules..."), yield Promise.all(Object.values(this.modules).map((o) => o == null ? void 0 : o.unload())), (t = this.wakeLock) == null || t.unload(), this.pool = new pi(G.MAX_POOL_SIZE), (r = (n = this.playbackSource).unload) == null || r.call(n), this.element.remove(), this.emitter.reset(), this.reset(), this.logger.debug("Unloaded modules");
    }));
    /**
     * @deprecated since 3.0.0 Use play instead.
     *
     * Activates audio or video on web browsers that require a user gesture to enable media playback.
     * The Vindral instance will emit a "needs user input" event to indicate when this is needed.
     * But it is also safe to pre-emptively call this if it is more convenient - such as in cases where
     * the Vindral instance itself is created in a user input event.
     *
     * Requirements: This method needs to be called within an user-input event handler to function properly, such as
     * an onclick handler.
     *
     * Note: Even if you pre-emptively call this it is still recommended to listen to "needs user input"
     * and handle that event gracefully.
     */
    s(this, "userInput", () => {
      this.play();
    });
    /**
     * Pauses the stream. Call .play() to resume playback again.
     */
    s(this, "pause", () => {
      this.options.get("pauseSupportEnabled") && this.playbackState !== "paused" && (this.playbackSource.pause(), this.hasCalledConnect && this.suspend());
    });
    s(this, "registerDebugInstance", () => {
      Or(this);
    });
    /**
     *
     * Start playing the stream.
     *
     * This method also activates audio or video on web browsers that require a user gesture to enable media playback.
     * The Vindral instance will emit a "needs user input" event to indicate when this is needed.
     * But it is also safe to pre-emptively call this if it is more convenient - such as in cases where
     * the Vindral instance itself is created in a user input event.
     *
     * Note: In most browsers this method needs to be called within an user-input event handler, such as
     * an onclick handler in order to activate audio. Most implementations call this directly after constructing the Vindral
     * instance once in order to start playing, and then listen to a user-event in order to allow audio to be activated.
     *
     * Note 2: Even if you pre-emptively call this it is still recommended to listen to "needs user input"
     * and handle that event gracefully.
     */
    s(this, "play", () => {
      var t;
      this.hasCalledConnect ? this.unsuspend() : this.playbackState !== "playing" && (this._connect(), self.addEventListener("__vindral_register_debug__", this.registerDebugInstance), this.modules.timer.setInterval(() => this.cleanupTextTracks(), G.REMOVE_CUE_THRESHOLD)), (t = this.wakeLock) == null || t.enable(), this.playbackState === "paused" && (this.resetModules(), this.emitter.emit("flush buffers"), this.cleanupTextTracks(Number.MAX_SAFE_INTEGER)), this.playbackSource.play();
    });
    /**
     * This method collects a statistics report from internal modules. While many of the report's properties are documented, the report may also contain undocumented
     * properties used internally or temporarily for monitoring and improving the performance of the service.
     *
     * Use undocumented properties at your own risk.
     */
    s(this, "getStatistics", () => Object.values(this.modules).reduce(
      (t, n) => n && "getStatistics" in n ? g(g({}, t), n.getStatistics()) : t,
      // Safety: We know that the collective statistics from module map will equal Statistic because the Statistics type is inferred from moduleMap
      this.getRuntimeInfo()
    ));
    s(this, "resetModules", () => {
      Object.values(this.modules).forEach((t) => {
        t && "reset" in t && t.reset();
      }), this.sampleProcessingSesssions.clear(), this.playbackSource.currentTime = 0, this.playbackSource.isActivated = !1;
    });
    s(this, "getRuntimeInfo", () => {
      const t = this.modules.canvasModule ? this.options.get("iosMediaElementEnabled") : void 0;
      return g({
        uptime: Date.now() - this.createdAt,
        version: "4.0.0",
        clientId: this.clientId,
        sessionId: this.sessionId,
        channelId: this.channelId,
        channelGroupId: this.options.get("channelGroupId"),
        ip: this.clientIp,
        url: this.options.get("url"),
        timeToFirstFrame: this.timeToFirstFrame(),
        iosMediaElementEnabled: t
      }, this.userAgentInformation.getUserAgentInformation());
    });
    s(this, "onMediaElementState", (t) => {
      this.logger.info("media element state", { state: t }), this.options.get("pauseSupportEnabled") && (t === "paused" ? this.modules.documentState.isVisible && (this.suspend(), this.modules.connection.disconnect()) : (this.unsuspend(), this.modules.connection.getState() === "disconnected" && this.modules.connection.unsuspend()));
    });
    s(this, "onBufferEvent", (t) => {
      var r, o, a, c;
      this.emit("buffer state event", t);
      const n = !this.playbackSource.isActivated || this.playbackSource.isPaused;
      if (t === "filled" && n) {
        const d = Math.max(
          this.currentTime,
          (o = (r = this.videoBufferedRanges[0]) == null ? void 0 : r.start) != null ? o : 0,
          (c = (a = this.audioBufferedRanges[0]) == null ? void 0 : a.start) != null ? c : 0
        );
        this.logger.info("Buffer filled - starting playback", { currentTime: d }), this.playbackSource.currentTime = d, this.modules.sync.activateSyncAdjustments(), this.playbackSource.isActivated = !0;
      } else t === "drained" && this.playbackSource.isPaused && (this.playbackSource.isActivated = !1, this.modules.sync.deactivateSyncAdjustments());
    });
    s(this, "timeToFirstFrame", () => {
      const t = this.modules.playback.getFirstFrameTime(), n = this.modules.connection.firstConnectionTime;
      if (n && t)
        return t - n;
    });
    this.options = new Dr(g(g({}, Fr), To(t)));
    const n = ["localhost", "127.0.0.1"];
    t.telemetryEnabled === void 0 && n.includes(location.hostname) && this.options.set("telemetryEnabled", !1);
    const r = {
      channelId: this.options.get("channelId"),
      audio: {
        language: this.options.get("language"),
        bitRate: this.options.get("maxAudioBitRate")
      },
      video: {
        bitRate: this.options.get("maxVideoBitRate"),
        width: this.options.get("maxSize").width,
        height: this.options.get("maxSize").height
      }
    }, o = Ht.get();
    o.setLevel(this.options.get("logLevel")), o.setDebug(!1), this.logger = o;
    const a = ai.create(
      this.emitter,
      this.logger.createContext("PictureInPictureModule")
    ), c = N.create();
    this.apiClient = new vs({
      publicEndpoint: this.options.get("url").toString(),
      tokenFactory: () => this.options.get("authenticationToken")
    });
    const d = Jt.create(this.emitter, this.logger.createContext("ConnectionModule"), {
      connectHandler: this.connectHandler,
      reconnectHandler: this.options.get("reconnectHandler")
    }), h = li.create(
      this.logger.createContext("SubscriptionModule"),
      this.emitter,
      r
    ), l = ui.create(this.emitter, h), m = hi.create(
      this.emitter,
      this.logger.createContext("QualityOfServiceModule")
    ), f = ci.create(
      this.emitter,
      this.logger.createContext("PlaybackModule"),
      this,
      this.options.get("minBufferTime")
    ), p = $t.create(this.emitter), v = this.options.get("poster"), B = v === !0 ? this.getThumbnailUrl() : v || void 0;
    let k, M, C;
    if (this.willUseMediaSource()) {
      const A = new Wt({
        type: this.options.get("media") == "audio" ? "audio" : "video",
        autoplay: !1,
        muted: this.options.get("muted") || this.options.get("media") === "video",
        logger: this.logger.createContext("MediaElement"),
        poster: B
      });
      A.on("buffer state", (S) => this.emitter.emit("buffer state", S)), A.on("needs user input", (S) => this.emitter.emit("needs user input", S)), A.on("volume state", (S) => this.emit("volume state", S)), A.on("media element state", (S) => this.onMediaElementState(S)), this.element = A.element, this.playbackSource = A, k = oi.create(this.logger.createContext("MseModule"), this.emitter, this.element), this.options.get("pauseSupportEnabled") || (M = ht.create(this.logger.createContext("UnpauseModule"), A, p)), this.options.get("pictureInPictureEnabled") && this.emitter.emit("add picture in picture listener", { element: A.element });
    } else if (this.browser.platform.iosVersion >= 15 && this.options.get("iosMediaElementEnabled")) {
      const A = ri.create(
        this.emitter,
        this.logger.createContext("ModernCanvasModule"),
        this.pool,
        this,
        {
          type: this.options.get("media") == "audio" ? "audio" : "video",
          muted: this.options.get("muted") || this.options.get("media") === "video",
          poster: B
        }
      ), S = A.element();
      this.element = S.element, this.playbackSource = A, C = A, this.options.get("pictureInPictureEnabled") && this.browser.platform.iosVersion > 15 && this.emitter.emit("add picture in picture listener", { element: this.element }), this.options.get("pauseSupportEnabled") || (M = ht.create(this.logger.createContext("UnpauseModule"), S, p));
    } else {
      const A = ni.create(
        this.emitter,
        this.logger.createContext("LegacyCanvasModule"),
        this.pool,
        this,
        this.options.get("muted") || this.options.get("media") === "video"
      );
      this.element = A.element(), this.playbackSource = A, C = A, this.options.get("iosWakeLockEnabled") && (this.wakeLock = new xr());
    }
    this.emitter.on("channel reset", this.resetModules), this.emitter.on("no data timeout", this.resetModules), this.emitter.on("media element state", (A) => this.onMediaElementState(A)), this.emitter.on("volume state", (A) => this.emit("volume state", A)), this.options.get("pauseSupportEnabled") || this.emitter.on("exit picture in picture", () => c.setTimeout(() => this.play(), 0)), this.emitter.on("constraint cap changed", (A) => {
      this.logger.info("new cap set", { cap: A }), this.alignSizeAndBitRate(this.targetSubscription);
    }), this.pictureInPicture = {
      enter: () => a.requestPictureInPicture(),
      exit: () => a.exitPictureInPicture(),
      isActive: () => a.isPictureInPictureActive(),
      isSupported: () => a.isPictureInPictureSupported()
    }, this.emitter.on("error", (A) => {
      if (A.type() === "external" && this.emit("error", A), A.isFatal())
        return () => void this.unload();
    });
    const E = this.browser.platform.isIOS && !this.browser.platform.isIpadOS, H = mi.create(
      this.emitter,
      this.logger.createContext("SyncModule"),
      this.playbackSource,
      f,
      this.willUseMediaSource() && !E
    ), Y = (this.options.get("edgeUrl") || this.options.get("url")).replace("wss://", "https://").replace("ws://", "http://").replace("//lb.", "//errors."), se = new URL("/telemetry", Y).toString(), tt = dt.create(
      this.logger.createContext("TelemetryModule"),
      this.emitter,
      {
        url: se,
        enabled: this.options.get("telemetryEnabled"),
        includeStats: !1,
        interval: 5e3
      },
      this
    );
    this.modules = {
      telemetry: tt,
      bufferTime: Zt.create(
        this.emitter,
        this.logger.createContext("BufferTimeModule"),
        m,
        this,
        {
          maxBufferTime: this.options.get("maxBufferTime"),
          minBufferTime: this.options.get("minBufferTime")
        }
      ),
      incomingData: ei.create(this.emitter),
      adaptivity: jt.create(
        this.emitter,
        this.logger.createContext("AdaptivityModule"),
        m,
        {
          cooldownTime: Math.max(this.options.get("minBufferTime"), 2e3)
        }
      ),
      constraintCap: Yt.create(
        this.emitter,
        this.element,
        l,
        this.options.get("abrEnabled") ? this.options.get("sizeBasedResolutionCapEnabled") : !1
      ),
      event: Kt.create(this.emitter, this.logger.createContext("EventModule"), H),
      sync: H,
      documentState: p,
      connection: d,
      playback: f,
      pictureInPicture: a,
      timer: c,
      subscription: h,
      renditions: l,
      qualityOfService: m,
      mseModule: k,
      unpause: M,
      canvasModule: C
    }, this.modules.adaptivity.isEnabled = this.options.get("abrEnabled"), this.emitter.on("page active", (A) => {
      var S;
      A && typeof this.disconnectTimeout == "number" && (this.modules.timer.clearInterval(this.disconnectTimeout), this.disconnectTimeout = void 0), A ? this.playbackSource.isPaused || (this.logger.debug("Unsuspending"), this.unsuspend()) : (this.logger.debug("Suspending"), this.suspend(), this.modules.decoder ? this.options.get("iosBackgroundPlayEnabled") ? (this.modules.decoder.unsuspend(), (S = this.modules.canvasModule) == null || S.unsuspend()) : this.modules.connection.disconnect() : (this.disconnectTimeout && this.modules.timer.clearInterval(this.disconnectTimeout), this.disconnectTimeout = this.modules.timer.setInterval(() => {
        const P = this.playbackState === "paused" || this.muted;
        this.connectionState === "connected" && P && (this.emitter.emit("flush buffers"), this.modules.connection.disconnect("Page inactive timeout"));
      }, G.DISCONNECT_TIMEOUT)));
    });
    let ne;
    this.emitter.on("context switch complete", () => {
      ne || (ne = window.setTimeout(() => {
        window.clearTimeout(ne), ne = void 0, this.emit("context switch", "completed"), this.emitLanguagesIfChanged();
      }, this.targetBufferTime));
    }), this.emitter.on("context switch started", () => this.emit("context switch", "started")), this.emitter.on("needs user input", (A) => this.emit("needs user input", A)), this.emitter.on("event", (A) => {
      switch (A.type) {
        case "metadata":
          this.emit("metadata", A);
          break;
        case "channel switch":
          this.emit("channel switch", { channelId: A.channelId });
          break;
        case "language switch":
          this.emit("language switch", { language: A.language });
          break;
      }
    }), this.emitter.on("buffer state event", this.onBufferEvent), this.emitter.on("playback state", (A) => this.emit("playback state", A)), this.emitter.on("rendition level changed", ({ to: A }) => {
      A && this.emit("rendition level", A);
    }), this.emitter.on("connection state", (A) => {
      A === "connected" && (this.cachedEdges = [], this.shiftedEdges = []), this.emit("connection state", A);
    }), this.emitter.on("recovered from media error", () => {
      this.modules.adaptivity.reset(this.targetBufferTime * 2);
    }), this.emitter.once("connect info", (A) => {
      var x, O, U;
      const P = ((O = (x = A.telemetry) == null ? void 0 : x.probability) != null ? O : 1) >= Math.random();
      A.telemetry && ((U = this.modules.telemetry) == null || U.unload(), this.modules.telemetry = dt.create(
        this.logger.createContext("TelemetryModule"),
        this.emitter,
        L(g({}, A.telemetry), {
          enabled: this.options.get("telemetryEnabled") && P
        }),
        this
      ), this.modules.telemetry.load());
    }), this.emitter.on("adapt level", (A) => {
      var re, j, oe, K, de;
      this.logger.debug("adapt level", { direction: A });
      const S = this.modules.renditions.getRenditionLevels(), P = this.modules.renditions.getRenditionLevel(), x = S.findIndex((z) => z === P), O = S.length - 1;
      let U = x;
      switch (A) {
        case "upgrade":
          {
            const z = Math.min(x + 1, O), ee = S[z], us = (re = this.modules.connection.estimatedBandwidth) != null ? re : ge(), ls = ((oe = (j = ee == null ? void 0 : ee.audio) == null ? void 0 : j.bitRate) != null ? oe : 0) + ((de = (K = ee == null ? void 0 : ee.video) == null ? void 0 : K.bitRate) != null ? de : 0), ms = us * 2 > ls;
            ee && ms && this.modules.adaptivity.isQoSOk(ee) && (U = z);
          }
          break;
        case "downgrade":
          U = Math.max(x - 1, 0);
          break;
        case "double downgrade":
          U = Math.max(x - 2, 0);
          break;
        case "reconnect":
          if (x === 0 || this.modules.qualityOfService.timeSpentBufferingLast(6e3) > 5e3) {
            if (!this.modules.connection.lastConnectionTime || Date.now() - this.modules.connection.lastConnectionTime < this.modules.qualityOfService.fatalQosGraceTime() || this.modules.connection.getState() !== "connected")
              return;
            this.modules.qualityOfService.incrementFatalQosCount(), this.logger.info("Reconnecting due to poor qos"), this.modules.connection.reconnect("Fatal QOS"), this.emitter.emit("adapted level");
            return;
          } else
            U = 0;
      }
      if (U === x)
        return;
      const Q = S[U];
      this.alignSizeAndBitRate(L(g({}, this.targetSubscription), {
        video: g(g({}, this.targetSubscription.video), Q == null ? void 0 : Q.video),
        audio: g(g({}, this.targetSubscription.audio), Q == null ? void 0 : Q.audio)
      })), this.emitter.emit("adapted level");
    }), this.emitter.on("received signal", (A) => {
      var P;
      const S = A;
      switch (this.logger.debug("received", g({}, S)), S.type) {
        case "client ip":
          this.clientIp = S.ip;
          break;
        case "renditions":
          this.updateTextTracks(S.renditions), _(this, Te, this.filterRenditions(S.renditions).then((x) => {
            this.emitter.emit("renditions", {
              renditions: x,
              channelId: this.currentSubscription.channelId
            }), this.emit("rendition levels", this.modules.renditions.getRenditionLevels()), this.emitLanguagesIfChanged();
          }).finally(() => {
            _(this, Te, void 0);
          }));
          break;
        case "subscription changed":
          try {
            Co(S.subscription);
          } catch (x) {
            this.emitter.emit(
              "error",
              new b("Subscription failed validation", {
                source: x instanceof Error ? x : void 0,
                isFatal: !1,
                code: "subscription_failed_validation"
              })
            );
          }
          this.emitter.emit("subscription changed", {
            to: S.subscription,
            from: this.modules.subscription.getCurrentSubscription()
          }), this.modules.sync.timeshiftOnAudio = !((P = S.subscription.video) != null && P.codec), this.modules.adaptivity.reset();
          break;
        case "timing info":
          this.modules.sync.updateChannelSyncInfo(S.timingInfo.channelId, S.timingInfo), this.emit("server wallclock time", S.timingInfo.wallclockTime);
          break;
      }
    }), this.emitter.on("received data", (A) => {
      const S = this.modules.subscription.getCurrentSubscription(), P = kr(A);
      if (!S) {
        this.logger.warn("Received unwanted message", g({}, P));
        return;
      }
      it(L(g({}, P), { channelId: S.channelId }));
    });
    const Qe = this.options.get("container");
    Qe && this.attach(Qe), this.logger.info("Created Vindral instance", { options: this.options });
    const it = (A) => I(this, null, function* () {
      const S = A.channelId;
      u(this, Te) && (yield u(this, Te));
      const P = this.modules.renditions.getRendition(A.renditionId, S);
      if (!Ir(A.flags)) {
        if (Br(A.flags)) {
          const O = new TextDecoder().decode(A.payload), U = this.modules.sync.getTimeshiftOffset();
          if (A.renditionId !== 0) {
            const Q = bs(O);
            if (Q && Q.language !== void 0) {
              const j = new Mr().parse(Q.content || ""), oe = U / 1e3, K = u(this, Z).find((z) => z.language === Q.language), de = oe - u(this, Ke);
              if (_(this, Ke, oe), K) {
                if (K.cues)
                  for (const z of K.cues)
                    z.startTime -= de, z.endTime -= de;
                for (const z of j) {
                  const ee = new VTTCue(z.startTime - oe, z.endTime - oe, z.text);
                  K.addCue(ee);
                }
              }
            }
          } else
            this.modules.event.addEvent({
              timestamp: A.timestamp / A.timescale * 1e3 - this.modules.sync.getTimeshiftOffset(),
              content: O,
              type: "metadata"
            });
        } else if (P != null && P.codec) {
          const x = Fs(P.codec);
          if (x === "text")
            throw new Error("Subtitles are not supported");
          if (this.modules.incomingData.add(x, A.payload.byteLength), Cr(A.flags)) {
            const O = L(g({
              type: x,
              data: A.payload,
              codec: P.codec
            }, A), {
              channelId: S
            }), U = Sr(O.codec, O.payload);
            U && this.sizes.set(O.renditionId, U);
            const Q = Me({ codec: P.codec, codecString: P.codecString });
            this.emitter.emit("init segment", { initSegment: O, mimeType: Q }), this.emit("initialized media");
          } else {
            const O = bo(A, P, this.sizes.get(A.renditionId));
            let U = this.sampleProcessingSesssions.get(x);
            if (!U)
              U = So(
                this.modules.sync.processSample(O)
              ), this.sampleProcessingSesssions.set(x, U);
            else {
              const Q = U(
                this.modules.sync.processSample(O),
                this.isSwitchingRenditionLevel && O.type === "video"
              );
              let re = O;
              Q.forEach((j) => {
                this.modules.event.extractEvent(j, re), this.emitter.emit("coded sample", j), re = j;
              });
            }
          }
        }
      }
    });
    this.options.get("maxVideoBitRate") !== Number.MAX_SAFE_INTEGER && (this.maxVideoBitRate = this.options.get("maxVideoBitRate")), this.options.get("maxAudioBitRate") !== Number.MAX_SAFE_INTEGER && (this.maxAudioBitRate = this.options.get("maxAudioBitRate")), Be(this.options.get("maxSize"), rt()) || (this.maxSize = this.options.get("maxSize")), this.options.get("burstEnabled") && h.enableBurst(this.targetBufferTime);
  }
  // TODO: volym blir nog fuckad när vi startar och mutear - måste testa om volume ändras när muted ändras
  /**
   * Set the current volume.
   * Setting this to 0 is not equivalent to muting the audio.
   * Setting this to >0 is not equivalent to unmuting the audio.
   *
   * Note that setting volume is not allowed on iPadOS and iOS devices.
   * This is an OS/browser limitation on the video element.
   *
   * [Read more about it on Apple docs](https://developer.apple.com/library/archive/documentation/AudioVideo/Conceptual/Using_HTML5_Audio_Video/Device-SpecificConsiderations/Device-SpecificConsiderations.html)
   * for iOS-Specific Considerations. The following section is the important part:
   * On iOS devices, the audio level is always under the user's physical control. The volume property is not settable in JavaScript. Reading the volume property always returns 1.
   */
  set volume(t) {
    this.playbackSource.volume = t;
  }
  /**
   * The current volume. Note that if the playback is muted volume can still be set.
   */
  get volume() {
    return this.playbackSource.volume;
  }
  /**
   * Set playback to muted/unmuted
   */
  set muted(t) {
    if (t === this.muted)
      return;
    const n = this.playbackSource.muted;
    this.playbackSource.muted = t, !t && n && !this.playbackSource.isPaused && this.playbackSource.play();
  }
  /**
   * Whether the playback is muted or not
   */
  get muted() {
    return this.playbackSource.muted;
  }
  /**
   * Media (audio | video | audio+video)
   */
  get media() {
    return this.options.get("media");
  }
  /**
   * The current average video bit rate in bits/s
   */
  get videoBitRate() {
    return this.modules.incomingData.averageBitRate("video");
  }
  /**
   * The current average audio bit rate in bits/s
   */
  get audioBitRate() {
    return this.modules.incomingData.averageBitRate("audio");
  }
  /**
   * The current connection state
   */
  get connectionState() {
    return this.modules.connection.getState();
  }
  /**
   * The current playback state
   */
  get playbackState() {
    return this.modules.playback.getState();
  }
  /**
   * The current buffer fullness as a floating point value between 0-1, where 1 is full and 0 i empty.
   */
  get bufferFullness() {
    return this.modules.playback.getBufferFullness();
  }
  /**
   * Whether user bandwidth savings by capping the video resolution to the size of the video element is enabled
   */
  get sizeBasedResolutionCapEnabled() {
    return this.modules.constraintCap.sizeBasedResolutionCapEnabled;
  }
  /**
   * Enables or disables user bandwidth savings by capping the video resolution to the size of the video element.
   */
  set sizeBasedResolutionCapEnabled(t) {
    this.modules.constraintCap.sizeBasedResolutionCapEnabled = t;
  }
  /**
   * Whether ABR is currently enabled
   */
  get abrEnabled() {
    return this.modules.adaptivity.isEnabled;
  }
  /**
   * Enable or disable ABR
   *
   * The client will immediatly stop changing renditon level based on QoS metrics
   *
   * Note: It is strongly recommended to keep this enabled as it can severly increase
   * the number of buffering events for viewers.
   */
  set abrEnabled(t) {
    this.modules.constraintCap.sizeBasedResolutionCapEnabled = t ? this.options.get("sizeBasedResolutionCapEnabled") : !1, this.modules.adaptivity.isEnabled = t, this.alignSizeAndBitRate(this.targetSubscription);
  }
  /**
   * Estimated live edge time for the current channel
   */
  get serverEdgeTime() {
    return this.modules.sync.getLiveEdgeTimeLatencyAdjusted(this.currentSubscription.channelId);
  }
  /**
   * @returns Estimated wallclock time on the edge server in milliseconds
   */
  get serverWallclockTime() {
    return this.modules.sync.getWallclockTimeLatencyAdjusted(this.currentSubscription.channelId);
  }
  /**
   * Local current time normalized between all channels in the channel group
   */
  get currentTime() {
    return this.modules.sync.serverCurrentTime;
  }
  /**
   * Current time for the channel. This is the actual stream time, passed on from your ingress.
   * Integer overflow could make this value differ from your encoder timestamps if it has been rolling for more
   * than 42 days with RTMP as target.
   *
   * Note: This is not normalized between channels, thus it can make jumps when switching channels
   */
  get channelCurrentTime() {
    return this.modules.sync.channelCurrentTime;
  }
  /**
   * The current target buffer time in milliseconds
   */
  get targetBufferTime() {
    return this.modules.playback.getTargetBufferTime();
  }
  /**
   * Set the current target buffer time in milliseconds
   */
  set targetBufferTime(t) {
    this.modules.playback.getTargetBufferTime() !== t && (this.modules.playback.setTargetBufferTime(t), this.playbackSource.currentTime = this.modules.sync.serverCurrentTime, this.options.get("burstEnabled", this.channelId) ? this.modules.subscription.enableBurst(this.targetBufferTime) : this.modules.subscription.enableBurst(0));
  }
  /**
   * The estimated playback latency based on target buffer time, the connection rtt and local playback drift
   */
  get playbackLatency() {
    var t;
    if (this.playbackSource.currentTime !== 0)
      return this.targetBufferTime + ((t = this.modules.sync.drift) != null ? t : 0) + this.modules.connection.rtt / 2;
  }
  /**
   * The estimated utc timestamp (in ms) for the playhead.
   */
  get playbackWallclockTime() {
    if (!(!this.serverWallclockTime || !this.playbackLatency))
      return this.serverWallclockTime - this.playbackLatency;
  }
  /**
   * Channels that can be switched between
   */
  get channels() {
    return this._channels;
  }
  /**
   * Languages available
   */
  get languages() {
    return this.modules.renditions.getLanguages();
  }
  /**
   * The current language
   */
  get language() {
    return this.modules.subscription.getTargetSubscription().audio.language;
  }
  /**
   * Set the current language
   */
  set language(t) {
    this.modules.subscription.setLanguage(t);
  }
  /**
   * Set the active text track
   */
  set textTrack(t) {
    u(this, Z).forEach((n) => {
      n.label === t ? n.mode = "showing" : n.mode = "hidden";
    });
  }
  /**
   * Get the available text tracks
   */
  get textTracks() {
    return u(this, Z).filter((t) => t.mode !== "disabled").map((t) => t.label);
  }
  /**
   * Get the active text track
   */
  get textTrack() {
    var t;
    return (t = u(this, Z).find((n) => n.mode === "showing")) == null ? void 0 : t.label;
  }
  /**
   * The current channelId
   */
  get channelId() {
    return this.modules.subscription.getTargetSubscription().channelId;
  }
  /**
   * Set the current channelId
   *
   * Possible channels to set are available from [[channels]]
   *
   * Note that the following scenarios are not possible right now:
   * - switching channel from a channel with audio to a channel without audio (unless audio only mode is active)
   * - switching channel from a channel with video to a channel without video (unless video only mode is active)
   */
  set channelId(t) {
    if (t === this.channelId)
      return;
    this.modules.subscription.setChannelId(t);
    const n = this.options.get("media") === "audio" ? [] : this.options.get("videoCodecs"), r = this.modules.renditions.getAudioRenditions(t), o = this.modules.renditions.getVideoRenditions(t), a = this.targetSubscription.audio.language, c = r == null ? void 0 : r.some(
      (h) => h.language === a
    ), d = n.find((h) => (o == null ? void 0 : o.find((l) => l.codec === h)) !== void 0);
    d && this.modules.subscription.setVideoCodec(d), this.logger.debug("Channel switch - started", {
      audioRenditions: r,
      targetSubscriptionLanguage: a,
      targetHasCurrentLanguage: c
    }), this.alignSizeAndBitRate(this.targetSubscription);
  }
  /**
   * Max size that will be subcribed to
   */
  get maxSize() {
    var r, o;
    const { width: t, height: n } = (o = (r = this.modules.constraintCap.getCurrentConstraintCap()) == null ? void 0 : r.video) != null ? o : rt();
    return { width: t, height: n };
  }
  /**
   * Set max size that will be subscribed to
   *
   * Note: If ABR is disabled, setting this will make the client instantly subscribe to this size
   */
  set maxSize(t) {
    this.modules.constraintCap.setUserSpecifiedCap({ video: { width: t.width, height: t.height } }), this.alignSizeAndBitRate(this.targetSubscription);
  }
  /**
   * The max video bit rate that will be subscribed to
   *
   * Note: Returns Number.MAX_SAFE_INTEGER if no limits have been set
   */
  get maxVideoBitRate() {
    var t, n;
    return (n = (t = this.modules.constraintCap.getCurrentConstraintCap()) == null ? void 0 : t.video.bitRate) != null ? n : ge();
  }
  /**
   * Set max video bit rate that will be subscribed to
   *
   * Note: If ABR is disabled, setting this will make the client instantly subscribe to this bitrate
   */
  set maxVideoBitRate(t) {
    this.modules.constraintCap.setUserSpecifiedCap({ video: { bitRate: t } }), this.alignSizeAndBitRate(this.targetSubscription);
  }
  /**
   * The max audio bit rate that will be subscribed to
   *
   * Note: Returns Number.MAX_SAFE_INTEGER if no limits have been set
   */
  get maxAudioBitRate() {
    var t, n;
    return (n = (t = this.modules.constraintCap.getCurrentConstraintCap()) == null ? void 0 : t.audio.bitRate) != null ? n : ge();
  }
  /**
   * Set max audio bit rate that will be subscribed to
   *
   * Note: If ABR is disabled, setting this will make the client instantly subscribe to this bit rate
   */
  set maxAudioBitRate(t) {
    this.modules.constraintCap.setUserSpecifiedCap({ audio: { bitRate: t } }), this.alignSizeAndBitRate(this.targetSubscription);
  }
  /**
   * The rendition levels available.
   */
  get renditionLevels() {
    return this.modules.renditions.getRenditionLevels();
  }
  /**
   * The current rendition level
   */
  get currentRenditionLevel() {
    return this.modules.renditions.getRenditionLevel();
  }
  /**
   * The target rendition level that the client is currently switching to
   */
  get targetRenditionLevel() {
    return this.modules.renditions.getRenditionLevel(this.modules.subscription.getTargetSubscription());
  }
  /**
   * True if the client is currently switching from one rendition level to another
   */
  get isSwitchingRenditionLevel() {
    return this.modules.subscription.isSwitchingSubscription();
  }
  /**
   * The time ranges buffered for video.
   * The ranges are specified in milliseconds.
   */
  get videoBufferedRanges() {
    var t, n, r, o;
    return (o = (r = (t = this.modules.mseModule) == null ? void 0 : t.getBuffer("video")) != null ? r : (n = this.modules.decoder) == null ? void 0 : n.getBuffer("video")) != null ? o : [];
  }
  /**
   * The time ranges buffered for audio.
   * The ranges are specified in milliseconds.
   */
  get audioBufferedRanges() {
    var t, n, r, o;
    return (o = (r = (t = this.modules.mseModule) == null ? void 0 : t.getBuffer("audio")) != null ? r : (n = this.modules.decoder) == null ? void 0 : n.getBuffer("audio")) != null ? o : [];
  }
  /**
   * The API client for calls to the public available endpoints of the Vindral Live CDN.
   */
  getApiClient() {
    return this.apiClient;
  }
  // Begin Undocumented getters/setters
  get lastBufferEvent() {
    return this.modules.playback.getLastBufferStateEvent();
  }
  get activeRatios() {
    return this.modules.qualityOfService.activeRatios();
  }
  get bufferingRatios() {
    return this.modules.qualityOfService.bufferingRatios();
  }
  get timeSpentBuffering() {
    return this.modules.qualityOfService.timeSpentBuffering();
  }
  get timeActive() {
    return this.modules.qualityOfService.timeActive();
  }
  get mediaElement() {
    return this.element;
  }
  /**
   * How long in milliseconds since the instance was created
   */
  get uptime() {
    return Date.now() - this.createdAt;
  }
  suspend() {
    this.isSuspended || (Object.values(this.modules).forEach((t) => {
      t && "suspend" in t && t.suspend();
    }), this.isSuspended = !0);
  }
  unsuspend() {
    this.isSuspended && (Object.values(this.modules).forEach((t) => {
      t && "unsuspend" in t && t.unsuspend();
    }), this.isSuspended = !1);
  }
  /**
   * Aligns size and bitrate to match a rendition level correctly
   */
  alignSizeAndBitRate(t) {
    const n = this.modules.constraintCap.constrainSubscription(L(g({}, t), {
      video: g({}, t.video),
      audio: g({}, t.audio)
    })), r = this.modules.constraintCap.getUserSpecifiedCap();
    !this.abrEnabled && r && (n.audio.bitRate = r.audio.bitRate, n.video.bitRate = r.video.bitRate, n.video.width = r.video.width, n.video.height = r.video.height);
    const o = this.modules.renditions.getRenditionLevel(n);
    if (o) {
      if (o.video && (this.modules.subscription.setVideoBitRate(o.video.bitRate), this.modules.subscription.setSize(o.video)), o.audio)
        this.modules.subscription.setAudioBitRate(o.audio.bitRate), this.modules.subscription.setLanguage(o.audio.language);
      else if (n.audio.language) {
        let a = this.modules.renditions.getAudioRenditions(n.channelId);
        !this.abrEnabled && r && (a = a == null ? void 0 : a.filter((m) => m.bitRate < r.audio.bitRate));
        const c = n.audio.language, d = a == null ? void 0 : a.some((m) => m.language === c), h = a == null ? void 0 : a.find((m) => m.language), l = (a == null ? void 0 : a.length) && a[0] || void 0;
        d || (h ? (this.logger.debug("Randomizing language since target did not have current language"), this.modules.subscription.setAudioBitRate(h.bitRate), this.modules.subscription.setLanguage(h.language)) : (this.logger.debug("Randomizing audio rendition since target did not have current language"), l != null && l.bitRate && this.modules.subscription.setAudioBitRate(l.bitRate), this.modules.subscription.setLanguage(l == null ? void 0 : l.language)));
      }
    }
  }
  get currentSubscription() {
    return this.modules.subscription.getCurrentSubscription();
  }
  get targetSubscription() {
    return this.modules.subscription.getTargetSubscription();
  }
  willUseMediaSource() {
    return this.browser.supportsMediaSource && this.options.get("mseEnabled");
  }
};
Ke = new WeakMap(), Z = new WeakMap(), Te = new WeakMap(), s(G, "MAX_POOL_SIZE", 10), s(G, "INITIAL_MAX_BIT_RATE", 2.5 * 1e3 * 1e3), s(G, "PING_TIMEOUT", 1e3), s(G, "DISCONNECT_TIMEOUT", 15 * 1e3), s(G, "REMOVE_CUE_THRESHOLD", 1e3 * 10);
let Xi = G;
export {
  zs as A,
  Hs as C,
  qs as D,
  X as F,
  Xs as I,
  Ht as L,
  Gs as N,
  Xi as V,
  Ds as a,
  Qs as b,
  Vs as c,
  sn as d,
  Ns as e,
  b as f,
  ko as i,
  ce as n
};
